webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Action_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2c58c36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Action_vue__ = __webpack_require__(265);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Action_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2c58c36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Action_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoice_vue__ = __webpack_require__(45);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c42fd21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__ = __webpack_require__(278);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Invoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c42fd21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Invoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddInvoice_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_748bff9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddInvoice_vue__ = __webpack_require__(276);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_748bff9e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//


var _layout = 'default';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    layout: function layout() {
      return (this.$route.meta.layout || _layout) + '-layout';
    }
  },
  created: function created() {
    // nothing defined here (when this.$route.path is other than "/")
    console.log(this.$route, this.$route.meta.layout);
  },
  updated: function updated() {
    // something defined here whatever the this.$route.path
    console.log(this.$route, this.$route.meta.layout);
  },
  mounted: function mounted() {
    // console.log(localStorage.getItem('uid'))
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getaccountSetting').then(function (response) {
      localStorage.setItem('account_image', response.data.results[0].ghost_logo);
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getprofileImage' + '?' + 'uid' + '=' + localStorage.getItem('uid')).then(function (response) {
      // console.log(response)
      localStorage.setItem('profile_img', response.data.results[0].profile_image);
    });
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errors: [],
      errorMessage: '',
      input: {
        email: '',
        password: '',
        rememberme: ''
      }
    };
  },

  methods: {
    login: function login(e) {
      var _this = this;

      this.errors = [];
      var x = this.input.email;
      var atposition = x.indexOf('@');
      var dotposition = x.lastIndexOf('.');
      if (this.input.email === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= x.length) {
        this.errors.push('Please enter a valid e-mail address ');
        this.$refs.email.focus();
      } else if (this.input.password === '') {
        this.errors.push('Password is Required');
        this.$refs.password.focus();
      } else {
        var email = this.input.email;
        var password = this.input.password;
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/login', {
          email: email,
          password: password
        }).then(function (response) {
          _this.isLoading = false;
          _this.errorMessage = response.data.message;
          var role = response.data.results[0].role;
          var username = response.data.results[0].name;
          var useremail = response.data.results[0].email;
          localStorage.setItem('profileimage', response.data.results[0].profile_image);
          localStorage.setItem('uid', response.data.results[0].uid);
          localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.results[0]));
          localStorage.setItem('jwt', response.data.results[0].token);
          if (localStorage.getItem('jwt') !== 'undefined' || localStorage.getItem('jwt') !== null) {
            if (role === 'admin') {
              // this.$router.push('/admindashboard')
              window.location = '/admindashboard';
              localStorage.setItem('role', 'admin');
              localStorage.setItem('username', username);
              localStorage.setItem('useremail', useremail);
            } else {
              window.location = '/userdashboard';
              localStorage.setItem('role', 'user');
              localStorage.setItem('username', username);
              localStorage.setItem('useremail', useremail);
            }
          }
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    rememberme: function rememberme(e) {
      var checkBox = document.getElementById('rememberme');
      if (checkBox.checked === true) {
        localStorage.usrname = document.getElementById('exampleInputEmail').value;
        console.log(localStorage.usrname);
        localStorage.pass = document.getElementById('exampleInputPassword1').value;
        localStorage.chkbx = document.getElementById('rememberme').value;
      } else {
        localStorage.usrname = '';
        localStorage.pass = '';
        localStorage.chkbx = '';
      }
    }
  },
  mounted: function mounted() {
    console.log(document.getElementById('exampleInputEmail').value);
    if (localStorage.chkbx && localStorage.chkbx !== '') {
      document.getElementById('rememberme').checked = true;
      document.getElementById('exampleInputEmail').value = localStorage.usrname;
      document.getElementById('exampleInputPassword1').value = localStorage.pass;
    } else {
      document.getElementById('rememberme').checked = false;
      document.getElementById('exampleInputEmail').value = '';
      document.getElementById('exampleInputPassword1').value = '';
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfilePage',
  data: function data() {
    return {
      msg: 'Dashboard'
    };
  },

  methods: {
    logout: function logout() {
      localStorage.removeItem('jwt');
      localStorage.removeItem('user');
      this.$router.push('login');
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserProfile',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      errorMessageUserForm: '',
      errors: [],
      stripe_bank_account_id: '',
      errorsPassword: [],
      msg: 'Dashboard',
      userDetails: {
        username: '',
        firstname: '',
        lastname: '',
        email: ''
      },
      currentpass: '',
      newpass: '',
      confpass: ''
    };
  },

  methods: {
    changepassword: function changepassword() {
      var _this = this;

      this.errorsPassword = [];
      var jwttoken = localStorage.getItem('jwt');
      var userid = localStorage.getItem('uid');
      var currentpassword = this.currentpass;
      var password = this.newpass;
      var confirmpassword = this.confpass;
      if (currentpassword === '') {
        this.errorsPassword.push('Current password is Required');
        this.$refs.currentpass.focus();
      } else if (password === '') {
        this.errorsPassword.push('New Password is Required');
        this.$refs.newpass.focus();
      } else if (password.length < 6) {
        this.errorsPassword.push('New Password must be 6 characters long');
        this.$refs.newpass.focus();
      } else if (confirmpassword === '') {
        this.errorsPassword.push('Confirm Password is Required');
        this.$refs.confpass.focus();
      } else if (password !== confirmpassword) {
        this.errorsPassword.push('Password & Confirm Password does not matched');
        this.$refs.confpass.focus();
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/changeUserPassword', {
          user_id: userid,
          current_password: currentpassword,
          password: password,
          confirm_password: confirmpassword
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this.isLoading = false;
          console.log(response);
          _this.flash('Password Changed Successfully', 'success', {
            timeout: 1000,
            beforeDestroy: function beforeDestroy() {
              location.reload();
            }
          });
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    save: function save() {
      var _this2 = this;

      this.errors = [];
      var jwttoken = localStorage.getItem('jwt');
      var userid = localStorage.getItem('uid');
      var firstname = this.userDetails.firstname;
      var lastname = this.userDetails.lastname;
      var email = this.userDetails.email;
      var username = this.userDetails.username;
      if (email === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (!this.emailValidator.validate(email)) {
        this.errors.push('Invalid contact Email');
        this.$refs.email.focus();
      } else if (username === '') {
        this.errors.push('Username is Required');
        this.$refs.username.focus();
      } else if (firstname === '') {
        this.errors.push('Name is Required');
        this.$refs.firstname.focus();
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/updateUserProfile', {
          user_id: userid,
          firstname: firstname,
          lastname: lastname,
          email: email,
          username: username
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this2.isLoading = false;
          _this2.flash('Admin Updated Successfully', 'success', { timeout: 3000 });
        }).catch(function (error) {
          this.isLoading = false;
          this.flash(error, 'error', { timeout: 3000 });
        });
      }
    },
    updateBankDetail: function updateBankDetail() {
      var _this3 = this;

      var uid = localStorage.getItem('uid');
      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/expressLogin/?uid=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        console.log(response);
        _this3.isLoading = false;
        _this3.responseUrl = response.data.results.url;
      }).catch(function (error) {
        console.log(error);
        _this3.isLoading = false;
      });
    },
    expressLogin: function expressLogin() {
      window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_GVYn1wmqiX7xBr65utC44cXRFRMirGLR&scope=read_write#/', '_self');
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    var userRecord = JSON.parse(localStorage.getItem('user'));
    this.stripe_bank_account_id = userRecord.stripe_bank_account_id;
    var uid = localStorage.getItem('uid');
    var jwttoken = localStorage.getItem('jwt');

    this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserProfile?uid=' + uid, {
      headers: {
        'x-access-token': jwttoken
      } }).then(function (response) {
      _this4.isLoading = false;
      _this4.userDetails = response.data.results[0];
      localStorage.setItem('username', _this4.userDetails.name);
    }).catch(function (error) {
      console.log(error);
      _this4.isLoading = false;
    });
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Subscription',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://checkout.stripe.com/checkout.js');
    recaptchaScript.setAttribute('class', 'stripe-button');
    recaptchaScript.setAttribute('data-key', 'pk_live_xse9yr0bV5ZUDzljrD0nAArN');
    recaptchaScript.setAttribute('data-image', '');
    recaptchaScript.setAttribute('data-name', 'Ghost Inc.');
    recaptchaScript.setAttribute('data-description', 'Monthly Subscription');
    recaptchaScript.setAttribute('data-amount', '19900');
    recaptchaScript.setAttribute('data-label', 'Pay');
    document.getElementById('subscribe').appendChild(recaptchaScript);
  },

  methods: {
    sendToken: function sendToken(e) {
      e.preventDefault();
      var formData = new FormData(document.getElementById('subscribe'));
      console.log(formData);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchData',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      errorMessage: '',
      fullPage: true,
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      BrandDatas: [],
      getAllUsers: [],
      getAllBrands: [],
      getAllInvoices: [],
      resultData: [],
      Invoices: [],
      role: localStorage.getItem('role')
    };
  },

  computed: {
    isAdmin: function isAdmin() {
      return this.role && this.role === 'admin';
    },
    isUser: function isUser() {
      return this.role && this.role === 'user';
    }
  },
  methods: {
    getSearchData: function getSearchData() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      var uid = localStorage.getItem('uid');
      console.log('uid');
      var search = this.$router.currentRoute.query.text;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/globalSearch', {
        text: search,
        userId: uid
      }, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        // console.log(response)
        _this.resultData = response.data.results;
        console.log(_this.resultData);
        _this.isLoading = false;
        // localStorage.setItem('searchData', JSON.stringify(this.resultData))
        // // console.log(this.$router.currentRoute.name)
        // this.$router.push('/searchData?text=nike')
      }).catch(function (error) {
        _this.errorMessage = error.response.data.errors;
        _this.isLoading = false;
      });
    },
    getInvoices: function getInvoices() {
      var _this2 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.Invoices = response.data.results;
        _this2.isLoading = false;
      }).catch(function (error) {
        _this2.errorMessage = error.response.data.errors;
        _this2.isLoading = false;
      });
    },
    getUsers: function getUsers() {
      var _this3 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this3.getAllUsers = response.data.results[0];
        _this3.isLoading = false;
        console.log(response);
      }).catch(function (error) {
        _this3.errorMessage = error.response.data.errors;
        _this3.isLoading = false;
      });
    },
    getbrands: function getbrands() {
      var _this4 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this4.getAllBrands = response.data.results[0];
        _this4.isLoading = false;
        console.log(response);
      }).catch(function (error) {
        _this4.errorMessage = error.response.data.errors;
        _this4.isLoading = false;
      });
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.getSearchData();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getInvoices();
    this.getUsers();
    this.getbrands();
    this.getSearchData();
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      errors: [],
      errorMessage: '',
      input: {
        email: '',
        name: '',
        username: '',
        password: '',
        cnfpassword: ''
      }
    };
  },

  methods: {
    signup: function signup() {
      var _this = this;

      this.errors = [];
      var pass = this.input.password;
      var nam = this.input.name;
      var uname = this.input.username;
      if (this.input.name === '') {
        this.errors.push('Name is Required');
        this.$refs.name.focus();
      } else if (nam.length < 3) {
        this.errors.push('Name must be 5 characters long');
        this.$refs.name.focus();
      } else if (this.input.username === '') {
        this.errors.push('Username is Required');
        this.$refs.username.focus();
      } else if (uname < 3) {
        this.errors.push('Username must be 5 characters long');
        this.$refs.username.focus();
      } else if (this.input.password === '') {
        this.errors.push('Password is Required');
        this.$refs.password.focus();
      } else if (pass.length < 6) {
        this.errors.push('Password must be 6 characters long');
        this.$refs.password.focus();
      } else if (this.input.cnfpassword === '') {
        this.errors.push('Confirm Password is Required');
        this.$refs.cnfpassword.focus();
      } else if (this.input.password !== this.input.cnfpassword) {
        this.errors.push('Password & Confirm Password does not matched');
        this.$refs.cnfpassword.focus();
      } else {
        var email = this.input.email;
        var username = this.input.username;
        var name = this.input.name;
        var password = this.input.password;
        var confirmpassword = this.input.cnfpassword;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/registration', {
          email: email,
          name: name,
          username: username,
          password: password,
          confirm_password: confirmpassword
        }).then(function (response) {
          return window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_GVYn1wmqiX7xBr65utC44cXRFRMirGLR&scope=read_write&requested_capabilities=["card_payments","transfers"]&requested=true#/', '_self');
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    checkboxClick: function checkboxClick() {
      var checkBox = document.getElementById('termsandcond');
      if (checkBox.checked === true) {
        document.getElementById('signup_btn').disabled = false;
      } else {
        document.getElementById('signup_btn').disabled = true;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    document.getElementById('signup_btn').disabled = true;
    var uid = this.$route.query.uid;
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserById/?uid=' + uid).then(function (response) {
      var email = response.data.results[0].email;
      localStorage.setItem('email', email);
      localStorage.setItem('uid', uid);
      self.input.email = email;
    }).catch(function (error) {
      _this2.errorMessage = error.response.data.errors;
      _this2.isLoading = false;
    });
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Subscription',
  data: function data() {
    return {};
  },
  updated: function updated() {

    localStorage.removeItem('jwt');
    var confirmCode = this.$route.query.code;
    console.log(confirmCode);
  },
  mounted: function mounted() {
    var _this = this;

    var jwttoken = localStorage.getItem('jwt');
    var confirmCode = this.$route.query.code;

    var uid = localStorage.getItem('uid');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/addBankAccount', {
      code: confirmCode,
      uid: uid
    }, {
      headers: {
        'x-access-token': jwttoken
      } }).then(function (response) {
      console.log(jwttoken);
      if (jwttoken !== '' && jwttoken !== null) {

        localStorage.setItem('jwt', jwttoken);
        _this.$router.push('userprofile');
      } else {

        localStorage.removeItem('jwt');
        _this.$router.push('login');
      }
    }).catch(function (error) {
      console.log(error);
      _this.isLoading = false;
    });
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Forgotpassword',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errors: [],
      errorMessage: '',
      input: {
        email: ''
      }
    };
  },

  methods: {
    sendemail: function sendemail(e) {
      var _this = this;

      this.errors = [];
      var jwttoken = localStorage.getItem('jwt');
      var x = this.input.email;
      var atposition = x.indexOf('@');
      var dotposition = x.lastIndexOf('.');
      if (this.input.email === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
        this.errorMessage = '';
      } else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= x.length) {
        this.errors.push('Please enter a valid e-mail address123 ');
        this.$refs.email.focus();
        this.errorMessage = '';
      } else {
        var email = this.input.email;
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/forgotPassword', {
          email: email
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this.errorMessage = response.data.message;
          _this.isLoading = false;
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftSidebar_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b31b22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftSidebar_vue__ = __webpack_require__(253);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b31b22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LeftSidebar',
  data: function data() {
    return {
      role: localStorage.getItem('role')
    };
  },

  computed: {
    isAdmin: function isAdmin() {
      return this.role && this.role === 'admin';
    },
    isUser: function isUser() {
      return this.role && this.role === 'user';
    }
  },
  methods: {},
  mounted: function mounted() {
    var ul = document.getElementById('accordion-menu');
    ul.onclick = function (event) {
      var body = document.body;
      body.classList.remove('background--blur');
      body.classList.remove('sidebar-show');
      document.getElementById('navigation-toggle1').style.display = 'block';
      document.getElementById('navigation-toggle2').style.display = 'none';
    };
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Resetpassword',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errors: [],
      errorMessage: '',
      input: {
        password: '',
        cnfpassword: ''
      }
    };
  },

  methods: {
    reset: function reset(e) {
      var _this = this;

      this.errors = [];
      var pass = this.input.password;
      var jwttoken = localStorage.getItem('jwt');
      if (this.input.password === '') {
        this.errors.push('Password is Required');
        this.$refs.password.focus();
      } else if (pass.length < 6) {
        this.errors.push('Password must be 6 characters long');
        this.$refs.password.focus();
      } else if (this.input.cnfpassword === '') {
        this.errors.push('Confirm Password is Required');
        this.$refs.cnfpassword.focus();
      } else if (this.input.password !== this.input.cnfpassword) {
        this.errors.push('Password & Confirm Password does not matched');
        this.$refs.cnfpassword.focus();
      } else {
        var password = this.input.password;
        var cnfpassword = this.input.cnfpassword;
        var token = this.$route.query.token;
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/resetPassword', {
          password: password,
          confirm_password: cnfpassword,
          token: token
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this.errorMessage = response.data.message;
          _this.input.password = '';
          _this.input.cnfpassword = '';
          _this.isLoading = false;
          window.open('/login');
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.input.password = '';
          _this.input.cnfpassword = '';
          _this.isLoading = false;
        });
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserProfile',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      msg: 'Dashboard',
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      errorMessageUserForm: '',
      errors: [],
      errorsPassword: [],
      userDetails: {
        username: '',
        firstname: '',
        lastname: '',
        email: ''
      },
      currentpass: '',
      newpass: '',
      confpass: ''
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      this.errors = [];
      var jwttoken = localStorage.getItem('jwt');
      var userid = localStorage.getItem('uid');
      var firstname = this.userDetails.firstname;
      var lastname = this.userDetails.lastname;
      var email = this.userDetails.email;
      var username = this.userDetails.username;
      if (email === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (!this.emailValidator.validate(email)) {
        this.errors.push('Invalid contact Email');
        this.$refs.email.focus();
      } else if (username === '') {
        this.errors.push('Username is Required');
        this.$refs.username.focus();
      } else if (firstname === '') {
        this.errors.push('FirstName is Required');
        this.$refs.firstname.focus();
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/updateUserProfile', {
          user_id: userid,
          firstname: firstname,
          lastname: lastname,
          email: email,
          username: username
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this.isLoading = false;
          console.log(response);
          _this.flash('User Profile Updated Successfully', 'success', {
            timeout: 1000,
            beforeDestroy: function beforeDestroy() {
              location.reload();
            }
          });
        }).catch(function (error) {
          _this.errorMessageUserForm = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    cancelSubscription: function cancelSubscription() {
      var _this2 = this;

      if (confirm('Do you really want to cancel Subscription?')) {
        this.isLoading = true;
        var userid = localStorage.getItem('uid');
        var jwttoken = localStorage.getItem('jwt');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/cancelSubscription', {
          user_id: userid
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          localStorage.removeItem('jwt');
          localStorage.removeItem('uid');
          localStorage.removeItem('userid');
          _this2.isLoading = false;
          _this2.$router.push('login');
        }).catch(function (error) {
          _this2.errorMessageUserForm = error.response.data.errors;
          _this2.isLoading = false;
        });
      }
    },
    createConnectAccount: function createConnectAccount() {
      window.location.href = 'https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_GVYn1wmqiX7xBr65utC44cXRFRMirGLR&scope=read_write&requested_capabilities=["card_payments","transfers"]&requested=true#/';
    },
    changepassword: function changepassword() {
      var _this3 = this;

      this.errorsPassword = [];
      var jwttoken = localStorage.getItem('jwt');
      var userid = localStorage.getItem('uid');
      var currentpassword = this.currentpass;
      var password = this.newpass;
      var confirmpassword = this.confpass;
      if (currentpassword === '') {
        this.errorsPassword.push('Current password is Required');
        this.$refs.currentpass.focus();
      } else if (password === '') {
        this.errorsPassword.push('New Password is Required');
        this.$refs.newpass.focus();
      } else if (password.length < 6) {
        this.errorsPassword.push('New Password must be 6 characters long');
        this.$refs.newpass.focus();
      } else if (confirmpassword === '') {
        this.errorsPassword.push('Confirm Password is Required');
        this.$refs.confpass.focus();
      } else if (password !== confirmpassword) {
        this.errorsPassword.push('Password & Confirm Password does not matched');
        this.$refs.confpass.focus();
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/changeUserPassword', {
          user_id: userid,
          current_password: currentpassword,
          password: password,
          confirm_password: confirmpassword
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this3.isLoading = false;
          console.log(response);
          _this3.flash('Password Changed Successfully', 'success', {
            timeout: 1000,
            beforeDestroy: function beforeDestroy() {
              location.reload();
            }
          });
        }).catch(function (error) {
          _this3.errorMessage = error.response.data.errors;
          _this3.isLoading = false;
        });
      }
    },
    updateBankDetail: function updateBankDetail() {
      var _this4 = this;

      var uid = localStorage.getItem('uid');
      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/expressLogin/?uid=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        console.log(response);
        _this4.isLoading = false;
        _this4.responseUrl = response.data.results.url;
        window.location = _this4.responseUrl;
      }).catch(function (error) {
        console.log(error);
        _this4.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    var uid = localStorage.getItem('uid');
    var jwttoken = localStorage.getItem('jwt');
    this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserProfile/?uid=' + uid, {
      headers: {
        'x-access-token': jwttoken
      } }).then(function (response) {
      _this5.isLoading = false;
      _this5.userDetails = response.data.results[0];
      localStorage.setItem('username', _this5.userDetails.name);
    }).catch(function (error) {
      console.log(error);
      _this5.isLoading = false;
    });
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'account-setting',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      errors: [],
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      input: {
        email: localStorage.getItem('useremail'),
        ghost_name: localStorage.getItem('username')
      },
      file: '',
      ghostlogo: localStorage.getItem('account_image'),
      siteLogo: '',
      ghostName: '',
      ghostEmail: ''

    };
  },

  methods: {
    update: function update() {
      var _this = this;

      this.errors = [];
      var fuData = document.getElementById('fileaddacct');
      var FileUploadPath = fuData.value;
      var ext = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
      var jwttoken = localStorage.getItem('jwt');
      if (FileUploadPath === '') {
        this.errors.push('File is Required');
      } else if (!this.checkExtension(ext)) {
        this.errors.push('Only jpeg , png , gif Allowed');
      } else if (this.ghostName === '') {
        this.errors.push('Ghost Name is Required');
        this.$refs.ghost_name.focus();
      } else if (this.ghostName.length < 3) {
        this.errors.push('Ghost Name must be 3 characters long');
        this.$refs.ghost_name.focus();
      } else if (this.ghostEmail === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (!this.emailValidator.validate(this.ghostEmail)) {
        this.errors.push('Invalid Ghost Email');
        this.$refs.email.focus();
      } else {
        var formData = new FormData();
        formData.append('email', this.ghostEmail);
        formData.append('ghost_name', this.ghostName);
        formData.append('file', this.fileaddacct);
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/accountSetting', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': jwttoken
          }
        }).then(function (response) {
          // console.log(response)
          localStorage.setItem('ghost_logo', response.data.results[0].ghost_logo);
          _this.isLoading = false;
          // console.log(response)
          _this.flash('Account Setting Updated Successfully', 'success', {
            timeout: 1000,
            beforeDestroy: function beforeDestroy() {
              location.reload();
            }
          });
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    handleFileUpload: function handleFileUpload() {
      this.fileaddacct = this.$refs.fileaddacct.files[0];
    },
    showLogo: function showLogo() {
      var _this2 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getaccountSetting', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.isLoading = false;
        _this2.siteLogo = response.data.results[0].ghost_logo;
        _this2.ghostName = response.data.results[0].ghost_name;
        _this2.ghostEmail = response.data.results[0].email;
      }).catch(function (error) {
        _this2.errorMessage = error.response.data.errors;
        _this2.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.showLogo();
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditUserModal_vue__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__User_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'action',
  props: ['row', 'data'],
  components: { User: __WEBPACK_IMPORTED_MODULE_2__User_vue__["default"],
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      users: [],
      errors: [],
      password: '',
      cnfpassword: '',
      userDetails: {
        name: '',
        username: '',
        email: '',
        uid: ''
      },
      errormessage: ''
    };
  },

  methods: {
    deleteUser: function deleteUser() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      console.log(this.row.uid);
      var uid = this.row.uid;
      var subsId = this.row.stripe_subscription_id;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deactivateUser' + '?' + 'user_id' + '=' + uid + '&' + 'stripe_subscription_id' + '=' + subsId, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.$eventBus.$emit('listUser', 'User is deleted successfully');
      }).catch(function (error) {
        this.isLoading = false;
        this.$eventBus.$emit('listUser', '', 'User could not be deleted');
      });
    },
    userDetail: function userDetail() {
      var location = '/userDetail' + '/' + this.row.uid + '/' + 'userlistpage';
      this.$router.push(location);
    },
    editUser: function editUser() {
      var _this2 = this;

      var jwttoken = localStorage.getItem('jwt');
      var uid = this.row.uid;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserById' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.isLoading = false;
        _this2.$modal.show(__WEBPACK_IMPORTED_MODULE_1__EditUserModal_vue__["a" /* default */], { userDetails: response.data.results[0] }, { height: '100%' });
      }).catch(function (error) {
        console.log(error);
        _this2.isLoading = false;
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditUserModal',
  props: ['userDetails'],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      users: [],
      errors: [],
      password: '',
      cnfpassword: '',
      input: {
        email: '',
        firstname: '',
        lastname: '',
        username: '',
        userrole: '',
        password: '',
        cnfpassword: ''
      },
      errormessage: ''
    };
  },

  methods: {
    editUser: function editUser() {
      var _this = this;

      this.errors = [];
      var jwttoken = localStorage.getItem('jwt');
      var firstname = this.userDetails.firstname;
      var lastname = this.userDetails.lastname;
      var email = this.userDetails.email;
      var username = this.userDetails.username;
      var password = this.password;
      var cnfpassword = this.cnfpassword;
      var uid = this.userDetails.uid;
      if (firstname === '') {
        this.errors.push('Name is Required');
        this.$refs.firstname.focus();
      } else if (firstname.length < 3) {
        this.errors.push('Name must be 3 characters long');
        this.$refs.firstname.focus();
      } else if (username === '') {
        this.errors.push('Username is Required');
        this.$refs.username.focus();
      } else if (username < 3) {
        this.errors.push('Username must be 3 characters long');
        this.$refs.username.focus();
      } else if (email === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (!this.emailValidator.validate(email)) {
        this.errors.push('Invalid contact Email');
        this.$refs.email.focus();
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/editUser', {
          firstname: firstname,
          lastname: lastname,
          email: email,
          username: username,
          password: password,
          confirm_password: cnfpassword,
          user_id: uid
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this.isLoading = false;
          _this.$eventBus.$emit('listUser', 'User is Updated successfully');
          _this.$emit('close');
        }).catch(function (error) {
          _this.$eventBus.$emit('listUser', '', 'User could not be Updated');
          _this.$emit('close');
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(40);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e7701d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(264);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e7701d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddUser__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Action__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'User',
  props: ['rows'],
  components: { AddUser: __WEBPACK_IMPORTED_MODULE_1__AddUser__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      tblCls: 'table',
      users: [],
      usersList: [],
      errors: [],
      i: 1,
      input: {
        email: '',
        name: '',
        username: '',
        userrole: '',
        password: '',
        cnfpassword: ''
      },
      columns: [{ label: 'Stripe CustomerID', field: 'id' }, { label: 'Name', field: 'name', headerClass: 'class-in-header second-class' }, { label: 'User Name', field: 'username' }, { label: 'Email', field: 'email' }, { label: 'Role', field: 'role' }, { label: 'User Type', field: 'usertype' }, { label: 'Status', field: 'status' }, { label: 'Action',
        component: __WEBPACK_IMPORTED_MODULE_2__Action__["a" /* default */],
        sortable: false
      }],
      rows: this.usersList,
      filter: '',
      page: 1
    };
  },

  methods: {
    adUser: function adUser() {
      this.$modal.show(__WEBPACK_IMPORTED_MODULE_1__AddUser__["a" /* default */], { height: '100%' });
    },
    getAlluser: function getAlluser() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      this.usersList = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.users = response.data.results;
        for (var i in _this.users) {
          var obj = _this.users[i];
          var name = '';
          if (obj.firstname && !obj.lastname) {
            name = obj.firstname;
          } else if (obj.firstname && obj.lastname) {
            name = obj.firstname + " " + obj.lastname;
          } else if (obj.name) {
            name = obj.name;
          }

          _this.usersList.push({
            id: obj.stripe_customer_id,
            name: name,
            uid: obj.uid,
            username: obj.username,
            email: obj.email,
            role: obj.role,
            usertype: obj.user_type,
            status: obj.status,
            stripe_subscription_id: obj.stripe_subscription_id
          });
        }
      }).catch(function (error) {
        _this.errorMessage = error.response.data.errors;
        _this.isLoading = false;
      });
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this2 = this;

    this.$eventBus.$on('listUser', function (data, error) {
      var messageStorage = _this2.flash();
      if (data) {
        _this2.getAlluser();
        _this2.$forceUpdate();
        messageStorage.destroyAll();
        _this2.flash(data, 'success', { timeout: 3000 });
      } else if (error) {
        _this2.flash(error, 'error', { timeout: 3000 });
      }
    });
    this.getAlluser();
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Action__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'User',
  props: ['rows'],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      tblCls: 'table',
      users: [],
      usersList: [],
      errors: [],
      i: 1,
      input: {
        email: '',
        firstname: '',
        lastname: '',
        username: '',
        userrole: '',
        password: '',
        cnfpassword: ''
      },
      columns: [{ label: 'Stripe CustomerID', field: 'id' }, { label: 'Name', field: 'name', headerClass: 'class-in-header second-class' }, { label: 'User Name', field: 'username' }, { label: 'Email', field: 'email' }, { label: 'Role', field: 'role' }, { label: 'Status', field: 'status' }, { label: 'Action',
        component: __WEBPACK_IMPORTED_MODULE_1__Action__["a" /* default */],
        sortable: false
      }],
      rows: this.usersList,
      filter: '',
      page: 1
    };
  },

  methods: {
    addUser: function addUser() {
      var _this = this;

      this.errors = [];
      var jwttoken = localStorage.getItem('jwt');
      var userrole = this.input.userrole;
      var firstname = this.input.firstname;
      var lastname = this.input.lastname;
      var email = this.input.email;
      var atposition = email.indexOf('@');
      var dotposition = email.lastIndexOf('.');
      if (userrole === '') {
        this.errors.push('Please select user role');
        this.$refs.userrole.focus();
      } else {
        if (userrole === 'user') {
          // this.errors = []
          var username = this.input.username;
          var password = this.input.password;
          var cnfpassword = this.input.cnfpassword;
          if (this.input.firstname === '') {
            this.errors.push('Name is Required');
            this.$refs.firstname.focus();
          } else if (firstname.length < 3) {
            this.errors.push('Name must be 3 characters long');
            this.$refs.firstname.focus();
          } else if (this.input.email === '') {
            this.errors.push('Email is Required');
            this.$refs.email.focus();
          } else if (!this.emailValidator.validate(this.input.email)) {
            this.errors.push('Invalid contact Email');
            this.$refs.email.focus();
          } else {
            this.isLoading = true;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createNewUser', {
              firstname: firstname,
              lastname: lastname,
              email: email,
              role: userrole
            }, {
              headers: {
                'x-access-token': jwttoken
              } }).then(function (response) {
              _this.isLoading = false;
              _this.$eventBus.$emit('listUser', 'User is Added successfully');
              _this.$emit('close');
            }).catch(function (error) {
              _this.$eventBus.$emit('listUser', '', 'User could not be Added');
              _this.$emit('close');
              _this.errorMessage = error.response.data.errors;
              _this.isLoading = false;
            });
          }
        } else {
          var username = this.input.username;
          var password = this.input.password;
          var cnfpassword = this.input.cnfpassword;
          if (this.input.firstname === '') {
            this.errors.push('Name is Required');
            this.$refs.firstname.focus();
          } else if (firstname.length < 3) {
            this.errors.push('Name must be 3 characters long');
            this.$refs.firstname.focus();
          } else if (this.input.username === '') {
            this.errors.push('Username is Required');
            this.$refs.username.focus();
          } else if (username < 3) {
            this.errors.push('Username must be 3 characters long');
            this.$refs.username.focus();
          } else if (this.input.email === '') {
            this.errors.push('Email is Required');
            this.$refs.email.focus();
          } else if (!this.emailValidator.validate(this.input.email)) {
            this.errors.push('Invalid contact Email');
            this.$refs.email.focus();
          } else if (this.input.password === '') {
            this.errors.push('Password is Required');
            this.$refs.password.focus();
          } else if (password.length < 6) {
            this.errors.push('Password must be 6 characters long');
            this.$refs.password.focus();
          } else if (this.input.cnfpassword === '') {
            this.errors.push('Confirm Password is Required');
            this.$refs.cnfpassword.focus();
          } else if (this.input.password !== this.input.cnfpassword) {
            this.errors.push('Password & Confirm Password does not matched');
            this.$refs.cnfpassword.focus();
          } else {
            this.isLoading = true;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createNewUser', {
              firstname: firstname,
              lastname: lastname,
              username: username,
              email: email,
              role: userrole,
              password: password,
              confirm_password: cnfpassword
            }, {
              headers: {
                'Content-Type': 'application/json',
                'x-access-token': jwttoken
              } }).then(function (response) {
              _this.isLoading = false;
              _this.$eventBus.$emit('listUser', 'User is Added successfully');
              _this.$emit('close');
            }).catch(function (error) {
              _this.$eventBus.$emit('listUser', '', 'User could not be Added');
              _this.$emit('close');
              _this.errorMessage = error.response.data.errors;
              _this.isLoading = false;
            });
          }
        }
      }
    },
    onChange: function onChange() {
      var role = event.target.value;
      if (role === 'user') {
        document.getElementById('username').style.display = 'none';
        document.getElementById('password').style.display = 'none';
        document.getElementById('cnfpassword').style.display = 'none';
      } else {
        document.getElementById('username').style.display = 'block';
        document.getElementById('password').style.display = 'block';
        document.getElementById('cnfpassword').style.display = 'block';
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {}
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'terms',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FreeSignup',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      errors: [],
      errorMessage: '',
      isLoading: false,
      fullPage: true,
      input: {
        email: '',
        firstname: '',
        lastname: '',
        username: '',
        password: '',
        cnfpassword: ''
      }
    };
  },

  methods: {
    signup: function signup(e) {
      var _this = this;

      this.errors = [];
      var pass = this.input.password;
      var firstname = this.input.firstname;
      var lastname = this.input.lastname;
      var uname = this.input.username;
      //var email = this.input.email
      var x = this.input.email;
      var atposition = x.indexOf('@');
      var dotposition = x.lastIndexOf('.');
      var checkBox = document.getElementById('termsandcond');
      if (x === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= x.length) {
        this.errors.push('Please enter a valid e-mail address ');
        this.$refs.email.focus();
      } else if (this.input.firstname === '') {
        this.errors.push('Firstname is Required');
        this.$refs.firstname.focus();
      } else if (firstname.length < 3) {
        this.errors.push('Firstname must be 5 characters long');
        this.$refs.firstname.focus();
      } else if (this.input.username === '') {
        this.errors.push('Username is Required');
        this.$refs.username.focus();
      } else if (uname < 3) {
        this.errors.push('Username must be 5 characters long');
        this.$refs.username.focus();
      } else if (this.input.password === '') {
        this.errors.push('Password is Required');
        this.$refs.password.focus();
      } else if (pass.length < 6) {
        this.errors.push('Password must be 6 characters long');
        this.$refs.password.focus();
      } else if (this.input.cnfpassword === '') {
        this.errors.push('Confirm Password is Required');
        this.$refs.cnfpassword.focus();
      } else if (this.input.password !== this.input.cnfpassword) {
        this.errors.push('Password & Confirm Password does not matched');
        this.$refs.cnfpassword.focus();
      } else if (!checkBox.checked) {
        this.errors.push('Please agree terms and conditions');
      } else {
        this.isLoading = true;
        var email = this.input.email;
        var username = this.input.username;
        var firstname = this.input.firstname;
        var lastname = this.input.lastname;
        var password = this.input.password;
        var confirmpassword = this.input.cnfpassword;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/freeSignup', {
          email: email,
          firstname: firstname,
          lastname: lastname,
          username: username,
          password: password,
          confirm_password: confirmpassword
        }).then(function (response) {
          _this.isLoading = false;
          var uid = response.data.results[0].uid;
          //console.log(userID)
          localStorage.setItem('uid', uid);
          window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_GVYn1wmqiX7xBr65utC44cXRFRMirGLR&scope=read_write&requested_capabilities=["card_payments","transfers"]&requested=true#/', '_self');
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    checkboxClick: function checkboxClick() {
      var checkBox = document.getElementById('termsandcond');
      if (checkBox.checked === true) {
        document.getElementById('signup_btn').disabled = false;
      } else {
        document.getElementById('signup_btn').disabled = true;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    document.getElementById('signup_btn').disabled = true;
    var uid = this.$route.query.uid;
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserById/?uid=' + uid).then(function (response) {
      var email = response.data.results[0].email;
      localStorage.setItem('email', email);
      localStorage.setItem('uid', uid);
      self.input.email = email;
    }).catch(function (error) {
      _this2.errorMessage = error.response.data.errors;
      _this2.isLoading = false;
    });
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Escrow',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      errors: [],
      errorMessage: '',
      isLoading: false,
      fullPage: true,
      input: {
        email: '',
        firstname: '',
        lastname: '',
        username: '',
        password: '',
        cnfpassword: ''
      }
    };
  },

  methods: {
    signup: function signup() {
      var _this = this;

      this.errors = [];
      var pass = this.input.password;
      var firstname = this.input.firstname;
      var lastname = this.input.lastname;
      var uname = this.input.username;
      var x = this.input.email;
      var atposition = x.indexOf('@');
      var dotposition = x.lastIndexOf('.');
      var checkBox = document.getElementById('termsandcond');
      if (x === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= x.length) {
        this.errors.push('Please enter a valid e-mail address ');
        this.$refs.email.focus();
      } else if (this.input.firstname === '') {
        this.errors.push('Firstname is Required');
        this.$refs.firstname.focus();
      } else if (firstname.length < 3) {
        this.errors.push('Firstname must be 5 characters long');
        this.$refs.firstname.focus();
      } else if (this.input.username === '') {
        this.errors.push('Username is Required');
        this.$refs.username.focus();
      } else if (uname < 3) {
        this.errors.push('Username must be 5 characters long');
        this.$refs.username.focus();
      } else if (this.input.password === '') {
        this.errors.push('Password is Required');
        this.$refs.password.focus();
      } else if (pass.length < 6) {
        this.errors.push('Password must be 6 characters long');
        this.$refs.password.focus();
      } else if (this.input.cnfpassword === '') {
        this.errors.push('Confirm Password is Required');
        this.$refs.cnfpassword.focus();
      } else if (this.input.password !== this.input.cnfpassword) {
        this.errors.push('Password & Confirm Password does not matched');
        this.$refs.cnfpassword.focus();
      } else if (!checkBox.checked) {
        this.errors.push('Please agree terms and conditions');
      } else {
        this.isLoading = true;
        var email = this.input.email;
        var username = this.input.username;
        var firstname = this.input.firstname;
        var lastname = this.input.lastname;
        var password = this.input.password;
        var confirmpassword = this.input.cnfpassword;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/escrowSignup', {
          email: email,
          firstname: firstname,
          lastname: lastname,
          username: username,
          password: password,
          confirm_password: confirmpassword
        }).then(function (response) {
          _this.isLoading = false;
          var uid = response.data.results[0].uid;
          //console.log(userID)
          localStorage.setItem('uid', uid);
          window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_GVYn1wmqiX7xBr65utC44cXRFRMirGLR&scope=read_write&requested_capabilities=["card_payments","transfers"]&requested=true#/', '_self');
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    checkboxClick: function checkboxClick() {
      var checkBox = document.getElementById('termsandcond');
      if (checkBox.checked === true) {
        document.getElementById('signup_btn').disabled = false;
      } else {
        document.getElementById('signup_btn').disabled = true;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    document.getElementById('signup_btn').disabled = true;
    var uid = this.$route.query.uid;
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserById/?uid=' + uid).then(function (response) {
      var email = response.data.results[0].email;
      localStorage.setItem('email', email);
      localStorage.setItem('uid', uid);
      self.input.email = email;
    }).catch(function (error) {
      _this2.errorMessage = error.response.data.errors;
      _this2.isLoading = false;
    });
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdminDashboard__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invoiceAction__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddInvoice__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invoice',
  components: { AddInvoice: __WEBPACK_IMPORTED_MODULE_3__AddInvoice__["a" /* default */], AdminDashboard: __WEBPACK_IMPORTED_MODULE_1__AdminDashboard__["default"],
    Loading: __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      msg: '',
      isLoading: false,
      fullPage: true,
      validated: false,
      errorMessage: '',
      tblCls: 'table',
      date: '2019-10-01 00:00:00',
      invoicesList: [],
      invoices: [],
      realtime: '',
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      BrandDatas: [],
      errors: [],
      i: 0,
      invoiceDetails: {
        InvoiceData: {
          amount: '',
          description: '',
          uid: '',
          invoice_percentage_id: '',
          brand_id: ''
        },
        invoicePercentageData: {
          admin_percentage: '',
          userA_percentage: '',
          userB_percentage: '',
          userC_percentage: '',
          admin_id: '',
          userA_id: '',
          userB_id: '',
          userC_id: ''
        }
      },
      input: {
        brandid: '',
        amount: '',
        admin: '',
        descrition: '',
        adminpercent: '',
        userA: '',
        userApercent: '',
        userB: '',
        userBpercent: '',
        userC: '',
        userCpercent: '',
        duedays: '',
        invoicetype: ''
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selecteduserC: '',
      selectedDays: '',
      statusInvoice: '',
      columns: [{ label: 'Invoice No.', field: 'id' }, { label: 'Brand', field: 'brand_name' }, { label: 'Payment', field: 'amount', headerClass: 'class-in-header second-class' }, { label: 'Escrow', field: 'admin_percentage' }, { label: 'User A', field: 'userA_percentage' }, { label: 'User B', field: 'userB_percentage' }, { label: 'User C', field: 'userC_percentage' }, { label: 'Status',
        field: 'status',
        interpolate: true,
        representedAs: function representedAs(row) {
          if (row.status === 'open') {
            return ' <span style="color:red">' + row.status + '</span> ';
          } else if (row.status === 'draft') {
            return ' <span style="color:blue">' + row.status + '</span> ';
          } else if (row.status === 'past due') {
            return ' <span style="color:#570702">' + row.status + '</span> ';
          } else {
            return ' <span style="color:green">' + row.status + '</span> ';
          }
        }
      }, { label: 'Action',
        component: __WEBPACK_IMPORTED_MODULE_2__invoiceAction__["a" /* default */],
        sortable: false
      }],
      rows: this.invoicesList,
      filter: '',
      page: 1
    };
  },

  methods: {
    invoiceBtn: function invoiceBtn() {
      var modal = document.getElementById('createInvoice');
      modal.style.display = 'block';
    },
    invoiceClose: function invoiceClose() {
      this.input.amount = '';
      this.input.description = '';
      this.input.adminpercent = '';
      this.input.userApercent = '';
      this.input.userBpercent = '';
      this.input.userCpercent = '';
      this.input.brandid = '';
      this.input.admin = '';
      this.input.userA = '';
      this.input.userB = '';
      this.input.userC = '';
      this.input.duedays = '';
      document.getElementById('brand-logo').style.display = 'none';
      document.getElementById('brandDetail').style.display = 'none';
      document.getElementById('userApercent').disabled = true;
    },
    adInvoice: function adInvoice() {
      this.$modal.show(__WEBPACK_IMPORTED_MODULE_3__AddInvoice__["a" /* default */], { height: '100%' });
    },
    createInvoicePopup: function createInvoicePopup() {
      var modal = document.getElementById('createInvoice');
      var span = document.getElementById('invoiceClose');
      span.onclick = function () {
        modal.style.display = 'none';
        document.getElementById('userApercent').disabled = true;
        document.getElementById('userBpercent').disabled = true;
        document.getElementById('userCpercent').disabled = true;
      };
      window.onclick = function (event) {
        if (event.target === modal) {
          modal.style.display = 'none';
        }
      };
    },
    changeBrand: function changeBrand(event) {
      this.selectedBrand = event.target.options[event.target.options.selectedIndex].value;
    },
    changeDays: function changeDays(event) {
      this.selectedDays = event.target.options[event.target.options.selectedIndex].value;
    },
    getBrands: function getBrands() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.brands = response.data.results;
      }).catch(function (error) {
        _this.errorMessage = error.response.data.errors;
        _this.isLoading = false;
      });
    },
    getInvoice: function getInvoice() {
      var _this2 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      this.invoicesList = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.invoices = response.data.results;

        for (var i in _this2.invoices) {
          var obj = _this2.invoices[i];

          //var amount = Number(obj.amount).toLocaleString()
          _this2.invoicesList.push({
            id: obj.invoice_number,
            uid: obj.invoice_id,
            amount: obj.amount,
            brand_name: obj.brand_name,
            admin_percentage: obj.escrowUser_percentage + '%' + ' (' + obj.escrowUser_amount + ')',
            userA_percentage: obj.userA_percentage + '%' + ' (' + obj.userA_amount + ')',
            userB_percentage: obj.userB_percentage + '%' + ' (' + obj.userB_amount + ')',
            userC_percentage: obj.userC_percentage + '%' + ' (' + obj.userC_amount + ')',
            status: obj.status,
            manual_payment: obj.manual_payment,
            invoice_type: obj.invoice_type
          });
          _this2.isLoading = false;
        }
      }).catch(function (error) {
        console.log(error.response.data.errors);
        _this2.isLoading = false;
      });
    },
    showInvoice: function showInvoice(invoiceId) {
      var _this3 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + invoiceId, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        console.log(response);
        _this3.isLoading = false;
      }).catch(function (error) {
        _this3.errorMessage = error.response.data.errors;
        _this3.isLoading = false;
      });
    }
  },
  created: function created() {
    this.getBrands();
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$eventBus.$on('listInvoice', function (data, error, time) {
      var messageStorage = _this4.flash();
      if (data) {
        _this4.getInvoice();
        _this4.$forceUpdate();
        messageStorage.destroyAll();
        if (time) {
          _this4.flash(data, 'success', { timeout: time });
        } else {
          _this4.flash(data, 'success', { timeout: 3000 });
        }
      } else if (error) {
        if (time) {
          _this4.flash(error, 'error', { timeout: time });
        } else {
          _this4.flash(error, 'error', { timeout: 3000 });
        }
      }
    });
    this.getInvoice();
    document.getElementById('userApercent').disabled = true;
    document.getElementById('userBpercent').disabled = true;
    this.createInvoicePopup();
  },

  watch: {
    $route: function $route(to, from) {
      this.msg = this.$router.currentRoute.query.errorMessage;
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDashboard_vue__ = __webpack_require__(47);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2afd6f18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDashboard_vue__ = __webpack_require__(277);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2afd6f18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddInvoice__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Invoice__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminDashboard',
  components: { AddInvoice: __WEBPACK_IMPORTED_MODULE_1__AddInvoice__["a" /* default */], Invoice: __WEBPACK_IMPORTED_MODULE_2__Invoice__["default"],
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      date: '2019-10-01 00:00:00',
      lastPayments: [],
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      BrandDatas: [],
      lastUsers: [],
      lastBrands: [],
      errors: [],
      i: 0,
      input: {
        brandid: '',
        amount: '',
        admin: '',
        descrition: '',
        adminpercent: '',
        userA: '',
        userApercent: '',
        userB: '',
        userBpercent: '',
        duedays: ''
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selectedDays: '',
      performance: ''
    };
  },

  methods: {
    adInvoice: function adInvoice() {
      this.$modal.show(__WEBPACK_IMPORTED_MODULE_1__AddInvoice__["a" /* default */], { height: '100%' });
    },
    invoiceClose: function invoiceClose() {
      this.input.amount = '';
      this.input.description = '';
      this.input.adminpercent = '';
      this.input.userApercent = '';
      this.input.userBpercent = '';
      this.input.brandid = '';
      this.input.admin = '';
      this.input.userA = '';
      this.input.userB = '';
      this.input.duedays = '';
      document.getElementById('brand-logo').style.display = 'none';
      document.getElementById('brandDetail').style.display = 'none';
    },
    method1: function method1() {
      document.body.addEventListener('click', function () {
        var body2 = document.body;
        body2.classList.remove('background--blur');
        body2.classList.remove('sidebar-show');
        window.onload = function () {
          document.getElementById('navigation-toggle1').style.display = 'block';
          document.getElementById('navigation-toggle2').style.display = 'none';
        };
      }, true);
    },
    changeDays: function changeDays(event) {
      this.selectedDays = event.target.options[event.target.options.selectedIndex].value;
      document.getElementById('draft').style.display = 'none';
      document.getElementById('adddatepick_hide').style.display = 'none';
    },
    click: function click() {
      document.body.addEventListener('click', function () {
        var modal = document.getElementById('createInvoice');
        var span = document.getElementById('close1');
        span.onclick = function () {
          modal.style.display = 'none';
        };
        window.onclick = function (event) {
          if (event.target === modal) {
            modal.style.display = 'none';
          }
        };
      }, true);
    },

    // deleteInvoice (uid) {
    //   var jwttoken = localStorage.getItem('jwt')
    //   if (confirm('Do you really want to delete?')) {
    //     this.isLoading = true
    //     axios.delete('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deleteInvoice' + '?' + 'uid' + '=' + uid, {
    //       headers: {
    //         'x-access-token': jwttoken
    //       }})
    //       .then(response => {
    //         this.isLoading = false
    //         console.log(response)
    //         axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
    //           headers: {
    //             'x-access-token': jwttoken
    //           }})
    //           .then(response => {
    //             this.invoiceDatas = response.data.results.InvoiceData
    //             this.invoicePartiesPercentageDatas = response.data.results.invoicePartiesPercentageData
    //           })
    //           .catch((error) => {
    //             console.log(error)
    //             this.isLoading = false
    //           })
    //       })
    //   }
    // },
    changeBrand: function changeBrand(event) {
      this.selectedBrand = event.target.options[event.target.options.selectedIndex].value;
      console.log(this.selectedBrand);
    },
    changeUserFirst: function changeUserFirst() {
      this.selecteduserA = event.target.options[event.target.options.selectedIndex].value;
      console.log(this.selecteduserA);
    },
    changeUserSecond: function changeUserSecond() {
      this.selecteduserB = event.target.options[event.target.options.selectedIndex].value;
      console.log(this.selecteduserB);
    },
    getBrands: function getBrands() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.brands = response.data.results[0];
        console.log(_this.brands);
      }).catch(function (error) {
        console.log(error);
        _this.isLoading = false;
      });
    },
    getUsers: function getUsers() {
      var _this2 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.isLoading = false;
        _this2.users = response.data.results[0];
        console.log(_this2.users);
      }).catch(function (error) {
        console.log(error);
        _this2.isLoading = false;
      });
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this3.isLoading = false;
        _this3.BrandDatas = response.data.results.BrandData;
        _this3.invoiceDatas = response.data.results.InvoiceData;
        _this3.invoicePartiesPercentageDatas = response.data.results.invoicePartiesPercentageData;
        console.log(_this3.results);
      }).catch(function (error) {
        console.log(error);
        _this3.isLoading = false;
      });
    },
    showInvoice: function showInvoice(invoiceId) {
      var _this4 = this;

      var jwttoken = localStorage.getItem('jwt');
      console.log(invoiceId);
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + invoiceId, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this4.isLoading = false;
        console.log(response);
      }).catch(function (error) {
        console.log(error);
        _this4.isLoading = false;
      });
    },
    getLastPayment: function getLastPayment() {
      var _this5 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getLatestPayments', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this5.isLoading = false;
        _this5.lastPayments = response.data.results;
      }).catch(function (error) {
        console.log(error);
        _this5.isLoading = false;
      });
    },
    getLastInvoices: function getLastInvoices() {
      var _this6 = this;

      this.lastInvoices = [];
      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getLatestInvoices', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this6.isLoading = false;
        _this6.lastInvoices = response.data.results.InvoiceData;
        console.log(response);
      }).catch(function (error) {
        console.log(error);
        _this6.isLoading = false;
      });
    },
    getLastUsers: function getLastUsers() {
      var _this7 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getLatestUsers', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this7.isLoading = false;
        _this7.lastUsers = response.data.results[0];
        console.log(_this7.lastUsers);
      }).catch(function (error) {
        console.log(error);
        _this7.isLoading = false;
      });
    },
    getLastbrands: function getLastbrands() {
      var _this8 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getLatestBrands', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this8.isLoading = false;
        _this8.lastBrands = response.data.results[0];
        console.log(_this8.lastBrands);
      }).catch(function (error) {
        console.log(error);
        _this8.isLoading = false;
      });
    },
    getPerformance: function getPerformance() {
      var _this9 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getPerformance', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this9.isLoading = false;
        _this9.performance = response.data.results;
      }).catch(function (error) {
        console.log(error);
        _this9.isLoading = false;
      });
    }
  },
  created: function created() {
    this.getBrands();
    this.getUsers();
    this.getInvoice();
    this.getLastInvoices();
  },
  mounted: function mounted() {
    var _this10 = this;

    this.$eventBus.$on('latestDashbordList', function () {
      // alert('helo')
      _this10.getLastInvoices();
      _this10.getLastUsers();
      _this10.getLastbrands();
      _this10.getLastPayment();
      _this10.$forceUpdate();
    });
    this.method1();
    this.click();
    this.getLastPayment();
    this.getLastInvoices();
    this.getLastUsers();
    this.getLastbrands();
    this.getPerformance();
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invoiceAction__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddInvoice__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invoice',
  components: { AddInvoice: __WEBPACK_IMPORTED_MODULE_2__AddInvoice__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      msg: '',
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      tblCls: 'table',
      date: '2019-10-01 00:00:00',
      invoicesList: [],
      invoices: [],
      realtime: '',
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      getBrandsAscendingOrder: [],
      BrandDatas: [],
      errors: [],
      i: 0,
      invoiceDetails: {
        InvoiceData: {
          amount: '',
          description: '',
          uid: '',
          invoice_percentage_id: '',
          brand_id: ''
        },
        invoicePercentageData: {
          admin_percentage: '',
          userA_percentage: '',
          userB_percentage: '',
          userC_percentage: '',
          admin_id: '',
          userA_id: '',
          userB_id: '',
          userC_id: ''
        }
      },
      invoicetypeList: [{
        id: 'immediate',
        text: 'Immediate',
        value: 'immediate'
      }, {
        text: 'Held',
        value: 'held',
        id: 'held'
      }],
      duedaysList: [{
        text: 'Escrow',
        value: '1'
      }, {
        text: '15 Days',
        value: '15'
      }, {
        text: '30 Days',
        value: '30'
      }, {
        text: '45 Days',
        value: '45'
      }, {
        text: '60 Days',
        value: '60'
      }],
      input: {
        brandid: '',
        amount: '',
        admin: '',
        description: '',
        adminpercent: '',
        userA: '',
        userApercent: '',
        userB: '',
        userBpercent: '',
        userC: '',
        userCpercent: '',
        invoicetype: '',
        duedays: '',

        onedays: ''
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selecteduserC: '',
      selectedDays: '',
      statusInvoice: '',
      columns: [{ label: 'Stripe Invoice ID', field: 'id' }, { label: 'Brand', field: 'brand_name' }, { label: 'Payment ($)', field: 'amount', headerClass: 'class-in-header second-class' }, { label: 'Ghost (%)', field: 'admin_percentage' }, { label: 'User A (%)', field: 'userA_percentage' }, { label: 'User B (%)', field: 'userB_percentage' }, { label: 'User C (%)', field: 'userC_percentage' }, { label: 'Status',
        field: 'status',
        interpolate: true,
        representedAs: function representedAs(row) {
          if (row.status === 'open') {
            return ' <span style="color:red">' + row.status + '</span> ';
          } else if (row.status === 'draft') {
            return ' <span style="color:blue">' + row.status + '</span> ';
          } else {
            return ' <span style="color:green">' + row.status + '</span> ';
          }
        }
      }, { label: 'Action',
        component: __WEBPACK_IMPORTED_MODULE_1__invoiceAction__["a" /* default */],
        sortable: false
      }],
      rows: this.invoicesList,
      filter: '',
      page: 1
    };
  },

  methods: {
    invoiceBtn: function invoiceBtn() {
      var modal = document.getElementById('createInvoice');
      modal.style.display = 'block';
    },
    invoiceClose: function invoiceClose() {
      this.input.amount = '';
      this.input.description = '';
      this.input.adminpercent = '';
      this.input.userApercent = '';
      this.input.userBpercent = '';
      this.input.userCpercent = '';
      this.input.brandid = '';
      this.input.admin = '';
      this.input.userA = '';
      this.input.userB = '';
      this.input.userC = '';
      this.input.duedays = '';
      this.input.onedays = '';
      document.getElementById('brand-logo').style.display = 'none';
      document.getElementById('brandDetail').style.display = 'none';
      document.getElementById('userApercent').disabled = true;
    },
    adUser: function adUser() {
      this.$modal.show(__WEBPACK_IMPORTED_MODULE_2__AddInvoice__["a" /* default */], { height: '100%' });
    },
    createInvoicePopup: function createInvoicePopup() {
      var modal = document.getElementById('createInvoice');
      var span = document.getElementById('invoiceClose');
      span.onclick = function () {
        modal.style.display = 'none';
        document.getElementById('userApercent').disabled = true;
        document.getElementById('userBpercent').disabled = true;
        document.getElementById('userCpercent').disabled = true;
      };
      window.onclick = function (event) {
        if (event.target === modal) {
          modal.style.display = 'none';
        }
      };
    },
    changeBrand: function changeBrand(event) {
      this.selectedBrand = event.target.options[event.target.options.selectedIndex].value;
      console.log(this.selectedBrand);
    },
    changeDays: function changeDays(event) {
      var optionList = document.getElementById("immediateHeldSelect");
      console.log(optionList.value);
      var display = "block";
      var selected = "";
      if (this.input.duedays === '1') {
        display = "none";
        selected = "true";
      } else {
        // alert('1')
        selected = "";
        this.input.invoicetype = "";
      }
      for (var i = 0; i < optionList.length; i++) {
        if (optionList.options[i].value === 'immediate') {
          optionList.options[i].style.display = display;
        }
        if (optionList.options[i].value === 'held') {
          // alert('2')
          this.input.invoicetype = 'held';
          optionList.options[i].selected = selected;
        }
      }
    },
    invoiceType: function invoiceType(event) {
      this.invoiceType = event.target.options[event.target.options.selectedIndex].value;
    },
    changeUserFirst: function changeUserFirst() {
      this.selecteduserA = event.target.options[event.target.options.selectedIndex].value;
      //alert(this.selecteduserA)
      if (this.selecteduserA === '') {
        this.input.userApercent = '';
        this.input.userBpercent = '';
        this.input.userCpercent = '';
        this.input.userB = '';
        this.input.userC = '';
        document.getElementById('userB').disabled = true;
        document.getElementById('userC').disabled = true;
        document.getElementById('userApercent').disabled = true;
        document.getElementById('userBpercent').disabled = true;
        document.getElementById('userCpercent').disabled = true;
      } else {
        // alert('1')
        document.getElementById('userB').disabled = false;
        document.getElementById('userApercent').disabled = false;
      }
    },
    changeUserSecond: function changeUserSecond() {
      this.selecteduserB = event.target.options[event.target.options.selectedIndex].value;
      if (this.selecteduserB === '') {
        this.input.userBpercent = '';
        this.input.userCpercent = '';
        this.input.userB = '';
        this.input.userC = '';
        document.getElementById('userC').disabled = true;
        document.getElementById('userBpercent').disabled = true;
        document.getElementById('userCpercent').disabled = true;
      } else {
        document.getElementById('userC').disabled = false;
        document.getElementById('userBpercent').disabled = false;
      }
    },
    changeUserThird: function changeUserThird() {
      this.selecteduserC = event.target.options[event.target.options.selectedIndex].value;
      if (this.selecteduserC === '') {
        this.input.userCpercent = '';
        document.getElementById('userCpercent').disabled = true;
      } else {
        document.getElementById('userCpercent').disabled = false;
      }
    },
    getBrands: function getBrands() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.brands = response.data.results;
      }).catch(function (error) {
        _this.errorMessage = error.response.data.errors;
        _this.isLoading = false;
      });
    },
    getUsers: function getUsers() {
      var _this2 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.isLoading = false;
        _this2.users = response.data.results;
        console.log(_this2.users);
      }).catch(function (error) {
        _this2.errorMessage = error.response.data.errors;
        _this2.isLoading = false;
      });
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this3.invoices = response.data.results;
        for (var i in _this3.invoices) {
          var obj = _this3.invoices[i];
          var amount = Number(obj.amount).toLocaleString();
          _this3.invoicesList.push({
            id: obj.stripe_invoice_id,
            uid: obj.invoice_id,
            amount: amount,
            brand_name: obj.brand_name,
            admin_percentage: obj.admin_percentage,
            userA_percentage: obj.userA_percentage,
            userB_percentage: obj.userB_percentage,
            userC_percentage: obj.userC_percentage,
            status: obj.status,
            invoice_type: obj.invoice_type
          });
          _this3.isLoading = false;
        }
      }).catch(function (error) {
        console.log(error.response.data.errors);
        _this3.isLoading = false;
      });
    },
    showInvoice: function showInvoice(invoiceId) {
      var _this4 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + invoiceId, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        console.log(response);
        _this4.isLoading = false;
      }).catch(function (error) {
        _this4.errorMessage = error.response.data.errors;
        _this4.isLoading = false;
      });
    },
    saveInvoice: function saveInvoice() {
      var _this5 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.errors = [];
      var status = 'open';
      var amount = this.input.amount;
      var description = this.input.description;
      var adminpercent = this.input.adminpercent;
      var userApercent = this.input.userApercent;
      var userBpercent = this.input.userBpercent ? this.input.userBpercent : 0.00;
      var userCpercent = this.input.userCpercent ? this.input.userCpercent : 0.00;
      var brandId = this.input.brandid;
      var escrowUserId = this.input.admin;
      var userA = this.input.userA;
      var userB = this.input.userB;
      var userC = this.input.userC;
      var duedays = this.input.duedays;
      var onedays = this.input.onedays;
      var invoiceType = this.input.invoicetype;
      var total = parseFloat(adminpercent) + parseFloat(userApercent) + parseFloat(userBpercent) + +parseFloat(userCpercent);
      var numbersOnly = /^\d+$/;
      if (brandId === '') {
        this.errors.push('Brand is Required');
        this.$refs.brandid.focus();
      } else if (amount === '') {
        this.errors.push('Amount is Required');
        this.$refs.amount.focus();
      } else if (!/^\d+(\.\d+)?$/.test(amount)) {
        this.errors.push('Please Enter Valid Amount');
        this.$refs.amount.focus();
      } else if (duedays === '') {
        this.errors.push('Due Days is Required');
        this.$refs.duedays.focus();
      } else if (invoiceType === '') {
        this.errors.push('Invoice Type is Required');
        this.$refs.invoicetype.focus();
      } else if (description === '') {
        this.errors.push('Description is Required');
        this.$refs.description.focus();
      } else if (escrowUserId === '') {
        this.errors.push('Admin is Required');
        this.$refs.admin.focus();
      } else if (adminpercent === '') {
        this.errors.push('Admin percentage is Required');
        this.$refs.adminpercent.focus();
      } else if (userA === '') {
        this.errors.push('UserA is Required');
        this.$refs.UserA.focus();
      } else if (userApercent === '') {
        this.errors.push('userA percentage is Required');
        this.$refs.userApercent.focus();
      } else if (total !== 100) {
        this.errors.push('Total should be 100');
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createInvoice', {
          brand_id: brandId,
          amount: amount,
          description: description,
          escrowUser_id: escrowUserId,
          escrowUser_percentage: adminpercent,
          userA_id: userA,
          userA_percentage: userApercent,
          userB_id: userB,
          userB_percentage: userBpercent,
          userC_id: userC,
          userC_percentage: userCpercent,
          status: status,
          due_days: duedays,
          escrow: '',
          invoice_type: invoiceType
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this5.isLoading = false;
          console.log(response);
          _this5.$eventBus.$emit('listInvoice', 'Invoice created successfully');
          _this5.$eventBus.$emit('latestDashbordList');
          _this5.$emit('close');
        }).catch(function (error) {
          _this5.$eventBus.$emit('listInvoice', '', 'Invoice could not be Added');
          _this5.$eventBus.$emit('latestDashbordList');
          _this5.$emit('close');
          _this5.errorMessage = error.response.data.errors;
          _this5.isLoading = false;
        });
      }
    },
    draftInvoice: function draftInvoice() {
      var _this6 = this;

      this.errors = [];
      var jwttoken = localStorage.getItem('jwt');
      var status = 'draft';
      var amount = this.input.amount;
      var description = this.input.description;
      var adminpercent = this.input.adminpercent;
      var userApercent = this.input.userApercent;
      var userBpercent = this.input.userBpercent ? this.input.userBpercent : 0;
      var userCpercent = this.input.userCpercent ? this.input.userCpercent : 0;
      var brandId = this.input.brandid;
      var escrowUserId = this.input.admin;
      var userA = this.input.userA;
      var userB = this.input.userB;
      var userC = this.input.userC;
      var duedays = this.input.duedays;
      var onedays = this.input.onedays;
      var invoiceType = this.input.invoicetype;

      var total = parseFloat(adminpercent) + parseFloat(userApercent) + parseFloat(userBpercent) + parseFloat(userCpercent);

      var numbersOnly = /^\d+$/;
      if (brandId === '') {
        this.errors.push('Brand is Required');
        this.$refs.brandid.focus();
      } else if (duedays === '') {
        this.errors.push('Due Days is Required');
        this.$refs.duedays.focus();
      } else if (invoiceType === '') {
        this.errors.push('Invoice Type is Required');
        this.$refs.invoicetype.focus();
      } else if (amount === '') {
        this.errors.push('Amount is Required');
        this.$refs.amount.focus();
      } else if (!/^\d+(\.\d+)?$/.test(amount)) {
        this.errors.push('Enter Valid Number');
        this.$refs.amount.focus();
      } else if (description === '') {
        this.errors.push('Description is Required');
        this.$refs.description.focus();
      } else if (escrowUserId === '') {
        this.errors.push('Admin is Required');
        this.$refs.admin.focus();
      } else if (adminpercent === '') {
        this.errors.push('Admin percentage is Required');
        this.$refs.adminpercent.focus();
      } else if (userA === '') {
        this.errors.push('UserA is Required');
        this.$refs.userA.focus();
      } else if (userApercent === '') {
        this.errors.push('userA percentage is Required');
        this.$refs.userApercent.focus();
      } else if (total !== 100) {
        this.errors.push('Total should be 100');
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createInvoice', {
          brand_id: brandId,
          amount: amount,
          description: description,
          escrowUser_id: escrowUserId,
          escrowUser_percentage: adminpercent,
          userA_id: userA,
          userA_percentage: userApercent,
          userB_id: userB,
          userB_percentage: userBpercent,
          userC_id: userC,
          userC_percentage: userCpercent,
          status: status,
          due_days: duedays,
          escrow: '',
          invoice_type: invoiceType
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this6.isLoading = false;
          _this6.$eventBus.$emit('listInvoice', 'Invoice created successfully');
          _this6.$emit('close');
        }).catch(function (error) {
          _this6.$eventBus.$emit('listInvoice', '', 'Invoice could not be Added');
          _this6.$emit('close');
          _this6.errorMessage = error.response.data.errors;
          _this6.isLoading = false;
        });
      }
    }
  },
  created: function created() {
    this.getBrands();
    this.getUsers();
    this.getInvoice();
  },

  computed: {
    sortedArray: function sortedArray() {
      function compare(a, b) {
        if (a.brand_name < b.brand_name) return -1;
        if (a.brand_name > b.brand_name) return 1;
        return 0;
      }

      return this.brands.sort(compare);
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    var jwttoken = localStorage.getItem('jwt');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getListBrands', {
      headers: {
        'x-access-token': jwttoken
      } }).then(function (response) {
      _this7.isLoading = false;
      _this7.getBrandsAscendingOrder = response.data.results;
      console.log(_this7.getBrandsAscendingOrder);
    }).catch(function (error) {
      _this7.errorMessage = error.response.data.errors;
      _this7.isLoading = false;
    });
    document.getElementById('userApercent').disabled = true;
    document.getElementById('userBpercent').disabled = true;
    document.getElementById('userCpercent').disabled = true;
    document.getElementById('userB').disabled = true;
    document.getElementById('userC').disabled = true;
    var options = document.getElementById("duedays").options;
    this.createInvoicePopup();
  },

  watch: {
    $route: function $route(to, from) {
      this.msg = this.$router.currentRoute.query.errorMessage;
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceAction_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af606210_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceAction_vue__ = __webpack_require__(275);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af606210_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceAction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Invoice__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditInvoiceModal_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brandAction',
  props: ['row', 'data'],
  components: { Invoice: __WEBPACK_IMPORTED_MODULE_2__Invoice__["default"],
    Loading: __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      date: '2019-10-01 00:00:00',
      invoicesList: [],
      invoices: [],
      realtime: '',
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      BrandDatas: [],
      errors: [],
      i: 0,
      invoiceDetails: {
        InvoiceData: {
          amount: '',
          description: '',
          uid: '',
          invoice_percentage_id: '',
          brand_id: ''
        },
        invoicePercentageData: {
          admin_percentage: '',
          userA_percentage: '',
          userB_percentage: '',
          admin_id: '',
          userA_id: '',
          userB_id: ''
        }
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selectedDays: '',
      statusInvoice: ''
    };
  },

  methods: {
    deleteInvoice: function deleteInvoice() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      var uid = this.row.uid;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deleteInvoice' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.$eventBus.$emit('listInvoice', 'Invoice is deleted successfully');
        _this.$eventBus.$emit('latestDashbordList');
      }).catch(function (error) {
        this.isLoading = false;
        this.$eventBus.$emit('listInvoice', '', 'Invoice could not be deleted');
      });
    },
    transfer: function transfer() {
      var _this2 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      var uid = this.row.uid;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/transferPayouts', {
        invoice_id: uid
      }, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.isLoading = false;
        if (response.data.message.adminData.adminStatus && (response.data.message.userAData.userAStatus || response.data.message.userBData.userBStatus)) {
          var str = '';
          if (response.data.message.userAData.userAStatus) {
            str += response.data.message.userAData.userAMessage + '\n';
          }
          if (response.data.message.userBData.userBStatus) {
            str += response.data.message.userBData.userBMessage + '\n';
          }
          if (response.data.message.userCData.userCStatus) {
            str += response.data.message.userCData.userCMessage + '\n';
          }
          if (response.data.message.adminData.adminStatus) {
            str += response.data.message.adminData.adminMessage + '\n';
          }

          _this2.$eventBus.$emit('listInvoice', str);
        } else {

          var _str = '';
          if (!response.data.message.userAData.userAStatus) {
            _str += response.data.message.userAData.userAMessage + '\n';
          }
          if (!response.data.message.userBData.userBStatus) {
            _str += response.data.message.userBData.userBMessage + '\n';
          }
          if (!response.data.message.userCData.userCStatus) {
            _str += response.data.message.userCData.userCMessage + '\n';
          }
          if (!response.data.message.adminData.adminStatus) {
            _str += response.data.message.adminData.adminMessage + '\n';
          }
          //   var errorMessage = response.data.message.userAData.userAMessage + ',' + response.data.message.userBData.userBMessage
          _this2.$eventBus.$emit('listInvoice', false, _str, 10000); // this.$router.replace('/Invoice?errorMessage=' + errorMessage)
        }
      }).catch(function (error) {
        _this2.errorMessage = error.response.data.errors;
        _this2.isLoading = false;
      });
    },
    invoiceDetail: function invoiceDetail() {
      var location = '/invoiceDetail' + '/' + this.row.uid + '/' + 'invoicelistpage';
      this.$router.push(location);
    },
    editInvoice: function editInvoice() {
      var _this3 = this;

      var jwttoken = localStorage.getItem('jwt');
      var uid = this.row.uid;
      var status = this.row.status;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this3.isLoading = false;
        _this3.invoiceDetails = response.data.results;
        _this3.statusInvoice = status;
        var timestamap = response.data.results.InvoiceData.schedule_date;
        _this3.realtime = __WEBPACK_IMPORTED_MODULE_1_moment___default()(timestamap).format('YYYY-MM-DD hh:mm:ss');
        _this3.invoiceDetails.InvoiceData.schedule_date = _this3.realtime;
        _this3.$modal.show(__WEBPACK_IMPORTED_MODULE_3__EditInvoiceModal_vue__["a" /* default */], { invoiceDetails: response.data.results }, { height: '100%' });
      }).catch(function (error) {
        // console.log(error.response.data.errors)
        _this3.errorMessage = error.response.data.errors;
        _this3.isLoading = false;
      });
    },
    download: function download() {
      var _this4 = this;

      //alert('1')
      var jwttoken = localStorage.getItem('jwt');
      var uid = this.row.uid;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/pdfCreator' + '?' + 'invoice_id' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this4.isLoading = false;
        var url = response.data.results;
        window.open(url);
        _this4.isLoading = false;
      }).catch(function (error) {
        // console.log(error.response.data.errors)
        _this4.errorMessage = error.response.data.errors;
        _this4.isLoading = false;
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditInvoiceModal',
  props: ['invoiceDetails'],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      date: '2019-10-01 00:00:00',
      invoicesList: [],
      invoices: [],
      realtime: '',
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      getBrandsAscendingOrder: [],
      BrandDatas: [],
      errors: [],
      i: 0,
      input: {
        brandid: '',
        amount: '',
        admin: '',
        description: '',
        adminpercent: '',
        userA: '',
        userApercent: '',
        userB: '',
        userBpercent: '',
        userC: '',
        userCpercent: '',
        duedays: ''
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selecteduserC: '',
      selectedDays: '',
      statusInvoice: ''
    };
  },

  methods: {
    changeBrand: function changeBrand(event) {
      this.selectedBrand = event.target.options[event.target.options.selectedIndex].value;
      console.log(this.selectedBrand);
    },
    changeUserFirst: function changeUserFirst() {
      this.selecteduserA = event.target.options[event.target.options.selectedIndex].value;
      // alert(this.selecteduserA)
      if (this.selecteduserA === '') {
        this.invoiceDetails.invoicePercentageData.userA_percentage = '';
        this.invoiceDetails.invoicePercentageData.userB_percentage = '';
        this.invoiceDetails.invoicePercentageData.userC_percentage = '';
        var x = document.getElementById("userB");
        x.remove(x.selectedIndex);
        var y = document.getElementById("userC");
        y.remove(y.selectedIndex);
        document.getElementById('userB').disabled = true;
        document.getElementById('userC').disabled = true;

        document.getElementById('userA_percentage').disabled = true;
        document.getElementById('userB_percentage').disabled = true;
        document.getElementById('userC_percentage').disabled = true;
      } else {
        document.getElementById('userB').disabled = false;
        document.getElementById('userA_percentage').disabled = false;
      }
    },
    changeUserSecond: function changeUserSecond() {
      this.selecteduserB = event.target.options[event.target.options.selectedIndex].value;
      if (this.selecteduserB === '') {
        this.invoiceDetails.invoicePercentageData.userC_percentage = '';
        document.getElementById('userB_percentage').disabled = true;
        document.getElementById('userC_percentage').disabled = true;
        var z = document.getElementById("userC");
        z.remove(z.selectedIndex);
        document.getElementById('userC').disabled = true;
      } else {

        document.getElementById('userC').disabled = false;
        document.getElementById('userB_percentage').disabled = false;
      }
    },
    changeUserThird: function changeUserThird() {
      this.selecteduserC = event.target.options[event.target.options.selectedIndex].value;
      if (this.selecteduserC === '') {
        this.invoiceDetails.invoicePercentageData.userC_percentage = '';
        document.getElementById('userC_percentage').disabled = true;
      } else {
        document.getElementById('userC_percentage').disabled = false;
      }
    },
    getBrands: function getBrands() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.brands = response.data.results;
        console.log(_this.brands);
      }).catch(function (error) {
        _this.errorMessage = error.response.data.errors;
        _this.isLoading = false;
      });
    },
    getUsers: function getUsers() {
      var _this2 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.isLoading = false;
        _this2.users = response.data.results;
        console.log(_this2.users);
      }).catch(function (error) {
        _this2.errorMessage = error.response.data.errors;
        _this2.isLoading = false;
      });
    },
    editchangeDays: function editchangeDays(event) {
      var optionList = document.getElementById("invoice_type");
      var display = "block";
      var selected = "";
      if (this.invoiceDetails.InvoiceData.due_days === '1') {
        display = "none";
        selected = "true";
      }
      for (var i = 0; i < optionList.length; i++) {
        if (optionList.options[i].value === 'immediate') {
          optionList.options[i].style.display = display;
        }
        if (optionList.options[i].value === 'held') {
          this.invoiceDetails.InvoiceData.invoice_type = 'held';
          optionList.options[i].selected = selected;
        }
      }
    },
    editsaveInvoice: function editsaveInvoice() {
      var _this3 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.errors = [];
      var status = 'open';
      var amount = parseFloat(this.invoiceDetails.InvoiceData.amount);
      var description = this.invoiceDetails.InvoiceData.description;
      var uid = this.invoiceDetails.InvoiceData.uid;
      var puid = this.invoiceDetails.InvoiceData.invoice_percentage_id;
      var adminpercent = this.invoiceDetails.invoicePercentageData.escrowUser_percentage;
      var userApercent = this.invoiceDetails.invoicePercentageData.userA_percentage;
      var userBpercent = this.invoiceDetails.invoicePercentageData.userB_percentage ? this.invoiceDetails.invoicePercentageData.userB_percentage : 0;
      var userCpercent = this.invoiceDetails.invoicePercentageData.userC_percentage ? this.invoiceDetails.invoicePercentageData.userC_percentage : 0;
      var brandId = this.invoiceDetails.InvoiceData.brand_id;

      var adminId = this.invoiceDetails.invoicePercentageData.escrowUser_id;
      var userA = this.invoiceDetails.invoicePercentageData.userA_id;
      var userB = this.invoiceDetails.invoicePercentageData.userB_id;
      var userC = this.invoiceDetails.invoicePercentageData.userC_id;
      var duedays = this.invoiceDetails.InvoiceData.due_days;
      var scheduledate = this.invoiceDetails.InvoiceData.schedule_date;
      var invoiceType = this.invoiceDetails.InvoiceData.invoice_type;

      var total = parseFloat(adminpercent) + parseFloat(userApercent) + parseFloat(userBpercent) + parseFloat(userCpercent);
      if (brandId === '') {
        this.errors.push('Brand is Required');
        this.$refs.brand_id.focus();
      } else if (invoiceType === '') {
        this.errors.push('Invoice Type is Required');
        this.$refs.invoice_type.focus();
      } else if (duedays === '') {
        this.errors.push('Due Days is Required');
        this.$refs.duedays.focus();
      } else if (amount === '') {
        this.errors.push('Amount is Required');
        this.$refs.amount.focus();
      } else if (!/^\d+(\.\d+)?$/.test(amount)) {
        this.errors.push('Enter Valid Number');
        this.$refs.amount.focus();
      } else if (description === '') {
        this.errors.push('Descrition is Required');
        this.$refs.description.focus();
      } else if (adminId === '') {
        this.errors.push('Admin is Required');
        this.$refs.admin.focus();
      } else if (adminpercent === '') {
        this.errors.push('Admin percentage is Required');
        this.$refs.admin_percentage.focus();
      } else if (userA === '') {
        this.errors.push('UserA is Required');
        this.$refs.userA.focus();
      } else if (userApercent === '') {
        this.errors.push('userA percentage is Required');
        this.$refs.userA_percentage.focus();
      } else if (total !== 100) {
        this.errors.push('Total should be 100');
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/editInvoice', {
          brand_id: brandId,
          amount: amount,
          description: description,
          escrowUser_id: adminId,
          escrowUser_percentage: adminpercent,
          userA_id: userA,
          userA_percentage: userApercent,
          userB_id: userB,
          userB_percentage: userBpercent,
          userC_id: userC,
          userC_percentage: userCpercent,
          status: status,
          uid: uid,
          puid: puid,
          due_days: duedays,
          schedule_date: scheduledate,
          escrow: '',
          invoice_type: invoiceType
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this3.isLoading = false;
          _this3.$eventBus.$emit('listInvoice', 'Invoice is Updated successfully');
          _this3.$eventBus.$emit('latestDashbordList');
          _this3.$emit('close');
        }).catch(function (error) {
          _this3.$eventBus.$emit('listInvoice', '', 'Invoice could not be Updated');
          _this3.$emit('close');
          _this3.errorMessage = error.response.data.errors;
          _this3.isLoading = false;
        });
      }
    },
    editdraftInvoice: function editdraftInvoice() {
      var _this4 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.errors = [];
      var status = 'draft';
      var amount = parseFloat(this.invoiceDetails.InvoiceData.amount);
      var description = this.invoiceDetails.InvoiceData.description;
      var uid = this.invoiceDetails.InvoiceData.uid;
      var puid = this.invoiceDetails.InvoiceData.invoice_percentage_id;
      var adminpercent = this.invoiceDetails.invoicePercentageData.escrowUser_percentage;
      var userApercent = this.invoiceDetails.invoicePercentageData.userA_percentage;
      var userBpercent = this.invoiceDetails.invoicePercentageData.userB_percentage ? this.invoiceDetails.invoicePercentageData.userB_percentage : 0;
      var userCpercent = this.invoiceDetails.invoicePercentageData.userC_percentage ? this.invoiceDetails.invoicePercentageData.userC_percentage : 0;
      var brandId = this.invoiceDetails.InvoiceData.brand_id;
      var adminId = this.invoiceDetails.invoicePercentageData.escrowUser_id;
      var userA = this.invoiceDetails.invoicePercentageData.userA_id;
      var userB = this.invoiceDetails.invoicePercentageData.userB_id;
      var userC = this.invoiceDetails.invoicePercentageData.userC_id;
      var invoiceType = this.invoiceDetails.InvoiceData.invoice_type;
      var total = parseFloat(adminpercent) + parseFloat(userApercent) + parseFloat(userBpercent) + parseFloat(userCpercent);
      var scheduledate = this.invoiceDetails.InvoiceData.schedule_date;
      var duedays = this.invoiceDetails.InvoiceData.due_days;

      if (brandId === '') {
        this.errors.push('Brand is Required');
        this.$refs.brand_id.focus();
      } else if (invoiceType === '') {
        this.errors.push('Invoice Type is Required');
        this.$refs.invoice_type.focus();
      } else if (duedays === '') {
        this.errors.push('Due Days is Required');
        this.$refs.duedays.focus();
      } else if (amount === '') {
        this.errors.push('Amount is Required');
        this.$refs.amount.focus();
      } else if (!/^\d+(\.\d+)?$/.test(amount)) {
        this.errors.push('Enter Valid Number');
        this.$refs.amount.focus();
      } else if (description === '') {
        this.errors.push('Description is Required');
        this.$refs.description.focus();
      } else if (adminId === '') {
        this.errors.push('Admin is Required');
        this.$refs.admin.focus();
      } else if (adminpercent === '') {
        this.errors.push('Admin percentage is Required');
        this.$refs.admin_percentage.focus();
      } else if (userA === '') {
        this.errors.push('UserA is Required');
        this.$refs.userA.focus();
      } else if (userApercent === '') {
        this.errors.push('userA percentage is Required');
        this.$refs.userA_percentage.focus();
      } else if (total !== 100) {
        this.errors.push('Total should be 100');
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/editInvoice', {
          brand_id: brandId,
          amount: amount,
          description: description,
          escrowUser_id: adminId,
          escrowUser_percentage: adminpercent,
          userA_id: userA,
          userA_percentage: userApercent,
          userB_id: userB,
          userB_percentage: userBpercent,
          userC_id: userC,
          userC_percentage: userCpercent,
          status: status,
          uid: uid,
          puid: puid,
          schedule_date: scheduledate,
          due_days: duedays,
          invoice_type: invoiceType,
          escrow: ''
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this4.isLoading = false;
          _this4.$eventBus.$emit('listInvoice', 'Invoice is Updated successfully');
          _this4.$eventBus.$emit('latestDashbordList');
          _this4.$emit('close');
        }).catch(function (error) {
          _this4.$eventBus.$emit('listInvoice', '', 'Invoice could not be Updated');
          _this4.$emit('close');
          _this4.errorMessage = error.response.data.errors;
          _this4.isLoading = false;
        });
      }
    }
  },
  created: function created() {
    this.getBrands();
    this.getUsers();
    // this.getInvoice()
  },
  mounted: function mounted() {
    var _this5 = this;

    var jwttoken = localStorage.getItem('jwt');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getListBrands', {
      headers: {
        'x-access-token': jwttoken
      } }).then(function (response) {
      _this5.isLoading = false;
      _this5.getBrandsAscendingOrder = response.data.results;
      console.log(_this5.getBrandsAscendingOrder);
    }).catch(function (error) {
      _this5.errorMessage = error.response.data.errors;
      _this5.isLoading = false;
    });

    this.selecteduserA = this.invoiceDetails.invoicePercentageData.userA_id;
    this.selecteduserB = this.invoiceDetails.invoicePercentageData.userB_id;
    this.selecteduserC = this.invoiceDetails.invoicePercentageData.userC_id;

    if (!this.invoiceDetails.invoicePercentageData.userB_id) {
      document.getElementById('userB_percentage').disabled = true;
    }
    if (!this.invoiceDetails.invoicePercentageData.userC_id) {
      // document.getElementById('userC').disabled = true
      document.getElementById('userC_percentage').disabled = true;
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserDashboard',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      msg: 'Dashboard',
      invoicesList: [],
      isLoading: false,
      fullPage: true,
      tblCls: 'table',
      columns: [{ label: 'Invoice Number', field: 'id' }, { label: 'Brand', field: 'brand', headerClass: 'class-in-header second-class' }, { label: 'CreatedOn', field: 'created' }, { label: 'Due Date', field: 'due_date' }, { label: 'Invoice Amount ($)', field: 'invoice_amount' }, { label: 'Your Amount ($)', field: 'amount' }, { label: 'Status',
        field: 'status',
        interpolate: true,
        representedAs: function representedAs(row) {
          if (row.status === 'open') {
            return ' <span style="color:red">' + row.status + '</span> ';
          } else if (row.status === 'draft') {
            return ' <span style="color:blue">' + row.status + '</span> ';
          } else if (row.status === 'past due') {
            return ' <span style="color:#570702">' + row.status + '</span> ';
          } else {
            return ' <span style="color:green">' + row.status + '</span> ';
          }
        }
      }],
      rows: this.invoicesList,
      filter: '',
      page: 1
    };
  },

  methods: {
    getUserInvoices: function getUserInvoices() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      var uid = localStorage.getItem('uid');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserInvoices' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.invoices = response.data.results;
        for (var i in _this.invoices) {
          var obj = _this.invoices[i];
          var amount = Number(obj.amount).toLocaleString();
          _this.invoicesList.push({
            id: obj.invoice_number,
            brand: obj.brand_name,
            created: obj.createdOn,
            due_date: obj.due_date,
            invoice_amount: obj.invoice_amount,
            amount: amount,
            status: obj.status
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getUserInvoices();
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Brands_vue__ = __webpack_require__(190);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199fc7b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brands_vue__ = __webpack_require__(287);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Brands_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199fc7b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brands_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddBrand__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__brandAction__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Brands',
  components: { AddBrand: __WEBPACK_IMPORTED_MODULE_1__AddBrand__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      checkExt: false,
      isLoading: false,
      errorMessage: '',
      fullPage: true,
      tblCls: 'table',
      brandsList: [],
      brands: [],
      errors: [],
      brandDetails: {
        brand_name: '',
        site_url: '',
        email: '',
        contact_no: '',
        uid: '',
        address: '',
        contact_title: '',
        contact_first_name: '',
        contact_last_name: '',
        contact_email: ''
      },

      columns: [{ label: 'Stripe CustomerID', field: 'id' }, { label: 'Brand Logo', field: '', interpolate: true, representedAs: function representedAs(row) {
          return ' <img style=\'height: 100px!important;height: 50px!important\' src = \'' + row.brandlogo + '\'/> ';
        }, sortable: false }, { label: 'Brand Name', field: 'brandname', headerClass: 'class-in-header second-class' }, { label: 'Site Url', field: 'siteurl' }, { label: 'Status', field: 'status' }, { label: 'Action',
        component: __WEBPACK_IMPORTED_MODULE_2__brandAction__["a" /* default */],
        sortable: false
      }],
      rows: this.brandsList,
      filter: '',
      page: 1,
      fileadd: '',
      fileedit: '',
      brandstatus: ''
    };
  },

  methods: {
    getBrands: function getBrands() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      this.brandsList = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {

        _this.brands = response.data.results;
        for (var i in _this.brands) {
          var obj = _this.brands[i];
          _this.brandsList.push({
            id: obj.stripe_customer_id,
            uid: obj.uid,
            brandlogo: obj.brand_logo,
            brandname: obj.brand_name,
            siteurl: obj.site_url,
            status: obj.status
          });
        }
        _this.isLoading = false;
      }).catch(function (error) {
        _this.errorMessage = error.response.data.errors;
        _this.isLoading = false;
      });
    },
    adbrand: function adbrand() {
      this.$modal.show(__WEBPACK_IMPORTED_MODULE_1__AddBrand__["a" /* default */], { height: '100%' });
    },
    deactiveBrand: function deactiveBrand(uid) {
      var _this2 = this;

      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deactivateBrand' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this2.brands = response.data.results[0];
        });
      }).catch(function (error) {
        _this2.errorMessage = error.response.data.errors;
        _this2.isLoading = false;
      });
    },
    activeBrand: function activeBrand(uid) {
      var _this3 = this;

      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/activateBrand' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {
          _this3.brands = response.data.results[0];
        }).catch(function (error) {
          _this3.errorMessage = error.response.data.errors;
          _this3.isLoading = false;
        });
      });
    }
  },
  created: function created() {},
  updated: function updated() {},
  mounted: function mounted() {
    var _this4 = this;

    this.$eventBus.$on('listBrand', function (data, error) {
      var messageStorage = _this4.flash();
      if (data) {
        _this4.getBrands();
        _this4.$forceUpdate();
        messageStorage.destroyAll();
        _this4.flash(data, 'success', { timeout: 3000 });
      } else if (error) {
        _this4.flashError(error);
      }
    });
    this.getBrands();
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Brands',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      checkExt: false,
      isLoading: false,
      errorMessage: '',
      fullPage: true,
      brands: [],
      errors: [],
      input: {
        email: '',
        brandname: '',
        siteurl: '',
        contactno: '',
        address: '',
        contacttitle: '',
        contactfirstname: '',
        contactlastname: '',
        contactemail: '',
        brand_logo: '',
        nameprefix: ''
      }
    };
  },

  methods: {
    addBrand: function addBrand() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      var fuData = document.getElementById('fileaddBrand');
      //alert(fuData)
      var contactNo = this.input.contactno;
      var FileUploadPath = fuData.value;
      console.log(FileUploadPath);
      var ext = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
      //console.log(ext)
      this.errors = [];
      if (this.input.brandname === '') {
        this.errors.push('Brand Name is Required');
        this.$refs.brandname.focus();
      } else if (this.input.siteurl === '') {
        this.errors.push('Siteurl is Required');
        this.$refs.siteurl.focus();
      } else if (!this.validUrl.isUri(this.input.siteurl)) {
        this.errors.push('Not a URL');
        this.$refs.siteurl.focus();
      } else if (this.input.email === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (!this.emailValidator.validate(this.input.email)) {
        this.errors.push('Invalid Email');
        this.$refs.email.focus();
      } else if (this.input.address === '') {
        this.errors.push('Address is Required');
        this.$refs.address.focus();
      } else if (contactNo === '') {
        this.errors.push('Contactno is Required');
        this.$refs.contactNo.focus();
      } else if (isNaN(contactNo) || contactNo.indexOf(" ") != -1) {
        this.errors.push('Enter numeric value');
        this.$refs.contactNo.focus();
      } else if (contactNo.length !== 10) {
        this.errors.push('Enter 10 Numbers Only');
        this.$refs.contactNo.focus();
      } else if (this.fileaddBrand === '') {
        this.errors.push('File is Required');
        this.$refs.fileaddBrand.focus();
      } else if (!this.checkExtension(ext)) {
        this.errors.push('Only jpeg , png , gif Allowed');
      } else if (this.input.nameprefix === '') {
        this.errors.push('Name prfix is Required');
        this.$refs.nameprefix.focus();
      } else if (this.input.contactfirstname === '') {
        this.errors.push('Contact First name is Required');
        this.$refs.contactfirstname.focus();
      } else if (this.input.contactlastname === '') {
        this.errors.push('Contact Last name is Required');
        this.$refs.contactlastname.focus();
      } else if (this.input.contactemail === '') {
        this.errors.push('Contact Email is Required');
        this.$refs.contactemail.focus();
      } else if (!this.emailValidator.validate(this.input.contactemail)) {
        this.errors.push('Invalid contact Email');
        this.$refs.contactemail.focus();
      } else {
        this.isLoading = true;
        var formData = new FormData();
        formData.append('email', this.input.email);
        formData.append('brand_name', this.input.brandname);
        formData.append('site_url', this.input.siteurl);
        formData.append('contact_no', this.input.contactno);
        formData.append('address', this.input.address);
        formData.append('brand_logo', this.fileaddBrand);
        formData.append('contact_title', this.input.contacttitle);
        formData.append('contact_name_prefix', this.input.nameprefix);
        formData.append('contact_first_name', this.input.contactfirstname);
        formData.append('contact_last_name', this.input.contactlastname);
        formData.append('contact_email', this.input.contactemail);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createNewBrand', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': jwttoken
          }
        }).then(function (response) {
          _this.isLoading = false;
          _this.$eventBus.$emit('listBrand', 'Brand is Added successfully');
          _this.$emit('close');
        }).catch(function (error) {
          _this.$eventBus.$emit('listBrand', '', 'Brand could not be Added');
          _this.$emit('close');
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    handleFileUpload: function handleFileUpload() {
      this.fileaddBrand = this.$refs.fileaddBrand.files[0];
    }
  }

});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditBrandModal_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Brands_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brandAction',
  props: ['row', 'data'],
  components: { Brands: __WEBPACK_IMPORTED_MODULE_2__Brands_vue__["default"],
    Loading: __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      brands: [],
      errors: [],
      errormessage: ''
    };
  },

  methods: {
    deleteBrand: function deleteBrand() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      var uid = this.row.uid;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deleteBrand' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.isLoading = false;
        _this.$eventBus.$emit('listBrand', 'Brand is deleted successfully');
      }).catch(function (error) {
        this.isLoading = false;
        this.$eventBus.$emit('listBrand', false, 'Brand could not be deleted');
      });
    },
    brandDetail: function brandDetail() {
      var location = '/brandDetail' + '/' + this.row.uid + '/' + 'brandlistpage';
      this.$router.push(location);
    },
    editBrand: function editBrand() {
      var _this2 = this;

      this.isLoading = true;
      var jwttoken = localStorage.getItem('jwt');
      var uid = this.row.uid;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getBrandById' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.isLoading = false;
        _this2.$modal.show(__WEBPACK_IMPORTED_MODULE_1__EditBrandModal_vue__["a" /* default */], { brandDetails: response.data.results[0] }, { height: '100%' });
      }).catch(function (error) {
        console.log(error);
        _this2.isLoading = false;
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditBrandModal',
  props: ['brandDetails'],
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      brandsList: [],
      brands: [],
      errors: [],
      brandDetails: {
        brand_name: '',
        site_url: '',
        email: '',
        contact_no: '',
        uid: '',
        address: '',
        contact_title: '',
        contact_first_name: '',
        contact_last_name: '',
        contact_email: '',
        brand_logo: '',
        contact_name_prefix: ''

      },
      fileadd: '',
      fileedit: '',
      brandstatus: ''
    };
  },

  methods: {
    editBrand: function editBrand() {
      var _this = this;

      var fuData = document.getElementById('fileedit');
      var FileUploadPath = fuData.value;
      var ext = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
      var contactemail = this.brandDetails.contact_email;
      var atposition = contactemail.indexOf('@');
      var dotposition = contactemail.lastIndexOf('.');
      var email = this.brandDetails.email;
      var atpositionEmail = email.indexOf('@');
      var dotpositionEmail = email.lastIndexOf('.');
      var contactNo = this.brandDetails.contact_no;
      this.errors = [];
      if (this.brandDetails.brand_name === '') {
        this.errors.push('Brandname is Required');
        this.$refs.brand_name.focus();
      } else if (this.brandDetails.site_url === '') {
        this.errors.push('Siteurl is Required');
        this.$refs.site_url.focus();
      } else if (!this.validUrl.isUri(this.brandDetails.site_url)) {
        this.errors.push('Not a URL');
        this.$refs.site_url.focus();
      } else if (this.brandDetails.email === '') {
        this.errors.push('Email is Required');
        this.$refs.email.focus();
      } else if (!this.emailValidator.validate(email)) {
        this.errors.push('Please enter a valid e-mail address');
        this.$refs.email.focus();
      } else if (this.brandDetails.address === '') {
        this.errors.push('Address is Required');
        this.$refs.address.focus();
      } else if (this.brandDetails.contact_no === '') {
        this.errors.push('Contact no is Required');
        this.$refs.contact_no.focus();
      } else if (isNaN(contactNo) || contactNo.indexOf(" ") != -1) {
        this.errors.push('Enter numeric value');
        this.$refs.contact_no.focus();
      } else if (contactNo.length !== 10) {
        this.errors.push('Enter 10 Numbers Only');
        this.$refs.contact_no.focus();
      } else if (this.fileedit !== '' && !this.checkExtension(ext)) {
        this.errors.push('Only jpeg , png , gif Allowed');
      } else if (this.brandDetails.contact_name_prefix === '') {
        this.errors.push('Contact Name Prefix is Required');
        this.$refs.contact_name_prefix.focus();
      } else if (this.brandDetails.contact_first_name === '') {
        this.errors.push('Contact First Name is Required');
        this.$refs.contact_first_name.focus();
      } else if (this.brandDetails.contact_last_name === '') {
        this.errors.push('Contact Last Name is Required');
        this.$refs.contact_last_name.focus();
      } else if (contactemail === '') {
        this.errors.push('Contatct Email is Required');
        this.$refs.contactemail.focus();
      } else if (!this.emailValidator.validate(contactemail)) {
        this.errors.push('Please enter a valid Contatct e-mail address');
        this.$refs.contactemail.focus();
      } else {
        this.isLoading = true;
        var jwttoken = localStorage.getItem('jwt');
        var formData = new FormData();
        formData.append('email', this.brandDetails.email);
        formData.append('brand_name', this.brandDetails.brand_name);
        formData.append('site_url', this.brandDetails.site_url);
        formData.append('contact_no', this.brandDetails.contact_no);
        formData.append('address', this.brandDetails.address);
        formData.append('uid', this.brandDetails.uid);
        formData.append('brand_logo', this.fileedit);
        formData.append('contact_title', this.brandDetails.contact_title);
        formData.append('contact_name_prefix', this.brandDetails.contact_name_prefix);
        formData.append('contact_first_name', this.brandDetails.contact_first_name);
        formData.append('contact_last_name', this.brandDetails.contact_last_name);
        formData.append('contact_email', this.brandDetails.contact_email);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/editBrand', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': jwttoken
          }
        }).then(function (response) {
          _this.isLoading = false;
          _this.$eventBus.$emit('listBrand', 'Brand is updated successfully');
          _this.$emit('close');
        }).catch(function (error) {
          _this.$eventBus.$emit('listBrand', '', 'Brand could not be updated');
          _this.$emit('close');
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    handleFileUploadedit: function handleFileUploadedit() {
      this.fileedit = this.$refs.fileedit.files[0];
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Payment',
  data: function data() {
    return {
      tblCls: 'table',
      paymentList: [],
      columns: [{ label: 'Transaction ID', field: 'id' }, { label: 'Amount', field: 'amount' }, { label: 'Escrow User Amount', field: 'escrowUser_amount' }, { label: 'UserA Amount', field: 'userA_amount' }, { label: 'UserB Amount', field: 'userB_amount' }, { label: 'UserC Amount', field: 'userC_amount' }, { label: 'Brand Name', field: 'user_name' }, { label: 'Date', field: 'dateCreated' }, { label: 'Method', field: 'payment_method' }, { label: 'Status', field: 'status' }, { label: 'Payment Type', field: 'pyament_type' }],
      rows: this.paymentList,
      filter: '',
      page: 1
    };
  },

  methods: {
    getPayment: function getPayment() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllPayments', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.payments = response.data.results;
        for (var i in _this.payments) {
          var obj = _this.payments[i];
          _this.paymentList.push({
            id: obj.transaction_id,
            amount: obj.amount,
            user_name: obj.user_name,
            dateCreated: obj.dateCreated,
            payment_method: obj.payment_method,
            status: obj.status,
            pyament_type: obj.pyament_type,
            escrowUser_amount: obj.escrowUser_amount,
            userA_amount: obj.userA_amount,
            userB_amount: obj.userB_amount,
            userC_amount: obj.userC_amount
          });
          console.log(_this.paymentList);
        }
      }).catch(function (error) {
        // this.errorMessage = response.data.errors
        console.log(error);
        _this.isLoading = false;
      });
    }
  },
  created: function created() {
    this.getPayment();
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Payment',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      tblCls: 'table',
      isLoading: false,
      fullPage: true,
      paymentList: [],
      columns: [{ label: 'TransactionID', field: 'id' }, { label: 'Amount', field: 'amount' }, { label: 'Method', field: 'payment_method' }, { label: 'Captured', field: 'captured' }, { label: 'Paid', field: 'paid' }, { label: 'Status', field: 'status' }, { label: 'Date', field: 'dateCreated' }, { label: 'Payment_Type', field: 'pyament_type' }],
      rows: this.paymentList,
      filter: '',
      page: 1
    };
  },

  methods: {
    getUserPayment: function getUserPayment() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      var uid = localStorage.getItem('uid');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserPayments' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this.payments = response.data.results;
        for (var i in _this.payments) {
          var obj = _this.payments[i];
          // count++
          _this.paymentList.push({
            id: obj.transaction_id,
            amount: obj.amount,
            payment_method: obj.payment_method,
            captured: obj.captured,
            paid: obj.paid,
            status: obj.status,
            dateCreated: obj.dateCreated,
            pyament_type: obj.pyament_type
          });
          console.log(_this.paymentList);
        }
        _this.isLoading = false;
      }).catch(function (error) {
        console.log(error);
        _this.isLoading = false;
      });
    }
  },
  created: function created() {
    this.getUserPayment();
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__changeInvoiceStatus__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoiceDetail',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      invoiceDatas: '',
      currentPage: '',
      grossAdmin: '',
      afterDate: '',
      grossUserA: '',
      grossUserB: '',
      grossUserC: 0
    };
  },

  methods: {
    changeInvoiceStatus: function changeInvoiceStatus() {
      this.$modal.show(__WEBPACK_IMPORTED_MODULE_1__changeInvoiceStatus__["a" /* default */], { height: '100%' });
    },
    downloadStripePdf: function downloadStripePdf() {
      console.log(this.invoiceDatas.invoice_pdf);
      window.open(this.invoiceDatas.invoice_pdf);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var jwttoken = localStorage.getItem('jwt');
    var currentUrl = window.location.href;
    console.log('invoiceid = ' + currentUrl);
    var splitUrl = currentUrl.split('/');
    var invoiceId = splitUrl[4];
    var page = splitUrl[5];
    this.currentPage = page;
    // console.log('invoicepage ' + this.currentPage)
    this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + invoiceId, {
      headers: {
        'x-access-token': jwttoken
      } }).then(function (response) {
      _this.isLoading = false;
      _this.invoiceDatas = response.data.results;
      var adminPer = response.data.results.invoicePercentageData.escrowUser_percentage;
      var UserAPer = response.data.results.invoicePercentageData.userA_percentage;
      var UserBPer = response.data.results.invoicePercentageData.userB_percentage;
      var UserCPer = response.data.results.invoicePercentageData.userC_percentage ? response.data.results.invoicePercentageData.userC_percentage : 0;
      var amt = response.data.results.net_amount;
      _this.grossAdmin = (adminPer * amt / 100).toFixed(2);
      _this.grossUserA = (UserAPer * amt / 100).toFixed(2);
      _this.grossUserB = (UserBPer * amt / 100).toFixed(2);
      _this.grossUserC = (UserCPer * amt / 100).toFixed(2);

      // this.invoiceDatas.invoicePercentageData.admin_percentage
    }).catch(function (error) {
      // this.errorMessage = response.data.errors
      console.log(error);
      _this.isLoading = false;
    });

    this.$eventBus.$on('changeInvoiceStatus', function (data, error, time) {
      var messageStorage = _this.flash();
      if (data) {
        // this.getInvoice() ;
        _this.$forceUpdate();
        messageStorage.destroyAll();
        if (time) {
          _this.flash(data, 'success', { timeout: time });
        } else {
          _this.flash(data, 'success', { timeout: 3000 });
        }
      } else if (error) {
        if (time) {
          _this.flash(error, 'error', { timeout: time });
        } else {
          _this.flash(error, 'error', { timeout: 3000 });
        }
      }
    });
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changeInvoiceStatus_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9ee4dd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changeInvoiceStatus_vue__ = __webpack_require__(293);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changeInvoiceStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9ee4dd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changeInvoiceStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__changeInvoiceStatus__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invoice',
  components: { changeInvoiceStatus: __WEBPACK_IMPORTED_MODULE_1__changeInvoiceStatus__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      msg: '',
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      successMessage: '',
      errors: [],
      input: {
        status: '',
        note: ''
      }
    };
  },

  methods: {
    saveInvoice: function saveInvoice() {
      var _this = this;

      var jwttoken = localStorage.getItem('jwt');
      var currentUrl = window.location.href;
      console.log('invoiceid = ' + currentUrl);
      var splitUrl = currentUrl.split('/');
      var invoiceId = splitUrl[4];
      this.errors = [];
      var status = this.input.status;
      var note = this.input.note;
      this.errors = [];
      if (this.input.status === '') {
        this.errors.push('Please choose status');
        this.$refs.status.focus();
      } else {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/changeInvoiceStatus', {
          invoice_id: invoiceId,
          status: status,
          note: note
        }, {
          headers: {
            'x-access-token': jwttoken
          } }).then(function (response) {

          _this.$eventBus.$emit('changeInvoiceStatus', 'Invoice status updated successfully');
          _this.$eventBus.$emit('changeInvoiceStatus');
          _this.$emit('close');
          _this.isLoading = false;
        }).catch(function (error) {
          _this.$eventBus.$emit('changeInvoiceStatus', '', error.response.data.errors);
          _this.$emit('close');
          _this.isLoading = false;
        });
      }
    }
  },
  computed: {},
  mounted: function mounted() {
    var jwttoken = localStorage.getItem('jwt');
  },

  watch: {}
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paymentDetail'
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brandDetail',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      brandDetails: '',
      profileimage: localStorage.getItem('profile_img'),
      currentPage: ''
    };
  },

  methods: {},
  mounted: function mounted() {
    var _this = this;

    var jwttoken = localStorage.getItem('jwt');
    var currentUrl = window.location.href;
    var splitUrl = currentUrl.split('/');
    var brandId = splitUrl[4];
    var page = splitUrl[5];
    this.currentPage = page;
    this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getBrandById' + '?' + 'uid' + '=' + brandId, {
      headers: {
        'x-access-token': jwttoken
      } }).then(function (response) {
      _this.isLoading = false;
      console.log(response);
      _this.brandDetails = response.data.results[0];
      console.log(_this.brandDetails);
    }).catch(function (error) {
      console.log(error);
      _this.isLoading = false;
    });
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userDetail',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      fullPage: true,
      userDetails: {
        user: {
          uid: '',
          email: '',
          status: '',
          name: '',
          role: ''
        }
      },
      invoiceDetails: [],
      BrandDatas: [],
      invoicePartyDatas: [],
      currentPage: ''
    };
  },

  methods: {},
  mounted: function mounted() {
    var _this = this;

    var jwttoken = localStorage.getItem('jwt');
    var currentUrl = window.location.href;
    var splitUrl = currentUrl.split('/');
    var uId = splitUrl[4];
    var page = splitUrl[5];
    this.currentPage = page;
    this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserDetail' + '?' + 'uid' + '=' + uId, {
      headers: {
        'x-access-token': jwttoken
      } }).then(function (response) {
      _this.isLoading = false;
      _this.userDetails = response.data.results;
      _this.invoiceDetails = response.data.results.invoiceList;
      _this.BrandDatas = response.data.results.invoiceBrandData;
      _this.invoicePartyDatas = response.data.results.invoicePartyData;
    }).catch(function (error) {
      _this.errorMessage = error.response.data.errors;
      _this.isLoading = false;
    });
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderMain__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sidebar_LeftSidebar__ = __webpack_require__(32);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NavBar: __WEBPACK_IMPORTED_MODULE_0__components_HeaderMain__["a" /* default */],
    SideBar: __WEBPACK_IMPORTED_MODULE_2__components_sidebar_LeftSidebar__["a" /* default */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1__components_FooterMain__["a" /* default */]
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__webpack_require__(6);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderMain',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  data: function data() {
    return {
      errors: [],
      errorMessage: '',
      isLoading: false,
      fullPage: true,
      file: '',
      role: localStorage.getItem('role'),
      profileimage: localStorage.getItem('profile_img'),
      ghostlogo: localStorage.getItem('account_image'),
      username: localStorage.getItem('username'),
      input: {
        search: ''
      },
      siteLogo: '',
      profImage: '',
      ghostuserName: ''
    };
  },

  computed: {
    isAdmin: function isAdmin() {
      return this.role && this.role === 'admin';
    },
    isUser: function isUser() {
      return this.role && this.role === 'user';
    }
  },
  methods: {
    update: function update() {
      var _this = this;

      this.errors = [];
      var fuData = document.getElementById('fileadd');
      var FileUploadPath = fuData.value;
      // var ext = fileName.toString().indexOf('.') + 1
      var ext = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
      if (FileUploadPath === '') {
        // alert('1')
        this.errors.push('File is Required');
      } else if (!this.checkExtension(ext)) {
        this.errors.push('Only jpeg , png , gif Allowed');
      } else {
        var jwttoken = localStorage.getItem('jwt');
        var formData = new FormData();
        formData.append('uid', localStorage.getItem('uid'));
        formData.append('file', this.file);
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/updateProfile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': jwttoken
          }
        }).then(function (response) {
          // console.log(response)
          localStorage.setItem('profile_image', response.data.results[0].profile_image);
          _this.isLoading = false;
          // console.log(localStorage.getItem('profile_image'))
          _this.flash('Profile Image Updated Successfully', 'success', {
            timeout: 1000,
            beforeDestroy: function beforeDestroy() {
              location.reload();
            }
          });
        }).catch(function (error) {
          _this.errorMessage = error.response.data.errors;
          _this.isLoading = false;
        });
      }
    },
    avtarpopupclose: function avtarpopupclose() {
      this.errors = [];
      var fuData = document.getElementById('fileadd');
      var FileUploadPath = fuData.value;
      //alert(FileUploadPath)

      var modal = document.getElementById('updateavatar');
      document.getElementById("myForm").reset();
      modal.style.display = 'none';
      window.onclick = function (event) {
        if (event.target === modal) {
          modal.style.display = 'none';
        }
      };
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.fileadd.files[0];
    },
    logout: function logout() {
      localStorage.removeItem('jwt');
      localStorage.removeItem('user');
      localStorage.removeItem('profileimage');
      localStorage.removeItem('uid');
      localStorage.removeItem('username');
      localStorage.removeItem('useremail');
      localStorage.removeItem('userid');
      localStorage.removeItem('searchData');
      this.isLoading = false;
      this.$router.push('login');
    },
    method1: function method1() {
      document.body.addEventListener('click', function () {
        var body = document.getElementById('dropdownAdd');
        var menushow = document.getElementById('menushow');
        window.onload = function () {
          var x = document.getElementById('addtrue').getAttribute('aria-expanded');
          if (x === 'true') {
            x = 'false';
            body.classList.remove('show');
            menushow.classList.remove('show');
          }
        };
      }, true);
    },
    toggle: function toggle() {
      var body = document.body;
      body.classList.add('background--blur');
      body.classList.add('sidebar-show');
      document.getElementById('navigation-toggle2').style.display = 'block';
      document.getElementById('navigation-toggle1').style.display = 'none';
    },
    toggle1: function toggle1() {
      var body = document.body;
      body.classList.remove('background--blur');
      body.classList.remove('sidebar-show');
      document.getElementById('navigation-toggle1').style.display = 'block';
      document.getElementById('navigation-toggle2').style.display = 'none';
    },
    menuopen: function menuopen() {
      var body = document.getElementById('dropdownAdd');
      body.classList.add('show');
      var menushow = document.getElementById('menushow');
      menushow.classList.add('show');
      var x = document.getElementById('addtrue').getAttribute('aria-expanded');
      if (x === 'true') {
        x = 'false';
        body.classList.remove('show');
        menushow.classList.remove('show');
      } else {
        x = 'true';
      }
      document.getElementById('addtrue').setAttribute('aria-expanded', x);
    },
    searchData: function searchData() {
      var search = this.input.search;
      if (search) {
        this.$router.replace('/searchData?text=' + search);
      }
    },
    menuclose: function menuclose() {
      document.getElementById('parent-list').addEventListener('click', function (e) {
        if (e.target.tagName === 'A') {
          var body = document.getElementById('dropdownAdd');
          var menushow = document.getElementById('menushow');
          menushow.classList.add('show');
          var x = document.getElementById('addtrue').getAttribute('aria-expanded');
          if (x === 'true') {
            x = 'false';
            body.classList.remove('show');
            menushow.classList.remove('show');
          } else {
            x = 'true';
          }
          document.getElementById('addtrue').setAttribute('aria-expanded', x);
        }
      });
    },
    toggleopen: function toggleopen() {
      var body = document.getElementById('navbarSupportedContent');
      body.classList.add('show');
      var x = document.getElementById('navbarSupportedContenttrue').getAttribute('aria-expanded');
      if (x === 'true') {
        x = 'false';
        body.classList.add('collapsed');
        body.classList.remove('show');
      } else {
        x = 'true';
      }
      document.getElementById('navbarSupportedContenttrue').setAttribute('aria-expanded', x);
    },
    click: function click() {
      var modal = document.getElementById('updateavatar');
      var btn = document.getElementById('avatarBtn');
      var span = document.getElementsByClassName('close')[0];
      btn.onclick = function () {
        modal.style.display = 'block';
      };
      span.onclick = function () {
        modal.style.display = 'none';
      };
      window.onclick = function (event) {
        if (event.target === modal) {
          modal.style.display = 'none';
        }
      };
    },
    showLogo: function showLogo() {
      var _this2 = this;

      var jwttoken = localStorage.getItem('jwt');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getaccountSetting', {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this2.siteLogo = response.data.results[0].ghost_logo;
        _this2.isLoading = false;
      }).catch(function (error) {
        // this.errorMessage = response.data.errors
        console.log(error);
        _this2.isLoading = false;
      });
    },
    showProfileImage: function showProfileImage() {
      var _this3 = this;

      var jwttoken = localStorage.getItem('jwt');
      var uid = localStorage.getItem('uid');
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserProfile' + '?' + 'uid' + '=' + uid, {
        headers: {
          'x-access-token': jwttoken
        } }).then(function (response) {
        _this3.profImage = response.data.results[0].profile_image;
        _this3.ghostuserName = response.data.results[0].username;
        _this3.isLoading = false;
        console.log(_this3.userDetails);
      }).catch(function (error) {
        console.log(error);
        _this3.isLoading = false;
      });
    },
    menueCloseOnClick: function menueCloseOnClick() {
      document.body.addEventListener('click', function () {
        var isMobileVersion = document.getElementsByClassName('show');
        if (isMobileVersion.length > 0) {
          var body = document.getElementById('dropdownAdd');
          var menushow = document.getElementById('menushow');
          menushow.classList.add('show');
          var x = document.getElementById('addtrue').getAttribute('aria-expanded');
          if (x === 'true') {
            x = 'false';
            body.classList.remove('show');
            menushow.classList.remove('show');
          } else {
            x = 'true';
          }
          document.getElementById('addtrue').setAttribute('aria-expanded', x);
        }
      }, true);
    }
  },
  mounted: function mounted() {
    this.menueCloseOnClick();
    this.showLogo();
    this.method1();
    this.click();
    this.toggle1();
    this.toggle();
    this.menuclose();
    this.showProfileImage();
    var body = document.body;
    body.classList.remove('background--blur');
    body.classList.remove('sidebar-show');
    document.getElementById('navigation-toggle1').style.display = 'block';
    document.getElementById('navigation-toggle2').style.display = 'none';
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FooterMain'
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_Default_vue__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layouts_LoginLayout_vue__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datatable__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_vanilla_datetime_picker__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_vanilla_datetime_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_vanilla_datetime_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_flash_message__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_flash_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_flash_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_valid_url__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_valid_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_valid_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_email_validator__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_email_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_email_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_dialog__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_dialog_dist_vuejs_dialog_min_css__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_dialog_dist_vuejs_dialog_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuejs_dialog_dist_vuejs_dialog_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('default-layout', __WEBPACK_IMPORTED_MODULE_3__layouts_Default_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('login-layout-Layout', __WEBPACK_IMPORTED_MODULE_4__layouts_LoginLayout_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('date-time-picker', __WEBPACK_IMPORTED_MODULE_6_vue_vanilla_datetime_picker___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuejs_datatable__["a" /* VuejsDatatableFactory */]);
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, 'validUrl', { value: __WEBPACK_IMPORTED_MODULE_9_valid_url___default.a });
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, 'emailValidator', { value: __WEBPACK_IMPORTED_MODULE_10_email_validator__ });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_email_validator__);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vuejs_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_flash_message___default.a, {
  messageOptions: {
    timeout: 3000
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default.a, { dynamic: true, injectModalsContainer: true });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  methods: {
    checkExtension: function checkExtension(ext) {
      if (!ext) return false;
      var fileExtensions = ['jpeg', 'jpg', 'png', 'gif'];
      var extension = ext.toLowerCase();
      if (fileExtensions.indexOf(extension) > -1) {
        return true;
      }
      return false;
    }
  }
});

// Tell Vue to install the plugin.


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f282f1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(228);
function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f282f1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flash_message__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flash_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_flash_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProfilePage__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AdminProfile__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Subscription__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SearchData__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Signup__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Confirm__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Forgotpassword__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sidebar_LeftSidebar__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_resetPassword__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_UserProfile__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_AccountSetting__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Action__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TermsAndCondition__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_FreeSignup__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Escrow__ = __webpack_require__(270);





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_flash_message___default.a);
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/subscribe',
    name: 'Subscription',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Subscription__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/freesignup',
    name: 'FreeSignup',
    component: __WEBPACK_IMPORTED_MODULE_18__components_FreeSignup__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/confirm',
    name: 'Confirm',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Confirm__["a" /* default */]
    // meta: {
    //   //guest: true,
    //   layout: 'login-layout',
    //   type: true
    // }
  }, {
    path: '/termsandcondition',
    name: 'TermsAndCondition',
    component: __WEBPACK_IMPORTED_MODULE_17__components_TermsAndCondition__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/sidebar',
    name: 'LeftSidebar',
    component: __WEBPACK_IMPORTED_MODULE_12__components_sidebar_LeftSidebar__["a" /* default */]
  }, {
    path: '/invoice',
    name: 'Invoice',
    component: __webpack_require__(10).default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/forgotpassword',
    name: 'Forgotpassword',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Forgotpassword__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/resetPassword',
    name: 'resetPassword',
    component: __WEBPACK_IMPORTED_MODULE_13__components_resetPassword__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Signup__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/escrow',
    name: 'Escrow',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Escrow__["a" /* default */],
    meta: {
      guest: true,
      layout: 'login-layout'
    }
  }, {
    path: '/admindashboard',
    name: 'AdminDashboard',
    component: __webpack_require__(46).default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/userdashboard',
    name: 'UserDashboard',
    component: __webpack_require__(279).default,
    meta: {
      requiresAuth: true,
      type: true
    }
  }, {
    path: '/profilepage',
    name: 'ProfilePage',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ProfilePage__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/adminprofile',
    name: 'AdminProfile',
    component: __WEBPACK_IMPORTED_MODULE_6__components_AdminProfile__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/searchdata',
    name: 'SearchData',
    component: __WEBPACK_IMPORTED_MODULE_8__components_SearchData__["a" /* default */],
    meta: {
      requiresAuth: true,
      type: true
    }
  }, {
    path: '/action',
    name: 'Action',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Action__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/account-setting',
    name: 'AccountSetting',
    component: __WEBPACK_IMPORTED_MODULE_15__components_AccountSetting__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/userprofile',
    name: 'UserProfile',
    component: __WEBPACK_IMPORTED_MODULE_14__components_UserProfile__["a" /* default */],
    meta: {
      requiresAuth: true,
      type: true
    }
  }, {
    path: '/user',
    name: 'User',
    component: __webpack_require__(39).default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/brands',
    name: 'Brands',
    component: __webpack_require__(189).default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/payment',
    name: 'Payment',
    component: __webpack_require__(288).default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/userpayment',
    name: 'PaymentUser',
    component: __webpack_require__(290).default,
    meta: {
      requiresAuth: true,
      type: true
    }
  }, {
    path: '/invoicedetail/:invoiceId/:page',
    name: 'invoiceDetail',
    component: __webpack_require__(292).default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/paymentdetail',
    name: 'paymentDetail',
    component: __webpack_require__(295).default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/branddetail/:brandId/:page',
    name: 'brandDetail',
    component: __webpack_require__(297).default,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/userdetail/:userId/:page',
    name: 'userDetail',
    component: __webpack_require__(299).default,
    meta: {
      requiresAuth: true
    }
  }]
});
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (localStorage.getItem('jwt') === 'undefined' || localStorage.getItem('jwt') === null) {
      next({
        path: '/login',
        params: {
          nextUrl: to.fullPath
        }
      });
    } else {
      var user = JSON.parse(localStorage.getItem('user'));
      if (user.role === 'admin') {
        if (to.matched.some(function (record) {
          return record.meta.auth;
        })) {
          if (user.auth === true) {
            next({
              path: '/admindashboard',
              params: {
                nextUrl: to.fullPath
              }
            });
          }
        } else {
          next();
        }
      }
      if (user.role === 'user') {
        if (to.matched.some(function (record) {
          return !record.meta.type;
        })) {
          if (user.auth === true) {
            next({
              path: '/userdashboard',
              params: {
                nextUrl: to.fullPath
              }
            });
          }
        } else {
          next();
        }
      }
    }
  } else if (to.matched.some(function (record) {
    return record.meta.guest;
  })) {
    if (localStorage.getItem('jwt') === 'undefined' || localStorage.getItem('jwt') === null) {
      // alert('/admindashboard')
      next();
    } else {
      next({
        path: '/admindashboard',
        params: {
          nextUrl: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 230 */,
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57be8576_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(233);
function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57be8576_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrapper"},[_c('form',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12 offset-lg-2  offset-md-3"},[_c('div',{staticClass:"forlogin"},[_c('h5',[_vm._v("Please login if you are already an account holder of Ghost Inc.\n            ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":"/login"}},[_vm._v("Login")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-md-6 col-sm-12"},[_c('div',{staticClass:"forsubscribe"},[_c('h5',[_vm._v("Free Signup")]),_vm._v(" "),_c('a',{staticClass:"btn btn-warning btn-lg",attrs:{"href":"/freesignup"}},[_vm._v("Free Signup")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca91db4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(238);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca91db4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"login-page err-500"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5 col-sm-9 lfh"},[_c('div',{staticClass:"card login-box"},[_c('div',{staticClass:"card-body"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('h5',{staticClass:"card-title"},[_vm._v("Sign In")]),_vm._v(" "),_c('form',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login(_vm.e)}}},[(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.email),expression:"input.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"email","name":"email","id":"exampleInputEmail","aria-describedby":"emailHelp","placeholder":"Enter email","tabindex":"1","spellcheck":"false","autofocus":""},domProps:{"value":(_vm.input.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.password),expression:"input.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":"Password","id":"exampleInputPassword1","tabindex":"2"},domProps:{"value":(_vm.input.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "password", $event.target.value)}}})]),_vm._v(" "),_c('a',{staticClass:"float-left forgot-link",attrs:{"href":"/forgotpassword"}},[_vm._v("Forgot password?")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary m-l-xxs float-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.login(_vm.e)}}},[_vm._v("Login")]),_vm._v(" "),_c('a',{staticClass:"btn btn-secondary float-right",attrs:{"href":"/freeSignup"}},[_vm._v("Sign Up")])],2)],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfilePage_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287f624e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfilePage_vue__ = __webpack_require__(240);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfilePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287f624e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfilePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("User Profile")])])]),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("User Profile")]),_vm._v(" "),_c('div',{staticClass:"search-create"},[_c('button',{staticClass:"btn btn-secondary"},[_vm._v("Cancel Subscription")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card profile"},[_c('div',{staticClass:"card-body center"},[_c('h5',{staticClass:"card-title"},[_vm._v("User Detail")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Email"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter User Name"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card profile"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Bank Detail")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_c('select',{staticClass:"form-control"},[_c('option',[_vm._v("Bank Type")]),_vm._v(" "),_c('option',[_vm._v("Bank Type One")]),_vm._v(" "),_c('option',[_vm._v("Bank Type Two")]),_vm._v(" "),_c('option',[_vm._v("Bank Type Three")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{staticClass:"form-control"},[_c('option',[_vm._v("Currency Type")]),_vm._v(" "),_c('option',[_vm._v("Currency Type One")]),_vm._v(" "),_c('option',[_vm._v("Currency Type Two")]),_vm._v(" "),_c('option',[_vm._v("Currency Type Three")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":"Account Holder Name"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{staticClass:"form-control"},[_c('option',[_vm._v("Account Holder Type")]),_vm._v(" "),_c('option',[_vm._v("Account Holder Type One")]),_vm._v(" "),_c('option',[_vm._v("Account Holder Type Two")]),_vm._v(" "),_c('option',[_vm._v("Account Holder Type Three")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":"Account Number"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card profile"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Change Password")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":"Current Password"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":"New Password"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":"Confirm Password"}})])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary"},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary"},[_vm._v("Cancel")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminProfile_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14dbfee2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminProfile_vue__ = __webpack_require__(242);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14dbfee2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('flash-message',{staticClass:"myCustomClass"})],1)])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('form',{attrs:{"name":"userform"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()}}},[_c('div',{staticClass:"card profile"},[_c('div',{staticClass:"card-body center"},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessageUserForm))]),_vm._v(" "),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('h5',{staticClass:"card-title"},[_vm._v("Admin Detail")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"value"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.email),expression:"userDetails.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"text","name":"email","id":"email","placeholder":"Enter Email"},domProps:{"value":(_vm.userDetails.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"value"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.username),expression:"userDetails.username"}],ref:"username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","placeholder":"Enter User Name"},domProps:{"value":(_vm.userDetails.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.firstname),expression:"userDetails.firstname"}],ref:"firstname",staticClass:"form-control",attrs:{"name":"firstname","id":"firstname","placeholder":"FirstName"},domProps:{"value":(_vm.userDetails.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.lastname),expression:"userDetails.lastname"}],ref:"lastname",staticClass:"form-control",attrs:{"name":"lastname","id":"lastname","placeholder":"LastName"},domProps:{"value":(_vm.userDetails.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card profile"},[_c('form',{attrs:{"name":"passwordform"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changepassword()}}},[_c('div',{staticClass:"card-body center"},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_vm._l((_vm.errorsPassword),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('h5',{staticClass:"card-title"},[_vm._v("Password Reset")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentpass),expression:"currentpass"}],ref:"currentpass",staticClass:"form-control",attrs:{"type":"password","name":"currentpass","id":"currentpass","placeholder":"Current Password*"},domProps:{"value":(_vm.currentpass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentpass=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newpass),expression:"newpass"}],ref:"newpass",staticClass:"form-control",attrs:{"type":"password","name":"newpass","id":"newpass","placeholder":"New Password*"},domProps:{"value":(_vm.newpass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newpass=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confpass),expression:"confpass"}],ref:"confpass",staticClass:"form-control",attrs:{"type":"password","name":"confpass","id":"confpass","placeholder":"Confirm Password*"},domProps:{"value":(_vm.confpass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confpass=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.changepassword()}}},[_vm._v("Change Password")])])],2)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Admin Profile")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscription_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a7e220_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscription_vue__ = __webpack_require__(244);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57a7e220_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subscription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-wrapper",attrs:{"id":"subscription"}},[_c('form',{attrs:{"id":"subscribe","action":"https://us-central1-stripe-firebase-133c0.cloudfunctions.net/subscription","method":"post","novalidate":"true"}},[_c('h3',[_vm._v("Monthly Subscription")]),_vm._v(" "),_c('h1',[_vm._v("$199")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchData_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c488ab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchData_vue__ = __webpack_require__(246);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c488ab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_vm._m(0)],1)]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("User List")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),(_vm.resultData.usersResults.length)?_c('tbody',_vm._l((_vm.resultData.usersResults),function(getAllUser,index,key){return _c('tr',[_c('td',[_vm._v(_vm._s(getAllUser.name))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(getAllUser.status))])]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'userDetail', params: { userId: getAllUser.uid, page: 'dashboard' }}}},[_c('button',{staticClass:"badge badge-info"},[_vm._v("View Details")])])],1)])}),0):_c('tbody',[_vm._m(2)])])])])])]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Brand List")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(3),_vm._v(" "),(_vm.resultData.brandsResults.length)?_c('tbody',_vm._l((_vm.resultData.brandsResults),function(getAllBrand,index,key){return _c('tr',[_c('td',[_vm._v(_vm._s(getAllBrand.brand_name))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(getAllBrand.status))])]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'brandDetail', params: { brandId: getAllBrand.uid, page: 'dashboard'}}}},[_c('button',{staticClass:"badge badge-info"},[_vm._v("View Details")])])],1)])}),0):_c('tbody',[_vm._m(4)])])])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("\n                                   Invoice List\n                                ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(5),_vm._v(" "),(_vm.resultData.invoicesResults.length)?_c('tbody',_vm._l((_vm.resultData.invoicesResults),function(invoiceData,index,key){return _c('tr',[_c('td',[_vm._v(_vm._s(invoiceData.invoice_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoiceData.brand_name))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'invoiceDetail', params: { invoiceId: invoiceData.uid, page: 'dashboard'}}}},[_c('button',{staticClass:"badge badge-info"},[_vm._v("View Details")])])],1)])}),0):_c('tbody',[_vm._m(6)])])])])])]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"col-md-6"},[_vm._m(7)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isUser)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("\n                                   Invoice List\n                                ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(8),_vm._v(" "),(_vm.resultData.invoicesResults.length)?_c('tbody',_vm._l((_vm.resultData.invoicesResults),function(invoiceData,index,key){return _c('tr',[_c('td',[_vm._v(_vm._s(invoiceData.stripe_invoice_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoiceData.brand_name))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'invoiceDetail', params: { invoiceId: invoiceData.uid, page: 'dashboard'}}}},[_c('button',{staticClass:"badge badge-info"},[_vm._v("View Details")])])],1)])}),0):_c('tbody',[_vm._m(9)])])])])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Search Result")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("User Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("No Data Found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Brand Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("No Data Found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Invoice ID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Brands")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("No Data Found")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Invoice ID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Brands")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("No Data Found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4435fa44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(248);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4435fa44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"signup"}},[_c('body',{staticClass:"login-page err-500"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5 col-sm-9 lfh"},[_c('div',{staticClass:"card login-box"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Sign Up")]),_vm._v(" "),_c('form',{attrs:{"novalidate":"true"}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.email),expression:"input.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"email","name":"email","id":"exampleInputEmail","aria-describedby":"emailHelp","placeholder":"Enter email","disabled":""},domProps:{"value":(_vm.input.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.name),expression:"input.name"}],ref:"name",staticClass:"form-control",attrs:{"type":"text","name":"name","id":"name","aria-describedby":"name","placeholder":"Name"},domProps:{"value":(_vm.input.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.username),expression:"input.username"}],ref:"username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"userName","aria-describedby":"userName","placeholder":"Username"},domProps:{"value":(_vm.input.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.password),expression:"input.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"exampleInputPassword","placeholder":"Password"},domProps:{"value":(_vm.input.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.cnfpassword),expression:"input.cnfpassword"}],ref:"cnfpassword",staticClass:"form-control",attrs:{"type":"password","name":"cnfpassword","id":"exampleInputCnfpassword","placeholder":"Confirm Password"},domProps:{"value":(_vm.input.cnfpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "cnfpassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox form-group"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"termsandcond"},on:{"click":function($event){return _vm.checkboxClick()}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button","id":"signup_btn"},on:{"click":function($event){return _vm.signup()}}},[_vm._v("Sign Up")])],2)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"termsandcond"}},[_vm._v("I Agree with "),_c('a',{attrs:{"href":"/termsandcondition"}},[_vm._v("Terms & Policies")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8d58ba2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__ = __webpack_require__(250);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8d58ba2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-wrapper",attrs:{"id":"confirm"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgotpassword_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470bd22e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forgotpassword_vue__ = __webpack_require__(252);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgotpassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470bd22e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forgotpassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('body',{staticClass:"login-page err-500"},[_c('div',{staticClass:"container"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5 col-sm-9 lfh"},[_c('div',{staticClass:"card login-box"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Forgot Password")]),_vm._v(" "),_c('form',{attrs:{"method":"POST","action":"#"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.sendemail(_vm.e)}}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage ? _vm.errorMessage : ''))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.email),expression:"input.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"email","name":"email","id":"exampleInputEmail","aria-describedby":"emailHelp","placeholder":"Enter email","tabindex":"1","spellcheck":"false","autofocus":""},domProps:{"value":(_vm.input.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "email", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary m-l-xxs float-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendemail(_vm.e)}}},[_vm._v("Forgot Password")])],2)])])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-sidebar"},[_c('div',{staticClass:"lime-sidebar-inner slimscroll"},[_c('ul',{staticClass:"accordion-menu",attrs:{"id":"accordion-menu"}},[(_vm.isAdmin)?_c('li',[_c('router-link',{attrs:{"to":"/admindashboard"}},[_c('i',{staticClass:"material-icons"},[_vm._v("dashboard")]),_vm._v("Dashboard")])],1):_vm._e(),_vm._v(" "),(_vm.isUser)?_c('li',[_c('router-link',{attrs:{"to":"/userdashboard"}},[_c('i',{staticClass:"material-icons"},[_vm._v("dashboard")]),_vm._v("Dashboard")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('li',[_c('router-link',{attrs:{"to":"/invoice"}},[_c('i',{staticClass:"material-icons"},[_vm._v("description")]),_vm._v("Invoices")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('li',[_c('router-link',{attrs:{"to":"/payment"}},[_c('i',{staticClass:"material-icons"},[_vm._v("attach_money")]),_vm._v("Payments")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('li',[_c('router-link',{attrs:{"to":"/user"}},[_c('i',{staticClass:"material-icons"},[_vm._v("group")]),_vm._v("Users")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('li',[_c('router-link',{attrs:{"to":"/brands"}},[_c('i',{staticClass:"material-icons"},[_vm._v("local_florist")]),_vm._v("Brands")])],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resetPassword_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e298888_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resetPassword_vue__ = __webpack_require__(255);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e298888_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_resetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('body',{staticClass:"login-page err-500"},[_c('div',{staticClass:"container"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5 col-sm-9 lfh"},[_c('div',{staticClass:"card login-box"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Reset Password")]),_vm._v(" "),_c('form',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.reset(_vm.e)}}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage ? _vm.errorMessage : ''))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.password),expression:"input.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","placeholder":"Password","id":"password"},domProps:{"value":(_vm.input.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.cnfpassword),expression:"input.cnfpassword"}],ref:"cnfpassword",staticClass:"form-control",attrs:{"type":"password","name":"cnfpassword","placeholder":"Confirm Password","id":"cnfpassword"},domProps:{"value":(_vm.input.cnfpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "cnfpassword", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary m-l-xxs float-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.reset(_vm.e)}}},[_vm._v("Password Reset")])],2)])])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8628f16c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__(257);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8628f16c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_c('flash-message',{staticClass:"myCustomClass"})],1)])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card profile"},[_c('div',{staticClass:"card-body center"},[_c('h5',{staticClass:"card-title"},[_vm._v("User Detail")]),_vm._v(" "),_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessageUserForm))]),_vm._v(" "),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('form',{attrs:{"action":"#","method":"post","name":"userform"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save()}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.email),expression:"userDetails.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"text","name":"email","id":"email","placeholder":"Enter Email"},domProps:{"value":(_vm.userDetails.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.username),expression:"userDetails.username"}],ref:"username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"username","placeholder":"Enter User Name"},domProps:{"value":(_vm.userDetails.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.firstname),expression:"userDetails.firstname"}],ref:"firstname",staticClass:"form-control",attrs:{"name":"firstname","id":"firstname","placeholder":"FirstName"},domProps:{"value":(_vm.userDetails.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.lastname),expression:"userDetails.lastname"}],ref:"lastname",staticClass:"form-control",attrs:{"name":"lastname","id":"lastname","placeholder":"LastName"},domProps:{"value":(_vm.userDetails.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Update User Profile")])])],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card profile"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Bank Detail")]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"text-align":"center"}},[(_vm.userDetails.stripe_bank_account_id !== '')?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateBankDetail()}}},[_vm._v("Update Bank Detail")]):_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.createConnectAccount()}}},[_vm._v("Create Connect Account")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card profile"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Password Reset")]),_vm._v(" "),_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_vm._l((_vm.errorsPassword),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('form',{attrs:{"name":"passwordform"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changepassword()}}},[_c('div',{staticClass:" center"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentpass),expression:"currentpass"}],ref:"currentpass",staticClass:"form-control",attrs:{"type":"password","name":"currentpass","id":"currentpass","placeholder":"Current Password*"},domProps:{"value":(_vm.currentpass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentpass=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newpass),expression:"newpass"}],ref:"newpass",staticClass:"form-control",attrs:{"type":"password","name":"newpass","id":"newpass","placeholder":"New Password*"},domProps:{"value":(_vm.newpass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newpass=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confpass),expression:"confpass"}],ref:"confpass",staticClass:"form-control",attrs:{"type":"password","name":"confpass","id":"confpass","placeholder":"Confirm Password*"},domProps:{"value":(_vm.confpass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confpass=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.changepassword()}}},[_vm._v("Change Password")])])])])],2)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("User Profile")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("User Profile")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSetting_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf1a57c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSetting_vue__ = __webpack_require__(259);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountSetting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf1a57c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountSetting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 offset-md-4"},[_c('div',{staticClass:"card profile"},[_c('div',{staticClass:"card-body "},[_c('h5',{staticClass:"card-title center"},[_vm._v("Account Setting")]),_vm._v(" "),_c('form',{attrs:{"action":"#"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.update()}}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('flash-message',{staticClass:"myCustomClass"}),_vm._v(" "),_c('div',{staticClass:"admin-logo"},[_c('img',{attrs:{"src":_vm.siteLogo}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{ref:"fileaddacct",staticClass:"form-control",attrs:{"type":"file","name":"ghost_logo","id":"fileaddacct"},on:{"change":function($event){return _vm.handleFileUpload()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ghostName),expression:"ghostName"}],ref:"ghost_name",staticClass:"form-control",attrs:{"type":"text","name":"ghost_name","id":"ghost_name","placeholder":"Ghost Name"},domProps:{"value":(_vm.ghostName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ghostName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ghostEmail),expression:"ghostEmail"}],ref:"email",staticClass:"form-control",attrs:{"type":"text","name":"email","placeholder":"Email","id":"email"},domProps:{"value":(_vm.ghostEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ghostEmail=$event.target.value}}})]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"save"},on:{"click":function($event){return _vm.update()}}})],2)])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserModal_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e89fa8d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserModal_vue__ = __webpack_require__(261);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUserModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e89fa8d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUserModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"editUser"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('flash-message',{staticClass:"myCustomClass"}),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Edit User")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","id":"edituserpopupclose","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1),_vm._v(" "),_c('form',{attrs:{"action":"#"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editUser()}}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.firstname),expression:"userDetails.firstname"}],ref:"firstname",staticClass:"form-control",attrs:{"type":"text","placeholder":"Firstname","id":"firstname","name":"firstname"},domProps:{"value":(_vm.userDetails.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.lastname),expression:"userDetails.lastname"}],ref:"lastname",staticClass:"form-control",attrs:{"type":"text","placeholder":"Lastname","id":"lastname","name":"lastname"},domProps:{"value":(_vm.userDetails.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.username),expression:"userDetails.username"}],ref:"username",staticClass:"form-control",attrs:{"type":"text","placeholder":"User Name","id":"username","name":"username"},domProps:{"value":(_vm.userDetails.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "username", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.uid),expression:"userDetails.uid"}],staticClass:"form-control",attrs:{"type":"hidden","placeholder":"User Name","id":"uid","name":"uid"},domProps:{"value":(_vm.userDetails.uid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "uid", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userDetails.email),expression:"userDetails.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"text","placeholder":"Email","id":"email","name":"email"},domProps:{"value":(_vm.userDetails.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Edit"},on:{"click":function($event){return _vm.editUser()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e2da600_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__ = __webpack_require__(263);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e2da600_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{attrs:{"id":"addUser"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('flash-message',{staticClass:"myCustomClass"}),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Add User")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","id":"close2","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1),_vm._v(" "),_c('form',{attrs:{"action":"#"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addUser()}}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.userrole),expression:"input.userrole"}],ref:"userrole",staticClass:"form-control",attrs:{"id":"userrole","name":"userrole"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "userrole", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChange($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Role*")]),_vm._v(" "),_c('option',{attrs:{"value":"admin"}},[_vm._v("Admin")]),_vm._v(" "),_c('option',{attrs:{"value":"user"}},[_vm._v("User")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.firstname),expression:"input.firstname"}],ref:"name",staticClass:"form-control",attrs:{"type":"text","placeholder":"Firstname*","id":"name","name":"firstname"},domProps:{"value":(_vm.input.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.lastname),expression:"input.lastname"}],ref:"name",staticClass:"form-control",attrs:{"type":"text","placeholder":"Lastname*","id":"name","name":"lastname"},domProps:{"value":(_vm.input.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.username),expression:"input.username"}],ref:"username",staticClass:"form-control",attrs:{"type":"text","placeholder":"User Name*","id":"username","name":"username"},domProps:{"value":(_vm.input.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.email),expression:"input.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"text","placeholder":"Email*","id":"email","name":"email"},domProps:{"value":(_vm.input.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.password),expression:"input.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"password","placeholder":"Password*"},domProps:{"value":(_vm.input.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.cnfpassword),expression:"input.cnfpassword"}],ref:"cnfpassword",staticClass:"form-control",attrs:{"type":"password","name":"cnfpassword","id":"cnfpassword","placeholder":"Confirm Password*"},domProps:{"value":(_vm.input.cnfpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "cnfpassword", $event.target.value)}}})])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Add"},on:{"click":function($event){return _vm.addUser()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('flash-message',{attrs:{"id":"flash-message"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Users List")]),_vm._v(" "),_c('div',{staticClass:"search-create"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control mr-sm-2",attrs:{"type":"text","placeholder":"Search User","aria-label":"Search"},domProps:{"value":(_vm.filter)},on:{"keydown":function($event){return $event.stopImmediatePropagation()},"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"userBtn"},on:{"click":function($event){return _vm.adUser()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" Add User")])],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"table-responsive"},[_c('datatable',{class:_vm.tblCls,attrs:{"columns":_vm.columns,"filter":_vm.filter,"per-page":10,"data":_vm.usersList}}),_vm._v(" "),_c('datatable-pager',{staticClass:"pagination",model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Users List")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action",attrs:{"id":"action"}},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('button',{staticClass:"badge badge-info",on:{"click":function($event){return _vm.userDetail()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])]),_vm._v(" "),(_vm.row.status === 'active')?_c('button',{staticClass:"badge badge-secondry editBtn",attrs:{"id":"editBtn"},on:{"click":function($event){return _vm.editUser()}}},[_c('i',{staticClass:"material-icons editBtn"},[_vm._v("edit")])]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ loader: false, ok: _vm.deleteUser, message: 'Do you really want to delete?'}),expression:"{ loader: false, ok: deleteUser, message: 'Do you really want to delete?'}"}],staticClass:"badge badge-danger"},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndCondition_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4493a426_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndCondition_vue__ = __webpack_require__(267);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndCondition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4493a426_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndCondition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('p'),_c('meta',{attrs:{"http-equiv":"content-type","content":"text/html; charset=utf-8"}}),_vm._v(" "),_c('p'),_vm._v(" "),_c('h1',{staticStyle:{"box-sizing":"border-box","font-size":"36px","margin":"0px 0px 18px","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Terms and Conditions for Ghost Inc.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Introduction")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("These Website Standard Terms and Conditions written on this webpage shall manage your use of our website, ghostinc.com accessible at www.ghostinc.com.")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed to accept all terms and conditions written in here. You must not use this Website if you disagree with any of these Website Standard Terms and Conditions. These Terms and Conditions have been generated with the help of the \n  "),_c('a',{staticStyle:{"box-sizing":"border-box","background-color":"transparent","color":"rgb(102, 102, 102)","text-decoration":"none"},attrs:{"href":"https://www.termsandcondiitionssample.com/"}},[_vm._v("Terms And Conditions Template")]),_vm._v(" and the \n  "),_c('a',{staticStyle:{"box-sizing":"border-box","background-color":"transparent","color":"rgb(102, 102, 102)","text-decoration":"none"},attrs:{"href":"https://www.terms-conditions-generator.com/"}},[_vm._v("Terms and Conditions Generator")]),_vm._v(".\n")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Minors or people below 18 years old are not allowed to use this Website.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Intellectual Property Rights")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Other than the content you own, under these Terms, Ghost Inc. and/or its licensors own all the intellectual property rights and materials contained in this Website.")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("You are granted limited license only for purposes of viewing the material contained on this Website.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Restrictions")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("You are specifically restricted from all of the following:")]),_vm._v(" "),_c('ul',{staticStyle:{"box-sizing":"border-box","margin-top":"0px","margin-bottom":"10px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_c('li',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("publishing any Website material in any other media;")]),_vm._v(" "),_c('li',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("selling, sublicensing and/or otherwise commercializing any Website material;")]),_vm._v(" "),_c('li',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("publicly performing and/or showing any Website material;")]),_vm._v(" "),_c('li',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("using this Website in any way that is or may be damaging to this Website;")]),_vm._v(" "),_c('li',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("using this Website in any way that impacts user access to this Website;")]),_vm._v(" "),_c('li',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity;")]),_vm._v(" "),_c('li',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website;")]),_vm._v(" "),_c('li',{staticStyle:{"box-sizing":"border-box"}},[_vm._v("using this Website to engage in any advertising or marketing.")])]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Certain areas of this Website are restricted from being access by you and Ghost Inc. may further restrict access by you to any areas of this Website, at any time, in absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Your Content")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("In these Website Standard Terms and Conditions, \"Your Content\" shall mean any audio, video text, images or other material you choose to display on this Website. By displaying Your Content, you grant Ghost Inc. a non-exclusive, worldwide irrevocable, sub licensable license to use, reproduce, adapt, publish, translate and distribute it in any and all media.")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Your Content must be your own and must not be invading any third-party’s rights. Ghost Inc. reserves the right to remove any of Your Content from this Website at any time without notice.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Your Privacy")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Please read Privacy Policy.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("No warranties")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("This Website is provided \"as is,\" with all faults, and Ghost Inc. express no representations or warranties, of any kind related to this Website or the materials contained on this Website. Also, nothing contained on this Website shall be interpreted as advising you.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Limitation of liability")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("In no event shall Ghost Inc., nor any of its officers, directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website whether such liability is under contract.  Ghost Inc., including its officers, directors and employees shall not be held liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Indemnification")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("You hereby indemnify to the fullest extent Ghost Inc. from and against any and/or all liabilities, costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of the provisions of these Terms.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Severability")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Variation of Terms")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Ghost Inc. is permitted to revise these Terms at any time as it sees fit, and by using this Website you are expected to review these Terms on a regular basis.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Assignment")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("The Ghost Inc. is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Entire Agreement")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("These Terms constitute the entire agreement between Ghost Inc. and you in relation to your use of this Website, and supersede all prior agreements and understandings.")]),_vm._v(" "),_c('h2',{staticStyle:{"box-sizing":"border-box","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-weight":"400","line-height":"1.1","color":"rgb(102, 102, 102)","margin":"0px 0px 18px","font-size":"16px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("Governing Law & Jurisdiction")]),_vm._v(" "),_c('p',{staticStyle:{"box-sizing":"border-box","margin":"0px 0px 20px","color":"rgb(102, 102, 102)","font-family":"\"Helvetica Neue\", Helvetica, Arial, sans-serif","font-size":"14px","font-style":"normal","font-variant-ligatures":"normal","font-variant-caps":"normal","font-weight":"400","letter-spacing":"normal","orphans":"2","text-align":"start","text-indent":"0px","text-transform":"none","white-space":"normal","widows":"2","word-spacing":"0px","-webkit-text-stroke-width":"0px","background-color":"rgb(255, 255, 255)","text-decoration-style":"initial","text-decoration-color":"initial"}},[_vm._v("These Terms will be governed by and interpreted in accordance with the laws of the State of us, and you submit to the non-exclusive jurisdiction of the state and federal courts located in us for the resolution of any disputes.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FreeSignup_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_932eece4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreeSignup_vue__ = __webpack_require__(269);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FreeSignup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_932eece4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreeSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"signup"}},[_c('body',{staticClass:"login-page err-500"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5 col-sm-9 lfh"},[_c('div',{staticClass:"card login-box"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Sign Up")]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('form',{attrs:{"novalidate":"true"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signup(_vm.e)}}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.email),expression:"input.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"email","name":"email","id":"exampleInputEmail","aria-describedby":"emailHelp","placeholder":"Enter email"},domProps:{"value":(_vm.input.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.firstname),expression:"input.firstname"}],ref:"firstname",staticClass:"form-control",attrs:{"type":"text","name":"firstname","id":"firstname","aria-describedby":"firstname","placeholder":"Firstname"},domProps:{"value":(_vm.input.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.lastname),expression:"input.lastname"}],ref:"lastname",staticClass:"form-control",attrs:{"type":"text","name":"lastname","id":"lastname","aria-describedby":"lastname","placeholder":"Lastname"},domProps:{"value":(_vm.input.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.username),expression:"input.username"}],ref:"username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"userName","aria-describedby":"userName","placeholder":"Username"},domProps:{"value":(_vm.input.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.password),expression:"input.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"exampleInputPassword","placeholder":"Password"},domProps:{"value":(_vm.input.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.cnfpassword),expression:"input.cnfpassword"}],ref:"cnfpassword",staticClass:"form-control",attrs:{"type":"password","name":"cnfpassword","id":"exampleInputCnfpassword","placeholder":"Confirm Password"},domProps:{"value":(_vm.input.cnfpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "cnfpassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox form-group"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"termsandcond"},on:{"click":function($event){return _vm.checkboxClick()}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button","id":"signup_btn"},on:{"click":function($event){return _vm.signup()}}},[_vm._v("Sign Up")])],2)],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"termsandcond"}},[_vm._v("I Agree with "),_c('a',{attrs:{"href":"https://www.tallyinvoice.com/terms","target":"_blank"}},[_vm._v("Terms & Policies")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Escrow_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cdb8292_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Escrow_vue__ = __webpack_require__(271);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Escrow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cdb8292_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Escrow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"signup"}},[_c('body',{staticClass:"login-page err-500"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5 col-sm-9 lfh"},[_c('div',{staticClass:"card login-box"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Sign Up")]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('form',{attrs:{"novalidate":"true"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signup(_vm.e)}}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.email),expression:"input.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"email","name":"email","id":"exampleInputEmail","aria-describedby":"emailHelp","placeholder":"Enter email"},domProps:{"value":(_vm.input.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.firstname),expression:"input.firstname"}],ref:"firstname",staticClass:"form-control",attrs:{"type":"text","name":"firstname","id":"firstname","aria-describedby":"firstname","placeholder":"Firstname"},domProps:{"value":(_vm.input.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "firstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.lastname),expression:"input.lastname"}],ref:"lastname",staticClass:"form-control",attrs:{"type":"text","name":"lastname","id":"lastname","aria-describedby":"lastname","placeholder":"Lastname"},domProps:{"value":(_vm.input.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "lastname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.username),expression:"input.username"}],ref:"username",staticClass:"form-control",attrs:{"type":"text","name":"username","id":"userName","aria-describedby":"userName","placeholder":"Username"},domProps:{"value":(_vm.input.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.password),expression:"input.password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","name":"password","id":"exampleInputPassword","placeholder":"Password"},domProps:{"value":(_vm.input.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.cnfpassword),expression:"input.cnfpassword"}],ref:"cnfpassword",staticClass:"form-control",attrs:{"type":"password","name":"cnfpassword","id":"exampleInputCnfpassword","placeholder":"Confirm Password"},domProps:{"value":(_vm.input.cnfpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "cnfpassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox form-group"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"termsandcond"},on:{"click":function($event){return _vm.checkboxClick()}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button","id":"signup_btn"},on:{"click":function($event){return _vm.signup()}}},[_vm._v("Sign Up")])],2)],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"custom-control-label",attrs:{"for":"termsandcond"}},[_vm._v("I Agree with "),_c('a',{attrs:{"href":"https://www.tallyinvoice.com/terms","target":"_blank"}},[_vm._v("Terms & Policies")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 52,
	"./af.js": 52,
	"./ar": 53,
	"./ar-dz": 54,
	"./ar-dz.js": 54,
	"./ar-kw": 55,
	"./ar-kw.js": 55,
	"./ar-ly": 56,
	"./ar-ly.js": 56,
	"./ar-ma": 57,
	"./ar-ma.js": 57,
	"./ar-sa": 58,
	"./ar-sa.js": 58,
	"./ar-tn": 59,
	"./ar-tn.js": 59,
	"./ar.js": 53,
	"./az": 60,
	"./az.js": 60,
	"./be": 61,
	"./be.js": 61,
	"./bg": 62,
	"./bg.js": 62,
	"./bm": 63,
	"./bm.js": 63,
	"./bn": 64,
	"./bn-bd": 65,
	"./bn-bd.js": 65,
	"./bn.js": 64,
	"./bo": 66,
	"./bo.js": 66,
	"./br": 67,
	"./br.js": 67,
	"./bs": 68,
	"./bs.js": 68,
	"./ca": 69,
	"./ca.js": 69,
	"./cs": 70,
	"./cs.js": 70,
	"./cv": 71,
	"./cv.js": 71,
	"./cy": 72,
	"./cy.js": 72,
	"./da": 73,
	"./da.js": 73,
	"./de": 74,
	"./de-at": 75,
	"./de-at.js": 75,
	"./de-ch": 76,
	"./de-ch.js": 76,
	"./de.js": 74,
	"./dv": 77,
	"./dv.js": 77,
	"./el": 78,
	"./el.js": 78,
	"./en-au": 79,
	"./en-au.js": 79,
	"./en-ca": 80,
	"./en-ca.js": 80,
	"./en-gb": 81,
	"./en-gb.js": 81,
	"./en-ie": 82,
	"./en-ie.js": 82,
	"./en-il": 83,
	"./en-il.js": 83,
	"./en-in": 84,
	"./en-in.js": 84,
	"./en-nz": 85,
	"./en-nz.js": 85,
	"./en-sg": 86,
	"./en-sg.js": 86,
	"./eo": 87,
	"./eo.js": 87,
	"./es": 88,
	"./es-do": 89,
	"./es-do.js": 89,
	"./es-mx": 90,
	"./es-mx.js": 90,
	"./es-us": 91,
	"./es-us.js": 91,
	"./es.js": 88,
	"./et": 92,
	"./et.js": 92,
	"./eu": 93,
	"./eu.js": 93,
	"./fa": 94,
	"./fa.js": 94,
	"./fi": 95,
	"./fi.js": 95,
	"./fil": 96,
	"./fil.js": 96,
	"./fo": 97,
	"./fo.js": 97,
	"./fr": 98,
	"./fr-ca": 99,
	"./fr-ca.js": 99,
	"./fr-ch": 100,
	"./fr-ch.js": 100,
	"./fr.js": 98,
	"./fy": 101,
	"./fy.js": 101,
	"./ga": 102,
	"./ga.js": 102,
	"./gd": 103,
	"./gd.js": 103,
	"./gl": 104,
	"./gl.js": 104,
	"./gom-deva": 105,
	"./gom-deva.js": 105,
	"./gom-latn": 106,
	"./gom-latn.js": 106,
	"./gu": 107,
	"./gu.js": 107,
	"./he": 108,
	"./he.js": 108,
	"./hi": 109,
	"./hi.js": 109,
	"./hr": 110,
	"./hr.js": 110,
	"./hu": 111,
	"./hu.js": 111,
	"./hy-am": 112,
	"./hy-am.js": 112,
	"./id": 113,
	"./id.js": 113,
	"./is": 114,
	"./is.js": 114,
	"./it": 115,
	"./it-ch": 116,
	"./it-ch.js": 116,
	"./it.js": 115,
	"./ja": 117,
	"./ja.js": 117,
	"./jv": 118,
	"./jv.js": 118,
	"./ka": 119,
	"./ka.js": 119,
	"./kk": 120,
	"./kk.js": 120,
	"./km": 121,
	"./km.js": 121,
	"./kn": 122,
	"./kn.js": 122,
	"./ko": 123,
	"./ko.js": 123,
	"./ku": 124,
	"./ku.js": 124,
	"./ky": 125,
	"./ky.js": 125,
	"./lb": 126,
	"./lb.js": 126,
	"./lo": 127,
	"./lo.js": 127,
	"./lt": 128,
	"./lt.js": 128,
	"./lv": 129,
	"./lv.js": 129,
	"./me": 130,
	"./me.js": 130,
	"./mi": 131,
	"./mi.js": 131,
	"./mk": 132,
	"./mk.js": 132,
	"./ml": 133,
	"./ml.js": 133,
	"./mn": 134,
	"./mn.js": 134,
	"./mr": 135,
	"./mr.js": 135,
	"./ms": 136,
	"./ms-my": 137,
	"./ms-my.js": 137,
	"./ms.js": 136,
	"./mt": 138,
	"./mt.js": 138,
	"./my": 139,
	"./my.js": 139,
	"./nb": 140,
	"./nb.js": 140,
	"./ne": 141,
	"./ne.js": 141,
	"./nl": 142,
	"./nl-be": 143,
	"./nl-be.js": 143,
	"./nl.js": 142,
	"./nn": 144,
	"./nn.js": 144,
	"./oc-lnc": 145,
	"./oc-lnc.js": 145,
	"./pa-in": 146,
	"./pa-in.js": 146,
	"./pl": 147,
	"./pl.js": 147,
	"./pt": 148,
	"./pt-br": 149,
	"./pt-br.js": 149,
	"./pt.js": 148,
	"./ro": 150,
	"./ro.js": 150,
	"./ru": 151,
	"./ru.js": 151,
	"./sd": 152,
	"./sd.js": 152,
	"./se": 153,
	"./se.js": 153,
	"./si": 154,
	"./si.js": 154,
	"./sk": 155,
	"./sk.js": 155,
	"./sl": 156,
	"./sl.js": 156,
	"./sq": 157,
	"./sq.js": 157,
	"./sr": 158,
	"./sr-cyrl": 159,
	"./sr-cyrl.js": 159,
	"./sr.js": 158,
	"./ss": 160,
	"./ss.js": 160,
	"./sv": 161,
	"./sv.js": 161,
	"./sw": 162,
	"./sw.js": 162,
	"./ta": 163,
	"./ta.js": 163,
	"./te": 164,
	"./te.js": 164,
	"./tet": 165,
	"./tet.js": 165,
	"./tg": 166,
	"./tg.js": 166,
	"./th": 167,
	"./th.js": 167,
	"./tk": 168,
	"./tk.js": 168,
	"./tl-ph": 169,
	"./tl-ph.js": 169,
	"./tlh": 170,
	"./tlh.js": 170,
	"./tr": 171,
	"./tr.js": 171,
	"./tzl": 172,
	"./tzl.js": 172,
	"./tzm": 173,
	"./tzm-latn": 174,
	"./tzm-latn.js": 174,
	"./tzm.js": 173,
	"./ug-cn": 175,
	"./ug-cn.js": 175,
	"./uk": 176,
	"./uk.js": 176,
	"./ur": 177,
	"./ur.js": 177,
	"./uz": 178,
	"./uz-latn": 179,
	"./uz-latn.js": 179,
	"./uz.js": 178,
	"./vi": 180,
	"./vi.js": 180,
	"./x-pseudo": 181,
	"./x-pseudo.js": 181,
	"./yo": 182,
	"./yo.js": 182,
	"./zh-cn": 183,
	"./zh-cn.js": 183,
	"./zh-hk": 184,
	"./zh-hk.js": 184,
	"./zh-mo": 185,
	"./zh-mo.js": 185,
	"./zh-tw": 186,
	"./zh-tw.js": 186
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditInvoiceModal_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20681af8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditInvoiceModal_vue__ = __webpack_require__(274);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditInvoiceModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20681af8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditInvoiceModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"editInvoice"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('flash-message',{staticClass:"myCustomClass"}),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Edit Invoice")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","id":"editinvoiceClose","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1),_vm._v(" "),_c('form',[_c('div',{staticClass:"modal-body"},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.brand_id),expression:"invoiceDetails.InvoiceData.brand_id"}],ref:"brand_id",staticClass:"form-control",attrs:{"id":"brand_id","name":"brand_id","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "brand_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeBrand($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("select brand")]),_vm._v(" "),_vm._l((_vm.getBrandsAscendingOrder),function(brand,index,key){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(brand.brand_name))])})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.brand_id),expression:"invoiceDetails.InvoiceData.brand_id"}],ref:"brand_id",staticClass:"form-control",attrs:{"id":"brand_id","name":"brand_id","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "brand_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeBrand($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("select brand")]),_vm._v(" "),_vm._l((_vm.getBrandsAscendingOrder),function(brand,index,key){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(brand.brand_name))])})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.brand_id),expression:"invoiceDetails.InvoiceData.brand_id"}],ref:"brand_id",staticClass:"form-control",attrs:{"id":"brand_id","name":"brand_id"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "brand_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeBrand($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("select brand")]),_vm._v(" "),_vm._l((_vm.getBrandsAscendingOrder),function(brand,index,key){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(brand.brand_name))])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",attrs:{"id":"hidedays"}},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.due_days),expression:"invoiceDetails.InvoiceData.due_days"}],ref:"duedays",staticClass:"form-control",attrs:{"id":"duedays","name":"duedays","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "due_days", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.editchangeDays($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Payment Term*")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Escrow")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("60 days ")])]):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.due_days),expression:"invoiceDetails.InvoiceData.due_days"}],ref:"duedays",staticClass:"form-control",attrs:{"id":"duedays","name":"duedays","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "due_days", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.editchangeDays($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Payment Term*")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Escrow")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("60 days ")])]):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.due_days),expression:"invoiceDetails.InvoiceData.due_days"}],ref:"duedays",staticClass:"form-control",attrs:{"id":"duedays","name":"duedays"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "due_days", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.editchangeDays($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Payment Term*")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Escrow")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("15 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("30 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("45 days ")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("60 days ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",attrs:{"id":""}},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.invoice_type),expression:"invoiceDetails.InvoiceData.invoice_type"}],ref:"invoice_type",staticClass:"form-control",attrs:{"id":"invoice_type","name":"invoice_type","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "invoice_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Invoice Type*")]),_vm._v(" "),_c('option',{attrs:{"value":"immediate"}},[_vm._v("Immediate")]),_vm._v(" "),_c('option',{attrs:{"value":"held"}},[_vm._v("Held")])]):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.invoice_type),expression:"invoiceDetails.InvoiceData.invoice_type"}],ref:"invoice_type",staticClass:"form-control",attrs:{"id":"invoice_type","name":"invoice_type","disabled":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "invoice_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Invoice Type*")]),_vm._v(" "),_c('option',{attrs:{"value":"immediate"}},[_vm._v("Immediate")]),_vm._v(" "),_c('option',{attrs:{"value":"held"}},[_vm._v("Held")])]):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.invoice_type),expression:"invoiceDetails.InvoiceData.invoice_type"}],ref:"invoice_type",staticClass:"form-control",attrs:{"id":"invoice_type","name":"invoice_type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.InvoiceData, "invoice_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Invoice Type*")]),_vm._v(" "),_c('option',{attrs:{"value":"immediate"}},[_vm._v("Immediate")]),_vm._v(" "),_c('option',{attrs:{"value":"held"}},[_vm._v("Held")])]):_vm._e()]),_vm._v(" "),_vm._l((_vm.brands),function(brand,index,key){return _c('div',[(index === _vm.selectedBrand || index === _vm.invoiceDetails.InvoiceData.brand_id)?_c('div',{staticClass:"brand-detail"},[_c('div',{staticClass:"brand-logo"},[_c('img',{attrs:{"src":brand.brand_logo}})]),_vm._v(" "),_c('ul',[_c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("language")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(brand.brand_name))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("mail")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(brand.site_url))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("phone")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(brand.contact_no))])])])]):_vm._e()])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.amount),expression:"invoiceDetails.InvoiceData.amount"}],ref:"amount",staticClass:"form-control",attrs:{"type":"text","id":"amount","name":"amount","placeholder":"Enter Amount","disabled":""},domProps:{"value":(_vm.invoiceDetails.InvoiceData.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.InvoiceData, "amount", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid' )?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.amount),expression:"invoiceDetails.InvoiceData.amount"}],ref:"amount",staticClass:"form-control",attrs:{"type":"text","id":"amount","name":"amount","placeholder":"Enter Amount","disabled":""},domProps:{"value":(_vm.invoiceDetails.InvoiceData.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.InvoiceData, "amount", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.amount),expression:"invoiceDetails.InvoiceData.amount"}],ref:"amount",staticClass:"form-control",attrs:{"type":"text","id":"amount","name":"amount","placeholder":"Enter Amount"},domProps:{"value":(_vm.invoiceDetails.InvoiceData.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.InvoiceData, "amount", $event.target.value)}}}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.uid),expression:"invoiceDetails.InvoiceData.uid"}],staticClass:"form-control",attrs:{"type":"hidden","name":"uid","placeholder":"Invoice Id"},domProps:{"value":(_vm.invoiceDetails.InvoiceData.uid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.InvoiceData, "uid", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.invoice_percentage_id),expression:"invoiceDetails.InvoiceData.invoice_percentage_id"}],staticClass:"form-control",attrs:{"type":"hidden","name":"puid","placeholder":"Invoice Percentage Id"},domProps:{"value":(_vm.invoiceDetails.InvoiceData.invoice_percentage_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.InvoiceData, "invoice_percentage_id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.description),expression:"invoiceDetails.InvoiceData.description"}],ref:"description",staticClass:"form-control",attrs:{"id":"description","name":"description","placeholder":"Description","disabled":""},domProps:{"value":(_vm.invoiceDetails.InvoiceData.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.InvoiceData, "description", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid' )?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.description),expression:"invoiceDetails.InvoiceData.description"}],ref:"description",staticClass:"form-control",attrs:{"id":"description","name":"description","placeholder":"Description","disabled":""},domProps:{"value":(_vm.invoiceDetails.InvoiceData.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.InvoiceData, "description", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.InvoiceData.description),expression:"invoiceDetails.InvoiceData.description"}],ref:"description",staticClass:"form-control",attrs:{"id":"description","name":"description","placeholder":"Description"},domProps:{"value":(_vm.invoiceDetails.InvoiceData.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.InvoiceData, "description", $event.target.value)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.escrowUser_id),expression:"invoiceDetails.invoicePercentageData.escrowUser_id"}],ref:"admin",staticClass:"form-control",attrs:{"id":"admin","name":"admin","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "escrowUser_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeAdmin($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Escrow")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.user_type === 'escrow' && user.role === 'user' && user.status === 'active' && user.platform_payments === 'active')?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid' )?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.escrowUser_id),expression:"invoiceDetails.invoicePercentageData.escrowUser_id"}],ref:"admin",staticClass:"form-control",attrs:{"id":"admin","name":"admin","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "escrowUser_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeAdmin($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Escrow")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.user_type === 'escrow' && user.status === 'active' && user.platform_payments === 'active')?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.escrowUser_id),expression:"invoiceDetails.invoicePercentageData.escrowUser_id"}],ref:"admin",staticClass:"form-control",attrs:{"id":"admin","name":"admin"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "escrowUser_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeAdmin($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Escrow")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.user_type === 'escrow' && user.status === 'active' && user.platform_payments === 'active')?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.escrowUser_percentage),expression:"invoiceDetails.invoicePercentageData.escrowUser_percentage"}],ref:"admin_percentage",staticClass:"form-control",attrs:{"type":"number","id":"admin_percentage","name":"admin_percentage","placeholder":"00.00%"},domProps:{"value":(_vm.invoiceDetails.invoicePercentageData.escrowUser_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.invoicePercentageData, "escrowUser_percentage", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userA_id),expression:"invoiceDetails.invoicePercentageData.userA_id"}],ref:"userA",staticClass:"form-control",attrs:{"id":"userA","name":"userA","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userA_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserFirst($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User A")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active')?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid' )?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userA_id),expression:"invoiceDetails.invoicePercentageData.userA_id"}],ref:"userA",staticClass:"form-control",attrs:{"id":"userA","name":"userA","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userA_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserFirst($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User A")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' &&  user.user_type === 'user' && user.platform_payments === 'active')?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userA_id),expression:"invoiceDetails.invoicePercentageData.userA_id"}],ref:"userA",staticClass:"form-control",attrs:{"id":"userA","name":"userA"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userA_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserFirst($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User A")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active')?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userA_percentage),expression:"invoiceDetails.invoicePercentageData.userA_percentage"}],ref:"userA_percentage",staticClass:"form-control",attrs:{"type":"number","id":"userA_percentage","name":"userA_percentage","placeholder":"00.00%"},domProps:{"value":(_vm.invoiceDetails.invoicePercentageData.userA_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.invoicePercentageData, "userA_percentage", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userB_id),expression:"invoiceDetails.invoicePercentageData.userB_id"}],ref:"userB",staticClass:"form-control",attrs:{"id":"userB","name":"userB","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userB_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserSecond($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User B ")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active' && user.uid !== _vm.selecteduserA )?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userB_id),expression:"invoiceDetails.invoicePercentageData.userB_id"}],ref:"userB",staticClass:"form-control",attrs:{"id":"userB","name":"userB","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userB_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserSecond($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User B ")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active' && user.uid !== _vm.selecteduserA )?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userB_id),expression:"invoiceDetails.invoicePercentageData.userB_id"}],ref:"userB",staticClass:"form-control",attrs:{"id":"userB","name":"userB"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userB_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserSecond($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User B ")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' && user.user_type === 'user' &&  user.platform_payments === 'active' && user.uid !== _vm.selecteduserA )?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userB_percentage),expression:"invoiceDetails.invoicePercentageData.userB_percentage"}],ref:"userB_percentage",staticClass:"form-control",attrs:{"type":"number","id":"userB_percentage","name":"userB_percentage","placeholder":"00.00%"},domProps:{"value":(_vm.invoiceDetails.invoicePercentageData.userB_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.invoicePercentageData, "userB_percentage", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[(_vm.invoiceDetails.InvoiceData.status === 'open')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userC_id),expression:"invoiceDetails.invoicePercentageData.userC_id"}],ref:"userC",staticClass:"form-control",attrs:{"id":"userC","name":"userC","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userC_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserThird($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User C ")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active' && user.uid !== _vm.selecteduserA && user.uid !== _vm.selecteduserB )?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'paid')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userC_id),expression:"invoiceDetails.invoicePercentageData.userC_id"}],ref:"userC",staticClass:"form-control",attrs:{"id":"userC","name":"userC","disabled":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userC_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserThird($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User C ")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active' && user.uid !== _vm.selecteduserA && user.uid !== _vm.selecteduserB )?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userC_id),expression:"invoiceDetails.invoicePercentageData.userC_id"}],ref:"userC",staticClass:"form-control",attrs:{"id":"userC","name":"userC"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invoiceDetails.invoicePercentageData, "userC_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserThird($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("User C ")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.status === 'active' && user.user_type === 'user' &&  user.platform_payments === 'active' && user.uid !== _vm.selecteduserA && user.uid !== _vm.selecteduserB )?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invoiceDetails.invoicePercentageData.userC_percentage),expression:"invoiceDetails.invoicePercentageData.userC_percentage"}],ref:"userC_percentage",staticClass:"form-control",attrs:{"type":"number","id":"userC_percentage","name":"userC_percentage","placeholder":"00.00%"},domProps:{"value":(_vm.invoiceDetails.invoicePercentageData.userC_percentage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invoiceDetails.invoicePercentageData, "userC_percentage", $event.target.value)}}})])])]),_vm._v(" "),_c('i',[_vm._v("The total Split (%) should add up to 100% (Mandatory)")])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.invoiceDetails.InvoiceData.status === 'draft')?_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","id":"editdraft","data-dismiss":"modal"},on:{"click":function($event){return _vm.editdraftInvoice()}}},[_vm._v("Save as Draft")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"editsave"},on:{"click":function($event){return _vm.editsaveInvoice()}}},[_vm._v("Save and Send")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action",attrs:{"id":"action"}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('button',{staticClass:"badge badge-info",on:{"click":function($event){return _vm.invoiceDetail()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])]),_vm._v(" "),(_vm.row.transfer_status !== 'paid' && _vm.row.status !== 'released')?_c('button',{staticClass:"badge badge-secondry editBtn",attrs:{"id":"editBtn tranferEdit"},on:{"click":function($event){return _vm.editInvoice()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("edit")])]):_vm._e(),_vm._v(" "),(_vm.row.status === 'draft')?_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ loader: false, ok: _vm.deleteInvoice, message: 'Do you really want to delete?'}),expression:"{ loader: false, ok: deleteInvoice, message: 'Do you really want to delete?'}"}],staticClass:"badge badge-danger"},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]):_vm._e(),_vm._v(" "),(_vm.row.status === 'paid' && _vm.row.invoice_type === 'held' && _vm.row.manual_payment ==='')?_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ loader: false, ok: _vm.transfer, message: 'Do you really want to release?'}),expression:"{ loader: false, ok: transfer, message: 'Do you really want to release?'}"}],staticClass:"btn btn-primary",attrs:{"id":"transfer"}},[_vm._v("Approve")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn"},[_c('i',{staticClass:"fas fa-file-pdf",on:{"click":function($event){return _vm.download()}}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"row"})],1)])]),_vm._v(" "),_c('div',{attrs:{"id":"createInvoice"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('flash-message',{staticClass:"myCustomClass"}),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Create Invoice")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","id":"invoiceClose","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1),_vm._v(" "),_c('form',[_c('div',{staticClass:"modal-body"},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.brandid),expression:"input.brandid"}],ref:"brandid",staticClass:"form-control",attrs:{"id":"brandid","name":"brandid"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "brandid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeBrand($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Select Brand*")]),_vm._v(" "),_vm._l((_vm.getBrandsAscendingOrder),function(brand,index,key){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(brand.brand_name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.duedays),expression:"input.duedays"}],ref:"duedays",staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "duedays", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeDays($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Payment Term*")]),_vm._v(" "),_vm._l((_vm.duedaysList),function(dueday){return _c('option',{domProps:{"value":dueday.value}},[_vm._v("\n                   \n                      "+_vm._s(dueday.text)+"\n\n                     ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.invoicetype),expression:"input.invoicetype"}],ref:"invoicetype",staticClass:"form-control",attrs:{"id":"immediateHeldSelect","name":"invoicetype"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "invoicetype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.invoiceType($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Invoice Type*")]),_vm._v(" "),_vm._l((_vm.invoicetypeList),function(option){return _c('option',{attrs:{"id":option.id},domProps:{"value":option.value}},[_vm._v("\n                      "+_vm._s(option.text)+"\n\n                     ")])})],2)]),_vm._v(" "),_vm._l((_vm.brands),function(brand,index,key){return _c('div',{attrs:{"id":""}},[(index === _vm.selectedBrand)?_c('div',{staticClass:"brand-detail"},[_c('div',{staticClass:"brand-logo",attrs:{"id":"brand-logo"}},[_c('img',{attrs:{"src":brand.brand_logo}})]),_vm._v(" "),_c('ul',{attrs:{"id":"brandDetail"}},[_c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("language")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(brand.brand_name))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("mail")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(brand.site_url))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"material-icons"},[_vm._v("phone")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(brand.contact_no))])])])]):_vm._e()])})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.amount),expression:"input.amount"}],ref:"amount",staticClass:"form-control",attrs:{"type":"text","id":"amount","name":"amount","placeholder":"Enter Amount*"},domProps:{"value":(_vm.input.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "amount", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.description),expression:"input.description"}],ref:"description",staticClass:"form-control",attrs:{"id":"description","name":"description","placeholder":"Description*"},domProps:{"value":(_vm.input.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.admin),expression:"input.admin"}],ref:"admin",staticClass:"form-control",attrs:{"id":"admin","name":"admin"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "admin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeAdmin($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Select Escrow*")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.user_type === 'escrow' && user.role === 'user' && user.status === 'active' && user.platform_payments === 'active')?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.adminpercent),expression:"input.adminpercent"}],ref:"adminpercent",staticClass:"form-control",attrs:{"type":"number","id":"adminpercent","name":"adminpercent","placeholder":"00.00%*"},domProps:{"value":(_vm.input.adminpercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "adminpercent", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.userA),expression:"input.userA"}],ref:"userA",staticClass:"form-control",attrs:{"id":"userA","name":"userA"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "userA", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserFirst($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("User A*")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.user_type === 'user' && user.status === 'active' && user.platform_payments === 'active')?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.userApercent),expression:"input.userApercent"}],ref:"userApercent",staticClass:"form-control",attrs:{"type":"number","id":"userApercent","name":"userApercent","placeholder":"00.00%*"},domProps:{"value":(_vm.input.userApercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "userApercent", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.userB),expression:"input.userB"}],ref:"userB",staticClass:"form-control",attrs:{"id":"userB","name":"userB"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "userB", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserSecond($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("User B")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.user_type === 'user' && user.status === 'active' && user.platform_payments === 'active' && user.uid !== _vm.selecteduserA )?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.userBpercent),expression:"input.userBpercent"}],ref:"userBpercent",staticClass:"form-control",attrs:{"type":"number","id":"userBpercent","name":"userBpercent","placeholder":"00.00%"},domProps:{"value":(_vm.input.userBpercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "userBpercent", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.userC),expression:"input.userC"}],ref:"userC",staticClass:"form-control",attrs:{"id":"userC","name":"userC"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "userC", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changeUserThird($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("User C")]),_vm._v(" "),_vm._l((_vm.users),function(user,index,key){return (user.role === 'user' && user.user_type === 'user' && user.status === 'active' && user.platform_payments === 'active' && user.uid !== _vm.selecteduserA && user.uid !== _vm.selecteduserB )?_c('option',{domProps:{"value":user.uid}},[_vm._v(_vm._s(user.firstname)+" "+_vm._s(user.lastname)+" <"+_vm._s(user.email)+">")]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.userCpercent),expression:"input.userCpercent"}],ref:"userCpercent",staticClass:"form-control",attrs:{"type":"number","id":"userCpercent","name":"userCpercent","placeholder":"00.00%"},domProps:{"value":(_vm.input.userCpercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "userCpercent", $event.target.value)}}})])])]),_vm._v(" "),_c('i',[_vm._v("The total Split (%) should add up to 100% (Mandatory)")])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","id":"draft","data-dismiss":"modal"},on:{"click":function($event){return _vm.draftInvoice()}}},[_vm._v("Save as Draft")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"save"},on:{"click":function($event){return _vm.saveInvoice()}}},[_vm._v("Save and Send")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card stat-card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Today")]),_vm._v(" "),(_vm.performance.performanceTodayData !== '')?_c('div',[_c('h2',[_vm._v("$"+_vm._s(_vm.performance.performanceTodayData))])]):_vm._e(),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card stat-card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("This Week")]),_vm._v(" "),_c('h2',[_vm._v("$"+_vm._s(_vm.performance.performanceWeekData))]),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card stat-card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("This Month")]),_vm._v(" "),_c('h2',[_vm._v("$"+_vm._s(_vm.performance.performanceMonthData))]),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card stat-card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("All Time")]),_vm._v(" "),_c('h2',[_vm._v("$"+_vm._s(_vm.performance.performanceData))]),_vm._v(" "),_vm._m(5)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("User List")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(6),_vm._v(" "),_c('tbody',_vm._l((_vm.lastUsers),function(lastUser,index,key){return _c('tr',[(lastUser.name)?_c('td',[_vm._v(_vm._s(lastUser.name))]):_c('td',[_vm._v(_vm._s(lastUser.firstname)+" "+_vm._s(lastUser.lastname))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(lastUser.status))])]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'userDetail', params: { userId: index, page: 'dashboard' }}}},[_c('button',{staticClass:"badge badge-info"},[_vm._v("View Details")])])],1)])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("Brand List")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(7),_vm._v(" "),_c('tbody',_vm._l((_vm.lastBrands),function(lastBrand,index,key){return _c('tr',[_c('td',[_vm._v(_vm._s(lastBrand.brand_name))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(lastBrand.status))])]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'brandDetail', params: { brandId: index, page: 'dashboard'}}}},[_c('button',{staticClass:"badge badge-info"},[_vm._v("View Details")])])],1)])}),0)])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v("\n                                    Last Invoices\n                                    "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"invoiceBtn"},on:{"click":function($event){return _vm.adInvoice()}}},[_vm._v("Create Invoice")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(8),_vm._v(" "),_c('tbody',_vm._l((_vm.lastInvoices),function(lastInvoice,index,key){return _c('tr',[(lastInvoice.invoice_number !== '')?_c('td',[_vm._v(_vm._s(lastInvoice.invoice_number))]):_vm._e(),_vm._v(" "),(lastInvoice.invoice_number === '')?_c('td',[_vm._v("#TEMP"+_vm._s(index))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(lastInvoice.brand_name))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'invoiceDetail', params: { invoiceId: lastInvoice.uid, page: 'dashboard'}}}},[_c('button',{staticClass:"badge badge-info"},[_vm._v("View Details")])])],1)])}),0)])])])])]),_vm._v(" "),_vm._m(9)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Dashboard")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Financial Performance")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",staticStyle:{"height":"10px"}},[_c('div',{staticClass:"progress-bar bg-warning",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"45","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",staticStyle:{"height":"10px"}},[_c('div',{staticClass:"progress-bar bg-info",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"60","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",staticStyle:{"height":"10px"}},[_c('div',{staticClass:"progress-bar bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"45","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",staticStyle:{"height":"10px"}},[_c('div',{staticClass:"progress-bar bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"45","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("User Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Brand Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Invoice No.")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Brands")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('flash-message',{attrs:{"id":"flash-message"}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Invoice List")]),_vm._v(" "),_c('div',{staticClass:"search-create"},[_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control mr-sm-2",attrs:{"type":"text","placeholder":"Search Invoice","aria-label":"Search"},domProps:{"value":(_vm.filter)},on:{"keydown":function($event){return $event.stopImmediatePropagation()},"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"invoiceBtn"},on:{"click":function($event){return _vm.adInvoice()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" Add Invoice")])])]),_vm._v(" "),_c('div',{staticClass:"row"})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('datatable',{class:_vm.tblCls,attrs:{"columns":_vm.columns,"filter":_vm.filter,"per-page":10,"data":_vm.invoicesList}}),_vm._v(" "),_c('datatable-pager',{staticClass:"pagination",model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Invoice")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserDashboard_vue__ = __webpack_require__(188);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a882d26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserDashboard_vue__ = __webpack_require__(280);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a882d26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Invoices ")]),_vm._v(" "),_c('div',{staticClass:"search-create"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control mr-sm-2",attrs:{"type":"text","placeholder":"Search invoice","aria-label":"Search"},domProps:{"value":(_vm.filter)},on:{"keydown":function($event){return $event.stopImmediatePropagation()},"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"table-responsive"},[_c('datatable',{class:_vm.tblCls,attrs:{"columns":_vm.columns,"filter":_vm.filter,"per-page":10,"data":_vm.invoicesList}}),_vm._v(" "),_c('datatable-pager',{staticClass:"pagination",model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Dashboard")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBrand_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ffd6898_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBrand_vue__ = __webpack_require__(282);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBrand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ffd6898_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBrand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addBrand"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Add Brand")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1),_vm._v(" "),_c('form',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addBrand()}}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h6',{staticClass:"sub-title"},[_vm._v("Brand Information")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.brandname),expression:"input.brandname"}],ref:"brandname",staticClass:"form-control",attrs:{"type":"text","name":"brandname","placeholder":"Brand Name*"},domProps:{"value":(_vm.input.brandname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "brandname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.siteurl),expression:"input.siteurl"}],ref:"siteurl",staticClass:"form-control",attrs:{"type":"text","name":"siteurl","placeholder":"Site URL*"},domProps:{"value":(_vm.input.siteurl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "siteurl", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.email),expression:"input.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"Email*"},domProps:{"value":(_vm.input.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "email", $event.target.value)}}}),_vm._v(" "),_c('p',{staticClass:"sub-title",staticStyle:{"color":"blue"}},[_vm._v("This is where the invoice will be sent.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.address),expression:"input.address"}],ref:"address",staticClass:"form-control",attrs:{"type":"text","name":"address","placeholder":"Complete Address*"},domProps:{"value":(_vm.input.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.contactno),expression:"input.contactno"}],ref:"contactno",staticClass:"form-control",attrs:{"type":"text","name":"contactno","placeholder":"Contact Number*"},domProps:{"value":(_vm.input.contactno)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "contactno", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{ref:"fileaddBrand",staticClass:"form-control",attrs:{"type":"file","name":"brand_logo","id":"fileaddBrand"},on:{"change":function($event){return _vm.handleFileUpload()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h6',{staticClass:"sub-title"},[_vm._v("Contact Information")]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_c('div',{staticClass:"form-group d-flex"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.nameprefix),expression:"input.nameprefix"}],ref:"nameprefix",staticClass:"form-control select",attrs:{"id":"nameprefix","name":"nameprefix"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.input, "nameprefix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changePrefix($event)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Select Title")]),_vm._v(" "),_c('option',{attrs:{"value":"Mr","selected":""}},[_vm._v("Mr ")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs ")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.contactfirstname),expression:"input.contactfirstname"}],ref:"contactfirstname",staticClass:"form-control",attrs:{"type":"text","name":"contactfirstname","placeholder":"Contact First Name*"},domProps:{"value":(_vm.input.contactfirstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "contactfirstname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.contactlastname),expression:"input.contactlastname"}],ref:"contactlastname",staticClass:"form-control",attrs:{"type":"text","name":"contactlastname","placeholder":"Contact Last Name*"},domProps:{"value":(_vm.input.contactlastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "contactlastname", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.contactemail),expression:"input.contactemail"}],ref:"contactemail",staticClass:"form-control",attrs:{"type":"text","name":"contactemail","placeholder":"Contact Email*"},domProps:{"value":(_vm.input.contactemail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "contactemail", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Add"},on:{"click":function($event){return _vm.addBrand()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")])])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brandAction_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305799b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brandAction_vue__ = __webpack_require__(286);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brandAction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305799b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brandAction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBrandModal_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69fdb820_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBrandModal_vue__ = __webpack_require__(285);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBrandModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69fdb820_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBrandModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"editBrand"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Edit Brand")]),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","id":"editbrandpopupclose","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],2),_vm._v(" "),_c('form',{attrs:{"action":"#"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editBrand()}}},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h6',{staticClass:"sub-title"},[_vm._v("Brand Information")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.brand_name),expression:"brandDetails.brand_name"}],ref:"brand_name",staticClass:"form-control",attrs:{"type":"text","name":"brand_name","placeholder":"Brand Name"},domProps:{"value":(_vm.brandDetails.brand_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "brand_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.site_url),expression:"brandDetails.site_url"}],ref:"site_url",staticClass:"form-control",attrs:{"type":"text","name":"site_url","placeholder":"Site URL"},domProps:{"value":(_vm.brandDetails.site_url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "site_url", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.email),expression:"brandDetails.email"}],ref:"email",staticClass:"form-control",attrs:{"type":"email","name":"email","placeholder":"Email"},domProps:{"value":(_vm.brandDetails.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "email", $event.target.value)}}}),_vm._v(" "),_c('p',{staticClass:"sub-title",staticStyle:{"color":"blue"}},[_vm._v("This is where the invoice will be sent.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.address),expression:"brandDetails.address"}],ref:"address",staticClass:"form-control",attrs:{"type":"text","name":"address","placeholder":"Complete Address"},domProps:{"value":(_vm.brandDetails.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.contact_no),expression:"brandDetails.contact_no"}],ref:"contactno",staticClass:"form-control",attrs:{"type":"text","name":"contactno","placeholder":"Contact Number"},domProps:{"value":(_vm.brandDetails.contact_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "contact_no", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.uid),expression:"brandDetails.uid"}],staticClass:"form-control",attrs:{"type":"hidden","name":"uid","placeholder":"Brand Id"},domProps:{"value":(_vm.brandDetails.uid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "uid", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{ref:"fileedit",staticClass:"form-control",attrs:{"type":"file","name":"brand_logo","id":"fileedit"},on:{"change":function($event){return _vm.handleFileUploadedit()}}}),_vm._v(" "),_c('img',{staticStyle:{"max-height":"100px"},attrs:{"src":_vm.brandDetails.brand_logo}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h6',{staticClass:"sub-title"},[_vm._v("Contact Information")]),_vm._v(" "),_c('div',{staticClass:"form-group"}),_vm._v(" "),_c('div',{staticClass:"form-group d-flex"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.contact_name_prefix),expression:"brandDetails.contact_name_prefix"}],ref:"nameprefix",staticClass:"form-control select",attrs:{"id":"nameprefix","name":"nameprefix"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.brandDetails, "contact_name_prefix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changePrefix($event)}]}},[_c('option',{attrs:{"value":"Mr"}},[_vm._v("Mr. ")]),_vm._v(" "),_c('option',{attrs:{"value":"Mrs"}},[_vm._v("Mrs. ")]),_vm._v(" "),_c('option',{attrs:{"value":"Ms"}},[_vm._v("Ms. ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.contact_first_name),expression:"brandDetails.contact_first_name"}],ref:"contactfirstname",staticClass:"form-control",attrs:{"type":"text","name":"contactfirstname","placeholder":"Contact First name"},domProps:{"value":(_vm.brandDetails.contact_first_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "contact_first_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.contact_last_name),expression:"brandDetails.contact_last_name"}],ref:"contactlastname",staticClass:"form-control",attrs:{"type":"text","name":"contactlastname","placeholder":"Contact Last name"},domProps:{"value":(_vm.brandDetails.contact_last_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "contact_last_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.brandDetails.contact_email),expression:"brandDetails.contact_email"}],ref:"contactemail",staticClass:"form-control",attrs:{"type":"text","name":"contactemail","placeholder":"Contact Email"},domProps:{"value":(_vm.brandDetails.contact_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.brandDetails, "contact_email", $event.target.value)}}})])])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Update"},on:{"click":function($event){return _vm.editBrand()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action",attrs:{"id":"action"}},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('button',{staticClass:"badge badge-info",on:{"click":function($event){return _vm.brandDetail()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("remove_red_eye")])]),_vm._v(" "),_c('button',{staticClass:"badge badge-secondry editBtn",attrs:{"id":"editBtn"},on:{"click":function($event){return _vm.editBrand()}}},[_c('i',{staticClass:"material-icons editBtn"},[_vm._v("edit")])]),_vm._v(" "),_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ loader: false, ok: _vm.deleteBrand, message: 'Do you really want to delete?'}),expression:"{ loader: false, ok: deleteBrand, message: 'Do you really want to delete?'}"}],staticClass:"badge badge-danger"},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('flash-message',{attrs:{"id":"flash-message"}}),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Brands List")]),_vm._v(" "),_c('div',{staticClass:"search-create"},[_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control mr-sm-2",attrs:{"type":"text","placeholder":"Search Brand","aria-label":"Search"},domProps:{"value":(_vm.filter)},on:{"keydown":function($event){return $event.stopImmediatePropagation()},"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"brandBtn"},on:{"click":function($event){return _vm.adbrand()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_vm._v(" Add Brand")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"table-responsive"},[_c('datatable',{ref:"table",class:_vm.tblCls,attrs:{"columns":_vm.columns,"filter":_vm.filter,"per-page":10,"data":_vm.brandsList}}),_vm._v(" "),_c('datatable-pager',{staticClass:"pagination",model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Brands")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(194);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28e8cd14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(289);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28e8cd14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page-title"}),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Payments(Received)")]),_vm._v(" "),_c('div',{staticClass:"search-create"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control mr-sm-2",attrs:{"type":"text","placeholder":"Search payments","aria-label":"Search"},domProps:{"value":(_vm.filter)},on:{"keydown":function($event){return $event.stopImmediatePropagation()},"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"table-responsive"},[_c('datatable',{class:_vm.tblCls,attrs:{"columns":_vm.columns,"filter":_vm.filter,"per-page":5,"data":_vm.paymentList}}),_vm._v(" "),_c('datatable-pager',{staticClass:"pagination",model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Payment")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentUser_vue__ = __webpack_require__(195);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330fc4fb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentUser_vue__ = __webpack_require__(291);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330fc4fb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page-title"}),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Payments")]),_vm._v(" "),_c('div',{staticClass:"search-create"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"form-control mr-sm-2",attrs:{"type":"text","placeholder":"Search payments","aria-label":"Search"},domProps:{"value":(_vm.filter)},on:{"keydown":function($event){return $event.stopImmediatePropagation()},"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"table-responsive"},[_c('datatable',{class:_vm.tblCls,attrs:{"columns":_vm.columns,"filter":_vm.filter,"per-page":5,"data":_vm.paymentList}}),_vm._v(" "),_c('datatable-pager',{staticClass:"pagination",model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Payment")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceDetail_vue__ = __webpack_require__(196);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba89458_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceDetail_vue__ = __webpack_require__(294);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba89458_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"row"})],1)])]),_vm._v(" "),_c('div',{attrs:{"id":"createInvoice"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Change Invoice Status")]),_c('br'),_c('br'),_vm._v(" "),_c('flash-message',{staticClass:"myCustomClass"}),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","id":"invoiceClose","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])],1),_vm._v(" "),_c('form',[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.status),expression:"input.status"}],ref:"status",attrs:{"type":"radio","id":"paid","name":"status","value":"paid"},domProps:{"checked":_vm._q(_vm.input.status,"paid")},on:{"change":function($event){return _vm.$set(_vm.input, "status", "paid")}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Paid ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.status),expression:"input.status"}],ref:"status",attrs:{"type":"radio","id":"void","name":"status","value":"void"},domProps:{"checked":_vm._q(_vm.input.status,"void")},on:{"change":function($event){return _vm.$set(_vm.input, "status", "void")}}}),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Void ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.note),expression:"input.note"}],ref:"description",staticClass:"form-control",attrs:{"id":"description","name":"description","placeholder":"Add Note"},domProps:{"value":(_vm.input.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "note", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"save"},on:{"click":function($event){return _vm.saveInvoice()}}},[_vm._v("Submit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Cancel")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('flash-message',{attrs:{"id":"flash-message"}}),_vm._v(" "),_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/invoice"}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Invoice")])])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Invoice Detail")])])]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Invoices")]),_vm._v(" "),(_vm.currentPage === 'dashboard')?_c('div',{staticClass:"search-create"},[_c('router-link',{attrs:{"to":"/admindashboard"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"id":"invoiceBtn"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")]),_vm._v("\n                                    Back to Dashboard\n                                ")])])],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'invoicelistpage')?_c('div',{staticClass:"search-create"},[_c('router-link',{attrs:{"to":"/invoice"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"id":"invoiceBtn"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")]),_vm._v("\n                                    Back to Invoice List\n                                ")])])],1):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.invoiceDatas.InvoiceData.status ==='open')?_c('button',{staticClass:"btn btn-primary",attrs:{"id":"invoiceBtn"},on:{"click":function($event){return _vm.changeInvoiceStatus()}}},[_vm._v(" Change Invoice Status")]):_vm._e(),_vm._v("    "),(_vm.invoiceDatas.invoice_pdf !=='')?_c('button',{staticClass:"btn btn-primary",attrs:{"id":"invoiceBtn"},on:{"click":function($event){return _vm.downloadStripePdf()}}},[_vm._v(" Download Stripe PDF")]):_vm._e(),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"card invoice-detail"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Billed To :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.BrandData.brand_name))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Name :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.BrandData.brand_name))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Address :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.BrandData.address))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Phone Number :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.BrandData.contact_no))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Currency :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.currency))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Due Date :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.due_date))])]),_vm._v(" "),(_vm.invoiceDatas.InvoiceData.note)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Note :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.InvoiceData.note))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Invoice No :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.invoice_number ? _vm.invoiceDatas.invoice_number : _vm.TEMP))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Escrow ("+_vm._s(_vm.invoiceDatas.escrowUser.firstname)+" "+_vm._s(_vm.invoiceDatas.escrowUser.lastname)+" "+_vm._s(_vm.invoiceDatas.escrowUser.email)+")  Split:\n                                            ")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.invoicePercentageData.escrowUser_percentage)+"%")]),_vm._v(" "),(_vm.invoiceDatas.InvoiceData.status === 'released')?_c('span',[_vm._v(" ($"+_vm._s(_vm.grossAdmin)+")")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("User A ("+_vm._s(_vm.invoiceDatas.userA.firstname)+" "+_vm._s(_vm.invoiceDatas.userA.lastname)+" "+_vm._s(_vm.invoiceDatas.userA.email)+")  Split:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.invoicePercentageData.userA_percentage)+"% \n                                            ")]),(_vm.invoiceDatas.InvoiceData.status === 'released')?_c('span',[_vm._v("($"+_vm._s(_vm.grossUserA)+")")]):_vm._e()]),_vm._v(" "),(_vm.invoiceDatas.userB.firstname)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("User B ("+_vm._s(_vm.invoiceDatas.userB.firstname)+" "+_vm._s(_vm.invoiceDatas.userB.lastname)+" "+_vm._s(_vm.invoiceDatas.userB.email)+") Split:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.invoicePercentageData.userB_percentage)+"% \n                                            ")]),_vm._v(" "),(_vm.invoiceDatas.InvoiceData.status === 'released')?_c('span',[_vm._v("($"+_vm._s(_vm.grossUserB)+")")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.invoiceDatas.userC.firstname)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("User C ("+_vm._s(_vm.invoiceDatas.userC.firstname)+" "+_vm._s(_vm.invoiceDatas.userC.lastname)+" "+_vm._s(_vm.invoiceDatas.userC.email)+") Split:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.invoiceDatas.invoicePercentageData.userC_percentage)+"% \n                                            ")]),_vm._v(" "),(_vm.invoiceDatas.InvoiceData.status === 'released')?_c('span',[_vm._v("($"+_vm._s(_vm.grossUserC)+")")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.invoiceDatas.InvoiceData.description))]),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s((_vm.invoiceDatas.InvoiceData.amount)))]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s((_vm.invoiceDatas.InvoiceData.amount)))])]),_vm._v(" "),(_vm.invoiceDatas.InvoiceData.status === 'paid' || _vm.invoiceDatas.InvoiceData.status === 'released')?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Stripe Fees")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(_vm.invoiceDatas.stripe_fee))])]):_vm._e(),_vm._v(" "),(_vm.invoiceDatas.InvoiceData.status === 'paid' || _vm.invoiceDatas.InvoiceData.status === 'released')?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Net Amount")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s((_vm.invoiceDatas.net_amount)))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Gross Amount")]),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s((_vm.invoiceDatas.InvoiceData.amount)))])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Billing Method :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("Send Invoice")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Description")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Unit Price")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Amount")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentDetail_vue__ = __webpack_require__(199);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c33d3b8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentDetail_vue__ = __webpack_require__(296);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c33d3b8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Invoices")]),_vm._v(" "),_c('div',{staticClass:"search-create"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/payment"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")]),_vm._v("\n                                    Back to Payment List\n                                ")])],1)])])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Payment")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("000001")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card invoice-detail"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Billed To :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("Adidas")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Name :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("No Name")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Address :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("No Name")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Phone Number :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("No Phone Number")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Currency :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("CAD - Canadian Dollar")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Invoice No :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("000001")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Billing Method :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("Send Invoice")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Ghost Profit :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("34%")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("User A Profit :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("33%")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("User B Profit :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("33%")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Description")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Unit Price")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Amount")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry.")]),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("CA$ 1,000.00")]),_vm._v(" "),_c('td',[_vm._v("CA$ 1,000.00")])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Sub Total")]),_vm._v(" "),_c('td',[_vm._v("CA$ 1,000.00")])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Total")]),_vm._v(" "),_c('td',[_vm._v("CA$ 1,000.00")])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Due Amount")]),_vm._v(" "),_c('td',[_vm._v("CA$ 1,000.00")])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brandDetail_vue__ = __webpack_require__(200);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137ee4f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brandDetail_vue__ = __webpack_require__(298);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_brandDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137ee4f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_brandDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/brands"}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Brands")])])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("Brand Name")])])]),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("Brand detail")]),_vm._v(" "),(_vm.currentPage === 'dashboard')?_c('div',{staticClass:"search-create"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/admindashboard"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")]),_vm._v("\n              Back to Dashboard\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'brandlist')?_c('div',{staticClass:"search-create"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/brands"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")]),_vm._v("\n              Back to Brand List\n            ")])],1):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body "},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"brand-detail"},[_c('div',{staticClass:"brand-img"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.brandDetails.brand_logo}})]),_vm._v(" "),_c('ul',[_c('li',[_c('label',[_vm._v("Brand Name")]),_c('span',[_vm._v(_vm._s(_vm.brandDetails.brand_name))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v("Site URL")]),_c('a',{attrs:{"href":_vm.brandDetails.site_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.brandDetails.site_url))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v("Email")]),_c('a',{attrs:{"href":"mailto:info@adidas.com","target":"_blank"}},[_vm._v(_vm._s(_vm.brandDetails.email))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v("Contact")]),_c('span',[_vm._v(_vm._s(_vm.brandDetails.contact_no))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v("Address")]),_c('span',[_vm._v(_vm._s(_vm.brandDetails.address))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v("Contact Name")]),_c('span',[_vm._v(_vm._s(_vm.brandDetails.contact_name_prefix + '.' + ' ' + _vm.brandDetails.contact_first_name + ' ' + _vm.brandDetails.contact_last_name))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v("Contact Email")]),_c('span',[_vm._v(_vm._s(_vm.brandDetails.contact_email))])])])])])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userDetail_vue__ = __webpack_require__(201);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc47528_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userDetail_vue__ = __webpack_require__(300);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc47528_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"on-cancel":_vm.onCancel,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb breadcrumb-separator-1"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/user"}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Users")])])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("User Name")])])]),_vm._v(" "),_c('div',{staticClass:"page-title"},[_c('h3',[_vm._v("User Name")]),_vm._v(" "),(_vm.currentPage === 'dashboard')?_c('div',{staticClass:"search-create",attrs:{"id":"backbtn"}},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/admindashboard"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")]),_vm._v("\n              Back to Dashboard\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.currentPage === 'userlistpage')?_c('div',{staticClass:"search-create"},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/user"}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")]),_vm._v("\n              Back to User List\n            ")])],1):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"row "},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row mb-50"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("User ID :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.userDetails.user.uid))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Email :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.userDetails.user.email))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Status :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.userDetails.user.status))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Name :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.userDetails.user.firstname)+" "+_vm._s(_vm.userDetails.user.lastname))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("User Type :")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.userDetails.user.user_type))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('table',{staticClass:"table"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.invoiceDetails),function(invoiceDetail,index,key){return _c('tr',[(invoiceDetail.stripe_invoice_id === '')?_c('td',[_vm._v("#TEMP000"+_vm._s(index))]):_vm._e(),_vm._v(" "),(invoiceDetail.stripe_invoice_id !== '')?_c('td',[_vm._v(_vm._s(invoiceDetail.invoice_number))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v("$"+_vm._s(invoiceDetail.amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoiceDetail.brand_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoiceDetail.admin_percentage)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoiceDetail.userA_percentage)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoiceDetail.userB_percentage)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoiceDetail.userC_percentage)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoiceDetail.status))])])}),0)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"}),_vm._v(" "),_c('span',{staticClass:"value"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('h5',[_vm._v("Assigned invoice")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Invoice ID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Payment")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Brand")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Ghost")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("User A")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("User B")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("User C")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Status")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270ce647_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__ = __webpack_require__(308);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Default_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270ce647_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderMain_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36448d5c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderMain_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36448d5c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-header"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('section',{staticClass:"material-design-hamburger navigation-toggle",attrs:{"id":"navigation-toggle1"},on:{"click":function($event){return _vm.toggle()}}},[_vm._m(0)]),_vm._v(" "),_c('section',{staticClass:"material-design-hamburger navigation-toggle2",attrs:{"id":"navigation-toggle2"},on:{"click":function($event){return _vm.toggle1()}}},[_vm._m(1)]),_vm._v(" "),_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('img',{attrs:{"src":_vm.siteLogo}})]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",attrs:{"id":"navbarSupportedContenttrue","type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent","aria-controls":"navbarSupportedContent","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":function($event){return _vm.toggleopen()}}},[_c('i',{staticClass:"material-icons key_arrow"},[_vm._v("keyboard_arrow_down")])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent"}},[(_vm.isAdmin)?_c('div',[_c('form',{staticClass:"form-inline my-2 my-lg-0 search",attrs:{"id":"search","action":"/searchData"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input.search),expression:"input.search"}],staticClass:"form-control mr-sm-2",attrs:{"type":"search","name":"text","id":"txt-search","placeholder":"Search for projects, apps, pages...","aria-label":"Search"},domProps:{"value":(_vm.input.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchData()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.input, "search", $event.target.value)}}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Search"},on:{"click":function($event){return _vm.searchData()}}})])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto",attrs:{"id":"parent-list"}},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"id":"avatarBtn","href":"#"}},[_c('div',{staticClass:"username"},[(_vm.profImage !== '')?_c('img',{attrs:{"src":_vm.profImage}}):_c('img',{attrs:{"src":__webpack_require__(305)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.ghostuserName))])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item dropdown",attrs:{"id":"dropdownAdd"}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"id":"addtrue","href":"#","role":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":function($event){return _vm.menuopen()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-right",attrs:{"id":"menushow"}},[(_vm.isAdmin)?_c('li',[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/adminprofile"}},[_vm._v("Profile")])],1):_vm._e(),_vm._v(" "),(_vm.isUser)?_c('li',[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/userprofile"}},[_vm._v("Profile")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('li',[_c('router-link',{staticClass:"dropdown-item",attrs:{"to":"/account-setting"}},[_vm._v("Account Setting")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Log Out")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"updateavatar"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('flash-message',{staticClass:"myCustomClass"}),_vm._v(" "),_c('h5',{staticClass:"modal-title",attrs:{"id":"exampleModalLabel"}},[_vm._v("Change Avatar")]),_vm._v(" "),_vm._m(2)],1),_vm._v(" "),_c('form',{attrs:{"id":"myForm","action":"#"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.update()}}},[_c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),(_vm.errors.length)?_c('p'):_vm._e(),_vm._l((_vm.errors),function(error){return _c('p',{staticStyle:{"color":"red","text-align":"center"}},[_vm._v(" "+_vm._s(error))])}),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.profImage}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{ref:"fileadd",staticClass:"form-control",attrs:{"type":"file","name":"ghost_logo","id":"fileadd"},on:{"change":function($event){return _vm.handleFileUpload()}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Save"},on:{"click":function($event){return _vm.update()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.avtarpopupclose()}}},[_vm._v("Cancel")])])],2)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-collapse material-design-hamburger__icon",attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"material-design-hamburger__layer"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-collapse material-design-hamburger__icon ",attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"material-design-hamburger__layer material-design-hamburger__icon--to-arrow"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.7cc7a63.png";

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterMain_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd0e21c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterMain_vue__ = __webpack_require__(307);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd0e21c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lime-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"footer-text"},[_vm._v("2020 © Ghost Inc.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('nav-bar'),_vm._v(" "),_c('side-bar'),_vm._v(" "),_c('div',{staticClass:"lime-container"},[_vm._t("default"),_vm._v(" "),_c('footer-bar')],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginLayout_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59866aaa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginLayout_vue__ = __webpack_require__(310);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59866aaa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[206]);


// WEBPACK FOOTER //
// static/js/app.58c1636695068a861fb9.js